//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Login
     * @return Successful Response
     */
    login_auth_login_post(body: UserLogin, cancelToken?: CancelToken): Promise<AccessTokenOut> {
        let url_ = this.baseUrl + "/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin_auth_login_post(_response);
        });
    }

    protected processLogin_auth_login_post(response: AxiosResponse): Promise<AccessTokenOut> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessTokenOut.fromJS(resultData200);
            return Promise.resolve<AccessTokenOut>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessTokenOut>(null as any);
    }

    /**
     * Refresh Token
     * @return Successful Response
     */
    refresh_token_auth_refresh_post( cancelToken?: CancelToken): Promise<AccessTokenOut> {
        let url_ = this.baseUrl + "/auth/refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefresh_token_auth_refresh_post(_response);
        });
    }

    protected processRefresh_token_auth_refresh_post(response: AxiosResponse): Promise<AccessTokenOut> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessTokenOut.fromJS(resultData200);
            return Promise.resolve<AccessTokenOut>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessTokenOut>(null as any);
    }

    /**
     * Forgot Password
     * @return Successful Response
     */
    forgot_password_auth_forgot_password_post(body: ForgotPasswordRequest, cancelToken?: CancelToken): Promise<MessageResponse> {
        let url_ = this.baseUrl + "/auth/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgot_password_auth_forgot_password_post(_response);
        });
    }

    protected processForgot_password_auth_forgot_password_post(response: AxiosResponse): Promise<MessageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageResponse.fromJS(resultData200);
            return Promise.resolve<MessageResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponse>(null as any);
    }

    /**
     * Reset Password
     * @return Successful Response
     */
    reset_password_auth_reset_password_post(body: ResetPasswordRequest, cancelToken?: CancelToken): Promise<MessageResponse> {
        let url_ = this.baseUrl + "/auth/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReset_password_auth_reset_password_post(_response);
        });
    }

    protected processReset_password_auth_reset_password_post(response: AxiosResponse): Promise<MessageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageResponse.fromJS(resultData200);
            return Promise.resolve<MessageResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponse>(null as any);
    }

    /**
     * Logout
     * @return Successful Response
     */
    logout_auth_logout_post( cancelToken?: CancelToken): Promise<MessageResponse> {
        let url_ = this.baseUrl + "/auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout_auth_logout_post(_response);
        });
    }

    protected processLogout_auth_logout_post(response: AxiosResponse): Promise<MessageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageResponse.fromJS(resultData200);
            return Promise.resolve<MessageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponse>(null as any);
    }

    /**
     * Get Me
     * @return Successful Response
     */
    get_me_auth_me_get( cancelToken?: CancelToken): Promise<UserOut> {
        let url_ = this.baseUrl + "/auth/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_me_auth_me_get(_response);
        });
    }

    protected processGet_me_auth_me_get(response: AxiosResponse): Promise<UserOut> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserOut.fromJS(resultData200);
            return Promise.resolve<UserOut>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOut>(null as any);
    }

    /**
     * Get Invite Info
     * @return Successful Response
     */
    get_invite_info_auth_invite_get(token: string, cancelToken?: CancelToken): Promise<InviteInfoOut> {
        let url_ = this.baseUrl + "/auth/invite?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_invite_info_auth_invite_get(_response);
        });
    }

    protected processGet_invite_info_auth_invite_get(response: AxiosResponse): Promise<InviteInfoOut> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InviteInfoOut.fromJS(resultData200);
            return Promise.resolve<InviteInfoOut>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InviteInfoOut>(null as any);
    }

    /**
     * Accept Invite
     * @return Successful Response
     */
    accept_invite_auth_invite_post(body: AcceptInviteRequest, cancelToken?: CancelToken): Promise<UserOut> {
        let url_ = this.baseUrl + "/auth/invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccept_invite_auth_invite_post(_response);
        });
    }

    protected processAccept_invite_auth_invite_post(response: AxiosResponse): Promise<UserOut> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = UserOut.fromJS(resultData201);
            return Promise.resolve<UserOut>(result201);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOut>(null as any);
    }

    /**
     * Invite User
     * @return Successful Response
     */
    invite_user_auth_invite_user_post(body: InviteRequest, cancelToken?: CancelToken): Promise<MessageResponse> {
        let url_ = this.baseUrl + "/auth/invite-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvite_user_auth_invite_user_post(_response);
        });
    }

    protected processInvite_user_auth_invite_user_post(response: AxiosResponse): Promise<MessageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
            result202 = MessageResponse.fromJS(resultData202);
            return Promise.resolve<MessageResponse>(result202);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponse>(null as any);
    }

    /**
     * Change Password
     * @return Successful Response
     */
    change_password_auth_change_password_post(body: ChangePasswordRequest, cancelToken?: CancelToken): Promise<MessageResponse> {
        let url_ = this.baseUrl + "/auth/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChange_password_auth_change_password_post(_response);
        });
    }

    protected processChange_password_auth_change_password_post(response: AxiosResponse): Promise<MessageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageResponse.fromJS(resultData200);
            return Promise.resolve<MessageResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponse>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_api_logs__get( cancelToken?: CancelToken): Promise<APILogReadDTO[]> {
        let url_ = this.baseUrl + "/api-logs/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_api_logs__get(_response);
        });
    }

    protected processList_items_api_logs__get(response: AxiosResponse): Promise<APILogReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(APILogReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<APILogReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APILogReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_api_logs__post(body: APILogCreateDTO, cancelToken?: CancelToken): Promise<APILogReadDTO> {
        let url_ = this.baseUrl + "/api-logs/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_api_logs__post(_response);
        });
    }

    protected processCreate_item_api_logs__post(response: AxiosResponse): Promise<APILogReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APILogReadDTO.fromJS(resultData200);
            return Promise.resolve<APILogReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APILogReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_api_logs__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<APILogReadDTO> {
        let url_ = this.baseUrl + "/api-logs/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_api_logs__item_id__get(_response);
        });
    }

    protected processGet_item_api_logs__item_id__get(response: AxiosResponse): Promise<APILogReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APILogReadDTO.fromJS(resultData200);
            return Promise.resolve<APILogReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APILogReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_api_logs__item_id__put(item_id: string, body: APILogCreateDTO, cancelToken?: CancelToken): Promise<APILogReadDTO> {
        let url_ = this.baseUrl + "/api-logs/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_api_logs__item_id__put(_response);
        });
    }

    protected processUpdate_item_api_logs__item_id__put(response: AxiosResponse): Promise<APILogReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APILogReadDTO.fromJS(resultData200);
            return Promise.resolve<APILogReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APILogReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_api_logs__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/api-logs/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_api_logs__item_id__delete(_response);
        });
    }

    protected processDelete_item_api_logs__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_census_code_a__get( cancelToken?: CancelToken): Promise<CensusCodeAReadDTO[]> {
        let url_ = this.baseUrl + "/census-code-a/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_census_code_a__get(_response);
        });
    }

    protected processList_items_census_code_a__get(response: AxiosResponse): Promise<CensusCodeAReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CensusCodeAReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CensusCodeAReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCodeAReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_census_code_a__post(body: CensusCodeACreateDTO, cancelToken?: CancelToken): Promise<CensusCodeAReadDTO> {
        let url_ = this.baseUrl + "/census-code-a/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_census_code_a__post(_response);
        });
    }

    protected processCreate_item_census_code_a__post(response: AxiosResponse): Promise<CensusCodeAReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CensusCodeAReadDTO.fromJS(resultData200);
            return Promise.resolve<CensusCodeAReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCodeAReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_census_code_a__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<CensusCodeAReadDTO> {
        let url_ = this.baseUrl + "/census-code-a/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_census_code_a__item_id__get(_response);
        });
    }

    protected processGet_item_census_code_a__item_id__get(response: AxiosResponse): Promise<CensusCodeAReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CensusCodeAReadDTO.fromJS(resultData200);
            return Promise.resolve<CensusCodeAReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCodeAReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_census_code_a__item_id__put(item_id: string, body: CensusCodeACreateDTO, cancelToken?: CancelToken): Promise<CensusCodeAReadDTO> {
        let url_ = this.baseUrl + "/census-code-a/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_census_code_a__item_id__put(_response);
        });
    }

    protected processUpdate_item_census_code_a__item_id__put(response: AxiosResponse): Promise<CensusCodeAReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CensusCodeAReadDTO.fromJS(resultData200);
            return Promise.resolve<CensusCodeAReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCodeAReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_census_code_a__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/census-code-a/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_census_code_a__item_id__delete(_response);
        });
    }

    protected processDelete_item_census_code_a__item_id__delete(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Search By Vector Id
     * @return Successful Response
     */
    search_by_vector_id_census_code_a_search_by_vector_id__vector_id__get(vector_id: string, cancelToken?: CancelToken): Promise<CensusCodeAReadDTO[]> {
        let url_ = this.baseUrl + "/census-code-a/search_by_vector_id/{vector_id}";
        if (vector_id === undefined || vector_id === null)
            throw new Error("The parameter 'vector_id' must be defined.");
        url_ = url_.replace("{vector_id}", encodeURIComponent("" + vector_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_vector_id_census_code_a_search_by_vector_id__vector_id__get(_response);
        });
    }

    protected processSearch_by_vector_id_census_code_a_search_by_vector_id__vector_id__get(response: AxiosResponse): Promise<CensusCodeAReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CensusCodeAReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CensusCodeAReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCodeAReadDTO[]>(null as any);
    }

    /**
     * Export Excel
     * @return Successful Response
     */
    export_excel_census_code_a_export_excel__vector_id__get(vector_id: string, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/census-code-a/export_excel/{vector_id}";
        if (vector_id === undefined || vector_id === null)
            throw new Error("The parameter 'vector_id' must be defined.");
        url_ = url_.replace("{vector_id}", encodeURIComponent("" + vector_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport_excel_census_code_a_export_excel__vector_id__get(_response);
        });
    }

    protected processExport_excel_census_code_a_export_excel__vector_id__get(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Import Excel
     * @param file (optional) 
     * @return Successful Response
     */
    import_excel_census_code_a_import_excel__vector_id__post(vector_id: string, file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/census-code-a/import_excel/{vector_id}";
        if (vector_id === undefined || vector_id === null)
            throw new Error("The parameter 'vector_id' must be defined.");
        url_ = url_.replace("{vector_id}", encodeURIComponent("" + vector_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport_excel_census_code_a_import_excel__vector_id__post(_response);
        });
    }

    protected processImport_excel_census_code_a_import_excel__vector_id__post(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Recalculate Percentage And Cost For Diagnosis
     * @return Successful Response
     */
    recalculate_percentage_and_cost_for_diagnosis_census_code_a_recalculate_percentage_and_cost_for_diagnosis__diagnosis_id__post(diagnosis_id: string, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/census-code-a/recalculate-percentage-and-cost-for-diagnosis/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecalculate_percentage_and_cost_for_diagnosis_census_code_a_recalculate_percentage_and_cost_for_diagnosis__diagnosis_id__post(_response);
        });
    }

    protected processRecalculate_percentage_and_cost_for_diagnosis_census_code_a_recalculate_percentage_and_cost_for_diagnosis__diagnosis_id__post(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_census_code_b__get( cancelToken?: CancelToken): Promise<CensusCodeBReadDTO[]> {
        let url_ = this.baseUrl + "/census-code-b/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_census_code_b__get(_response);
        });
    }

    protected processList_items_census_code_b__get(response: AxiosResponse): Promise<CensusCodeBReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CensusCodeBReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CensusCodeBReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCodeBReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_census_code_b__post(body: CensusCodeBCreateDTO, cancelToken?: CancelToken): Promise<CensusCodeBReadDTO> {
        let url_ = this.baseUrl + "/census-code-b/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_census_code_b__post(_response);
        });
    }

    protected processCreate_item_census_code_b__post(response: AxiosResponse): Promise<CensusCodeBReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CensusCodeBReadDTO.fromJS(resultData200);
            return Promise.resolve<CensusCodeBReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCodeBReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_census_code_b__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<CensusCodeBReadDTO> {
        let url_ = this.baseUrl + "/census-code-b/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_census_code_b__item_id__get(_response);
        });
    }

    protected processGet_item_census_code_b__item_id__get(response: AxiosResponse): Promise<CensusCodeBReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CensusCodeBReadDTO.fromJS(resultData200);
            return Promise.resolve<CensusCodeBReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCodeBReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_census_code_b__item_id__put(item_id: string, body: CensusCodeBCreateDTO, cancelToken?: CancelToken): Promise<CensusCodeBReadDTO> {
        let url_ = this.baseUrl + "/census-code-b/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_census_code_b__item_id__put(_response);
        });
    }

    protected processUpdate_item_census_code_b__item_id__put(response: AxiosResponse): Promise<CensusCodeBReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CensusCodeBReadDTO.fromJS(resultData200);
            return Promise.resolve<CensusCodeBReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCodeBReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_census_code_b__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/census-code-b/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_census_code_b__item_id__delete(_response);
        });
    }

    protected processDelete_item_census_code_b__item_id__delete(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Search By Vector Id
     * @return Successful Response
     */
    search_by_vector_id_census_code_b_search_by_vector_id__vector_id__get(vector_id: string, cancelToken?: CancelToken): Promise<CensusCodeBReadDTO[]> {
        let url_ = this.baseUrl + "/census-code-b/search_by_vector_id/{vector_id}";
        if (vector_id === undefined || vector_id === null)
            throw new Error("The parameter 'vector_id' must be defined.");
        url_ = url_.replace("{vector_id}", encodeURIComponent("" + vector_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_vector_id_census_code_b_search_by_vector_id__vector_id__get(_response);
        });
    }

    protected processSearch_by_vector_id_census_code_b_search_by_vector_id__vector_id__get(response: AxiosResponse): Promise<CensusCodeBReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CensusCodeBReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CensusCodeBReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCodeBReadDTO[]>(null as any);
    }

    /**
     * Export Excel
     * @return Successful Response
     */
    export_excel_census_code_b_export_excel__vector_id__get(vector_id: string, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/census-code-b/export_excel/{vector_id}";
        if (vector_id === undefined || vector_id === null)
            throw new Error("The parameter 'vector_id' must be defined.");
        url_ = url_.replace("{vector_id}", encodeURIComponent("" + vector_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport_excel_census_code_b_export_excel__vector_id__get(_response);
        });
    }

    protected processExport_excel_census_code_b_export_excel__vector_id__get(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Import Excel
     * @param file (optional) 
     * @return Successful Response
     */
    import_excel_census_code_b_import_excel__vector_id__post(vector_id: string, file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/census-code-b/import_excel/{vector_id}";
        if (vector_id === undefined || vector_id === null)
            throw new Error("The parameter 'vector_id' must be defined.");
        url_ = url_.replace("{vector_id}", encodeURIComponent("" + vector_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport_excel_census_code_b_import_excel__vector_id__post(_response);
        });
    }

    protected processImport_excel_census_code_b_import_excel__vector_id__post(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_census_code_c__get( cancelToken?: CancelToken): Promise<CensusCodeCReadDTO[]> {
        let url_ = this.baseUrl + "/census-code-c/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_census_code_c__get(_response);
        });
    }

    protected processList_items_census_code_c__get(response: AxiosResponse): Promise<CensusCodeCReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CensusCodeCReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CensusCodeCReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCodeCReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_census_code_c__post(body: CensusCodeCCreateDTO, cancelToken?: CancelToken): Promise<CensusCodeCReadDTO> {
        let url_ = this.baseUrl + "/census-code-c/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_census_code_c__post(_response);
        });
    }

    protected processCreate_item_census_code_c__post(response: AxiosResponse): Promise<CensusCodeCReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CensusCodeCReadDTO.fromJS(resultData200);
            return Promise.resolve<CensusCodeCReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCodeCReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_census_code_c__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<CensusCodeCReadDTO> {
        let url_ = this.baseUrl + "/census-code-c/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_census_code_c__item_id__get(_response);
        });
    }

    protected processGet_item_census_code_c__item_id__get(response: AxiosResponse): Promise<CensusCodeCReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CensusCodeCReadDTO.fromJS(resultData200);
            return Promise.resolve<CensusCodeCReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCodeCReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_census_code_c__item_id__put(item_id: string, body: CensusCodeCCreateDTO, cancelToken?: CancelToken): Promise<CensusCodeCReadDTO> {
        let url_ = this.baseUrl + "/census-code-c/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_census_code_c__item_id__put(_response);
        });
    }

    protected processUpdate_item_census_code_c__item_id__put(response: AxiosResponse): Promise<CensusCodeCReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CensusCodeCReadDTO.fromJS(resultData200);
            return Promise.resolve<CensusCodeCReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCodeCReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_census_code_c__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/census-code-c/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_census_code_c__item_id__delete(_response);
        });
    }

    protected processDelete_item_census_code_c__item_id__delete(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Search By Vector Id
     * @return Successful Response
     */
    search_by_vector_id_census_code_c_search_by_vector_id__vector_id__get(vector_id: string, cancelToken?: CancelToken): Promise<CensusCodeCReadDTO[]> {
        let url_ = this.baseUrl + "/census-code-c/search_by_vector_id/{vector_id}";
        if (vector_id === undefined || vector_id === null)
            throw new Error("The parameter 'vector_id' must be defined.");
        url_ = url_.replace("{vector_id}", encodeURIComponent("" + vector_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_vector_id_census_code_c_search_by_vector_id__vector_id__get(_response);
        });
    }

    protected processSearch_by_vector_id_census_code_c_search_by_vector_id__vector_id__get(response: AxiosResponse): Promise<CensusCodeCReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CensusCodeCReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CensusCodeCReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCodeCReadDTO[]>(null as any);
    }

    /**
     * Export Excel
     * @return Successful Response
     */
    export_excel_census_code_c_export_excel__vector_id__get(vector_id: string, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/census-code-c/export_excel/{vector_id}";
        if (vector_id === undefined || vector_id === null)
            throw new Error("The parameter 'vector_id' must be defined.");
        url_ = url_.replace("{vector_id}", encodeURIComponent("" + vector_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport_excel_census_code_c_export_excel__vector_id__get(_response);
        });
    }

    protected processExport_excel_census_code_c_export_excel__vector_id__get(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Import Excel
     * @param file (optional) 
     * @return Successful Response
     */
    import_excel_census_code_c_import_excel__vector_id__post(vector_id: string, file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/census-code-c/import_excel/{vector_id}";
        if (vector_id === undefined || vector_id === null)
            throw new Error("The parameter 'vector_id' must be defined.");
        url_ = url_.replace("{vector_id}", encodeURIComponent("" + vector_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport_excel_census_code_c_import_excel__vector_id__post(_response);
        });
    }

    protected processImport_excel_census_code_c_import_excel__vector_id__post(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_census_common_data__get( cancelToken?: CancelToken): Promise<CensusCommonDataReadDTO[]> {
        let url_ = this.baseUrl + "/census-common-data/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_census_common_data__get(_response);
        });
    }

    protected processList_items_census_common_data__get(response: AxiosResponse): Promise<CensusCommonDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CensusCommonDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CensusCommonDataReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCommonDataReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_census_common_data__post(body: CensusCommonDataCreateDTO, cancelToken?: CancelToken): Promise<CensusCommonDataReadDTO> {
        let url_ = this.baseUrl + "/census-common-data/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_census_common_data__post(_response);
        });
    }

    protected processCreate_item_census_common_data__post(response: AxiosResponse): Promise<CensusCommonDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CensusCommonDataReadDTO.fromJS(resultData200);
            return Promise.resolve<CensusCommonDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCommonDataReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_census_common_data__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<CensusCommonDataReadDTO> {
        let url_ = this.baseUrl + "/census-common-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_census_common_data__item_id__get(_response);
        });
    }

    protected processGet_item_census_common_data__item_id__get(response: AxiosResponse): Promise<CensusCommonDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CensusCommonDataReadDTO.fromJS(resultData200);
            return Promise.resolve<CensusCommonDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCommonDataReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_census_common_data__item_id__put(item_id: string, body: CensusCommonDataCreateDTO, cancelToken?: CancelToken): Promise<CensusCommonDataReadDTO> {
        let url_ = this.baseUrl + "/census-common-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_census_common_data__item_id__put(_response);
        });
    }

    protected processUpdate_item_census_common_data__item_id__put(response: AxiosResponse): Promise<CensusCommonDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CensusCommonDataReadDTO.fromJS(resultData200);
            return Promise.resolve<CensusCommonDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCommonDataReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_census_common_data__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/census-common-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_census_common_data__item_id__delete(_response);
        });
    }

    protected processDelete_item_census_common_data__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Vector Id
     * @return Successful Response
     */
    search_by_vector_id_census_common_data_search_by_vector_id__vector_id__get(vector_id: string, cancelToken?: CancelToken): Promise<CensusCommonDataReadDTO[]> {
        let url_ = this.baseUrl + "/census-common-data/search_by_vector_id/{vector_id}";
        if (vector_id === undefined || vector_id === null)
            throw new Error("The parameter 'vector_id' must be defined.");
        url_ = url_.replace("{vector_id}", encodeURIComponent("" + vector_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_vector_id_census_common_data_search_by_vector_id__vector_id__get(_response);
        });
    }

    protected processSearch_by_vector_id_census_common_data_search_by_vector_id__vector_id__get(response: AxiosResponse): Promise<CensusCommonDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CensusCommonDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CensusCommonDataReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CensusCommonDataReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_consumption_data__get( cancelToken?: CancelToken): Promise<ConsumptionDataReadDTO[]> {
        let url_ = this.baseUrl + "/consumption-data/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_consumption_data__get(_response);
        });
    }

    protected processList_items_consumption_data__get(response: AxiosResponse): Promise<ConsumptionDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsumptionDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ConsumptionDataReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumptionDataReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_consumption_data__post(body: ConsumptionDataCreateDTO, cancelToken?: CancelToken): Promise<ConsumptionDataReadDTO> {
        let url_ = this.baseUrl + "/consumption-data/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_consumption_data__post(_response);
        });
    }

    protected processCreate_item_consumption_data__post(response: AxiosResponse): Promise<ConsumptionDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConsumptionDataReadDTO.fromJS(resultData200);
            return Promise.resolve<ConsumptionDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumptionDataReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_consumption_data__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<ConsumptionDataReadDTO> {
        let url_ = this.baseUrl + "/consumption-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_consumption_data__item_id__get(_response);
        });
    }

    protected processGet_item_consumption_data__item_id__get(response: AxiosResponse): Promise<ConsumptionDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConsumptionDataReadDTO.fromJS(resultData200);
            return Promise.resolve<ConsumptionDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumptionDataReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_consumption_data__item_id__put(item_id: string, body: ConsumptionDataCreateDTO, cancelToken?: CancelToken): Promise<ConsumptionDataReadDTO> {
        let url_ = this.baseUrl + "/consumption-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_consumption_data__item_id__put(_response);
        });
    }

    protected processUpdate_item_consumption_data__item_id__put(response: AxiosResponse): Promise<ConsumptionDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConsumptionDataReadDTO.fromJS(resultData200);
            return Promise.resolve<ConsumptionDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumptionDataReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_consumption_data__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/consumption-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_consumption_data__item_id__delete(_response);
        });
    }

    protected processDelete_item_consumption_data__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Indicator Id
     * @return Successful Response
     */
    search_by_indicator_id_consumption_data_search_by_indicator_id__indicator_id__get(indicator_id: string, cancelToken?: CancelToken): Promise<ConsumptionDataReadDTO[]> {
        let url_ = this.baseUrl + "/consumption-data/search_by_indicator_id/{indicator_id}";
        if (indicator_id === undefined || indicator_id === null)
            throw new Error("The parameter 'indicator_id' must be defined.");
        url_ = url_.replace("{indicator_id}", encodeURIComponent("" + indicator_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_indicator_id_consumption_data_search_by_indicator_id__indicator_id__get(_response);
        });
    }

    protected processSearch_by_indicator_id_consumption_data_search_by_indicator_id__indicator_id__get(response: AxiosResponse): Promise<ConsumptionDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsumptionDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ConsumptionDataReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumptionDataReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_consumption_totals__get( cancelToken?: CancelToken): Promise<ConsumptionTotalsReadDTO[]> {
        let url_ = this.baseUrl + "/consumption-totals/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_consumption_totals__get(_response);
        });
    }

    protected processList_items_consumption_totals__get(response: AxiosResponse): Promise<ConsumptionTotalsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsumptionTotalsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ConsumptionTotalsReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumptionTotalsReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_consumption_totals__post(body: ConsumptionTotalsCreateDTO, cancelToken?: CancelToken): Promise<ConsumptionTotalsReadDTO> {
        let url_ = this.baseUrl + "/consumption-totals/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_consumption_totals__post(_response);
        });
    }

    protected processCreate_item_consumption_totals__post(response: AxiosResponse): Promise<ConsumptionTotalsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConsumptionTotalsReadDTO.fromJS(resultData200);
            return Promise.resolve<ConsumptionTotalsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumptionTotalsReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_consumption_totals__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<ConsumptionTotalsReadDTO> {
        let url_ = this.baseUrl + "/consumption-totals/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_consumption_totals__item_id__get(_response);
        });
    }

    protected processGet_item_consumption_totals__item_id__get(response: AxiosResponse): Promise<ConsumptionTotalsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConsumptionTotalsReadDTO.fromJS(resultData200);
            return Promise.resolve<ConsumptionTotalsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumptionTotalsReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_consumption_totals__item_id__put(item_id: string, body: ConsumptionTotalsCreateDTO, cancelToken?: CancelToken): Promise<ConsumptionTotalsReadDTO> {
        let url_ = this.baseUrl + "/consumption-totals/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_consumption_totals__item_id__put(_response);
        });
    }

    protected processUpdate_item_consumption_totals__item_id__put(response: AxiosResponse): Promise<ConsumptionTotalsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConsumptionTotalsReadDTO.fromJS(resultData200);
            return Promise.resolve<ConsumptionTotalsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumptionTotalsReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_consumption_totals__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/consumption-totals/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_consumption_totals__item_id__delete(_response);
        });
    }

    protected processDelete_item_consumption_totals__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Get By Consumption
     * @return Successful Response
     */
    get_by_consumption_consumption_totals_by_consumption__consumption_id__get(consumption_id: string, cancelToken?: CancelToken): Promise<ConsumptionTotalsReadDTO[]> {
        let url_ = this.baseUrl + "/consumption-totals/by-consumption/{consumption_id}";
        if (consumption_id === undefined || consumption_id === null)
            throw new Error("The parameter 'consumption_id' must be defined.");
        url_ = url_.replace("{consumption_id}", encodeURIComponent("" + consumption_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_by_consumption_consumption_totals_by_consumption__consumption_id__get(_response);
        });
    }

    protected processGet_by_consumption_consumption_totals_by_consumption__consumption_id__get(response: AxiosResponse): Promise<ConsumptionTotalsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsumptionTotalsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ConsumptionTotalsReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumptionTotalsReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_customers__get( cancelToken?: CancelToken): Promise<CustomerReadDTO[]> {
        let url_ = this.baseUrl + "/customers/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_customers__get(_response);
        });
    }

    protected processList_items_customers__get(response: AxiosResponse): Promise<CustomerReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_customers__post(body: CustomerCreateDTO, cancelToken?: CancelToken): Promise<CustomerReadDTO> {
        let url_ = this.baseUrl + "/customers/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_customers__post(_response);
        });
    }

    protected processCreate_item_customers__post(response: AxiosResponse): Promise<CustomerReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerReadDTO.fromJS(resultData200);
            return Promise.resolve<CustomerReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_customers__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<CustomerReadDTO> {
        let url_ = this.baseUrl + "/customers/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_customers__item_id__get(_response);
        });
    }

    protected processGet_item_customers__item_id__get(response: AxiosResponse): Promise<CustomerReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerReadDTO.fromJS(resultData200);
            return Promise.resolve<CustomerReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_customers__item_id__put(item_id: string, body: CustomerCreateDTO, cancelToken?: CancelToken): Promise<CustomerReadDTO> {
        let url_ = this.baseUrl + "/customers/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_customers__item_id__put(_response);
        });
    }

    protected processUpdate_item_customers__item_id__put(response: AxiosResponse): Promise<CustomerReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerReadDTO.fromJS(resultData200);
            return Promise.resolve<CustomerReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_customers__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/customers/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_customers__item_id__delete(_response);
        });
    }

    protected processDelete_item_customers__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Name
     * @return Successful Response
     */
    search_by_name_customers_search_by_name__name__get(name: string, cancelToken?: CancelToken): Promise<CustomerReadDTO[]> {
        let url_ = this.baseUrl + "/customers/search_by_name/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_name_customers_search_by_name__name__get(_response);
        });
    }

    protected processSearch_by_name_customers_search_by_name__name__get(response: AxiosResponse): Promise<CustomerReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_customer_sites__get( cancelToken?: CancelToken): Promise<CustomerSitesReadDTO[]> {
        let url_ = this.baseUrl + "/customer-sites/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_customer_sites__get(_response);
        });
    }

    protected processList_items_customer_sites__get(response: AxiosResponse): Promise<CustomerSitesReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerSitesReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerSitesReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerSitesReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_customer_sites__post(body: CustomerSitesCreateDTO, cancelToken?: CancelToken): Promise<CustomerSitesReadDTO> {
        let url_ = this.baseUrl + "/customer-sites/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_customer_sites__post(_response);
        });
    }

    protected processCreate_item_customer_sites__post(response: AxiosResponse): Promise<CustomerSitesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerSitesReadDTO.fromJS(resultData200);
            return Promise.resolve<CustomerSitesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerSitesReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_customer_sites__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<CustomerSitesReadDTO> {
        let url_ = this.baseUrl + "/customer-sites/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_customer_sites__item_id__get(_response);
        });
    }

    protected processGet_item_customer_sites__item_id__get(response: AxiosResponse): Promise<CustomerSitesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerSitesReadDTO.fromJS(resultData200);
            return Promise.resolve<CustomerSitesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerSitesReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_customer_sites__item_id__put(item_id: string, body: CustomerSitesCreateDTO, cancelToken?: CancelToken): Promise<CustomerSitesReadDTO> {
        let url_ = this.baseUrl + "/customer-sites/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_customer_sites__item_id__put(_response);
        });
    }

    protected processUpdate_item_customer_sites__item_id__put(response: AxiosResponse): Promise<CustomerSitesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerSitesReadDTO.fromJS(resultData200);
            return Promise.resolve<CustomerSitesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerSitesReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_customer_sites__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/customer-sites/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_customer_sites__item_id__delete(_response);
        });
    }

    protected processDelete_item_customer_sites__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Customer Id
     * @return Successful Response
     */
    search_by_customer_id_customer_sites_search_by_customer_id__customer_id__get(customer_id: string, cancelToken?: CancelToken): Promise<CustomerSitesReadDTO[]> {
        let url_ = this.baseUrl + "/customer-sites/search_by_customer_id/{customer_id}";
        if (customer_id === undefined || customer_id === null)
            throw new Error("The parameter 'customer_id' must be defined.");
        url_ = url_.replace("{customer_id}", encodeURIComponent("" + customer_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_customer_id_customer_sites_search_by_customer_id__customer_id__get(_response);
        });
    }

    protected processSearch_by_customer_id_customer_sites_search_by_customer_id__customer_id__get(response: AxiosResponse): Promise<CustomerSitesReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerSitesReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerSitesReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerSitesReadDTO[]>(null as any);
    }

    /**
     * Get Site Image File
     * @return Successful Response
     */
    get_site_image_file_customer_sites__site_id__image_get(site_id: string, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/customer-sites/{site_id}/image";
        if (site_id === undefined || site_id === null)
            throw new Error("The parameter 'site_id' must be defined.");
        url_ = url_.replace("{site_id}", encodeURIComponent("" + site_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_site_image_file_customer_sites__site_id__image_get(_response);
        });
    }

    protected processGet_site_image_file_customer_sites__site_id__image_get(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Upload Site Image
     * @return Successful Response
     */
    upload_site_image_customer_sites__site_id__image_post(site_id: string, body: SiteImageUploadDTO, cancelToken?: CancelToken): Promise<CustomerSitesReadDTO> {
        let url_ = this.baseUrl + "/customer-sites/{site_id}/image";
        if (site_id === undefined || site_id === null)
            throw new Error("The parameter 'site_id' must be defined.");
        url_ = url_.replace("{site_id}", encodeURIComponent("" + site_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload_site_image_customer_sites__site_id__image_post(_response);
        });
    }

    protected processUpload_site_image_customer_sites__site_id__image_post(response: AxiosResponse): Promise<CustomerSitesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerSitesReadDTO.fromJS(resultData200);
            return Promise.resolve<CustomerSitesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerSitesReadDTO>(null as any);
    }

    /**
     * Delete Site Image
     * @return Successful Response
     */
    delete_site_image_customer_sites__site_id__image_delete(site_id: string, cancelToken?: CancelToken): Promise<CustomerSitesReadDTO> {
        let url_ = this.baseUrl + "/customer-sites/{site_id}/image";
        if (site_id === undefined || site_id === null)
            throw new Error("The parameter 'site_id' must be defined.");
        url_ = url_.replace("{site_id}", encodeURIComponent("" + site_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_site_image_customer_sites__site_id__image_delete(_response);
        });
    }

    protected processDelete_site_image_customer_sites__site_id__image_delete(response: AxiosResponse): Promise<CustomerSitesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerSitesReadDTO.fromJS(resultData200);
            return Promise.resolve<CustomerSitesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerSitesReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisReadDTO> {
        let url_ = this.baseUrl + "/diagnosis/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis__item_id__get(response: AxiosResponse): Promise<DiagnosisReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis__item_id__put(item_id: string, body: DiagnosisCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisReadDTO> {
        let url_ = this.baseUrl + "/diagnosis/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis__item_id__put(response: AxiosResponse): Promise<DiagnosisReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisReadDTO>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis__get( cancelToken?: CancelToken): Promise<DiagnosisReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis__get(_response);
        });
    }

    protected processList_items_diagnosis__get(response: AxiosResponse): Promise<DiagnosisReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis__post(body: DiagnosisCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisReadDTO> {
        let url_ = this.baseUrl + "/diagnosis/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis__post(_response);
        });
    }

    protected processCreate_item_diagnosis__post(response: AxiosResponse): Promise<DiagnosisReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisReadDTO>(null as any);
    }

    /**
     * Search By Site Id
     * @return Successful Response
     */
    search_by_site_id_diagnosis_search_by_site_id__site_id__get(site_id: string, cancelToken?: CancelToken): Promise<DiagnosisReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis/search_by_site_id/{site_id}";
        if (site_id === undefined || site_id === null)
            throw new Error("The parameter 'site_id' must be defined.");
        url_ = url_.replace("{site_id}", encodeURIComponent("" + site_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_site_id_diagnosis_search_by_site_id__site_id__get(_response);
        });
    }

    protected processSearch_by_site_id_diagnosis_search_by_site_id__site_id__get(response: AxiosResponse): Promise<DiagnosisReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisReadDTO[]>(null as any);
    }

    /**
     * Create Diagnosis
     * @return Successful Response
     */
    create_diagnosis_diagnosis_create_post(body: InitDiagnosisDto, cancelToken?: CancelToken): Promise<DiagnosisReadDTO> {
        let url_ = this.baseUrl + "/diagnosis/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_diagnosis_diagnosis_create_post(_response);
        });
    }

    protected processCreate_diagnosis_diagnosis_create_post(response: AxiosResponse): Promise<DiagnosisReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisReadDTO>(null as any);
    }

    /**
     * Close Diagnosis
     * @return Successful Response
     */
    close_diagnosis_diagnosis__diagnosis_id__close_post(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisReadDTO> {
        let url_ = this.baseUrl + "/diagnosis/{diagnosis_id}/close";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClose_diagnosis_diagnosis__diagnosis_id__close_post(_response);
        });
    }

    protected processClose_diagnosis_diagnosis__diagnosis_id__close_post(response: AxiosResponse): Promise<DiagnosisReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisReadDTO>(null as any);
    }

    /**
     * Get Previous Diagnosis For Same Base Site
     * @return Successful Response
     */
    get_previous_diagnosis_for_same_base_site_diagnosis__diagnosis_id__previous_for_same_base_site_get(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisReadDTO | null> {
        let url_ = this.baseUrl + "/diagnosis/{diagnosis_id}/previous_for_same_base_site";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_previous_diagnosis_for_same_base_site_diagnosis__diagnosis_id__previous_for_same_base_site_get(_response);
        });
    }

    protected processGet_previous_diagnosis_for_same_base_site_diagnosis__diagnosis_id__previous_for_same_base_site_get(response: AxiosResponse): Promise<DiagnosisReadDTO | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? DiagnosisReadDTO.fromJS(resultData200) : <any>null;
            return Promise.resolve<DiagnosisReadDTO | null>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisReadDTO | null>(null as any);
    }

    /**
     * Get Energy Uses By Vector
     * @return Successful Response
     */
    get_energy_uses_by_vector_diagnosis__diagnosis_id__energy_uses_by_vector_get(diagnosis_id: string, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/diagnosis/{diagnosis_id}/energy_uses_by_vector";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_energy_uses_by_vector_diagnosis__diagnosis_id__energy_uses_by_vector_get(_response);
        });
    }

    protected processGet_energy_uses_by_vector_diagnosis__diagnosis_id__energy_uses_by_vector_get(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * List All Diagnoses
     * @return Successful Response
     */
    list_all_diagnoses_diagnosis_all__get( cancelToken?: CancelToken): Promise<DiagnosisReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-all/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_all_diagnoses_diagnosis_all__get(_response);
        });
    }

    protected processList_all_diagnoses_diagnosis_all__get(response: AxiosResponse): Promise<DiagnosisReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_customer__get( cancelToken?: CancelToken): Promise<DiagnosisCustomerReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-customer/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_customer__get(_response);
        });
    }

    protected processList_items_diagnosis_customer__get(response: AxiosResponse): Promise<DiagnosisCustomerReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisCustomerReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisCustomerReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisCustomerReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_customer__post(body: DiagnosisCustomerCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisCustomerReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-customer/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_customer__post(_response);
        });
    }

    protected processCreate_item_diagnosis_customer__post(response: AxiosResponse): Promise<DiagnosisCustomerReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisCustomerReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisCustomerReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisCustomerReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_customer__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisCustomerReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-customer/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_customer__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_customer__item_id__get(response: AxiosResponse): Promise<DiagnosisCustomerReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisCustomerReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisCustomerReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisCustomerReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_customer__item_id__put(item_id: string, body: DiagnosisCustomerCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisCustomerReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-customer/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_customer__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_customer__item_id__put(response: AxiosResponse): Promise<DiagnosisCustomerReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisCustomerReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisCustomerReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisCustomerReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_customer__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-customer/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_customer__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_customer__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_customer_sites__get( cancelToken?: CancelToken): Promise<DiagnosisCustomerSitesReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-customer-sites/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_customer_sites__get(_response);
        });
    }

    protected processList_items_diagnosis_customer_sites__get(response: AxiosResponse): Promise<DiagnosisCustomerSitesReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisCustomerSitesReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisCustomerSitesReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisCustomerSitesReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_customer_sites__post(body: DiagnosisCustomerSitesCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisCustomerSitesReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-customer-sites/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_customer_sites__post(_response);
        });
    }

    protected processCreate_item_diagnosis_customer_sites__post(response: AxiosResponse): Promise<DiagnosisCustomerSitesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisCustomerSitesReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisCustomerSitesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisCustomerSitesReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_customer_sites__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisCustomerSitesReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-customer-sites/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_customer_sites__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_customer_sites__item_id__get(response: AxiosResponse): Promise<DiagnosisCustomerSitesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisCustomerSitesReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisCustomerSitesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisCustomerSitesReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_customer_sites__item_id__put(item_id: string, body: DiagnosisCustomerSitesCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisCustomerSitesReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-customer-sites/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_customer_sites__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_customer_sites__item_id__put(response: AxiosResponse): Promise<DiagnosisCustomerSitesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisCustomerSitesReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisCustomerSitesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisCustomerSitesReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_customer_sites__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-customer-sites/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_customer_sites__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_customer_sites__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Customer Id
     * @return Successful Response
     */
    search_by_customer_id_diagnosis_customer_sites_search_by_customer_id__customer_id__get(customer_id: string, cancelToken?: CancelToken): Promise<DiagnosisCustomerSitesReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-customer-sites/search_by_customer_id/{customer_id}";
        if (customer_id === undefined || customer_id === null)
            throw new Error("The parameter 'customer_id' must be defined.");
        url_ = url_.replace("{customer_id}", encodeURIComponent("" + customer_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_customer_id_diagnosis_customer_sites_search_by_customer_id__customer_id__get(_response);
        });
    }

    protected processSearch_by_customer_id_diagnosis_customer_sites_search_by_customer_id__customer_id__get(response: AxiosResponse): Promise<DiagnosisCustomerSitesReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisCustomerSitesReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisCustomerSitesReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisCustomerSitesReadDTO[]>(null as any);
    }

    /**
     * Get Site Image File
     * @return Successful Response
     */
    get_site_image_file_diagnosis_customer_sites__site_id__image_get(site_id: string, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/diagnosis-customer-sites/{site_id}/image";
        if (site_id === undefined || site_id === null)
            throw new Error("The parameter 'site_id' must be defined.");
        url_ = url_.replace("{site_id}", encodeURIComponent("" + site_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_site_image_file_diagnosis_customer_sites__site_id__image_get(_response);
        });
    }

    protected processGet_site_image_file_diagnosis_customer_sites__site_id__image_get(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Upload Site Image
     * @return Successful Response
     */
    upload_site_image_diagnosis_customer_sites__site_id__image_post(site_id: string, body: SiteImageUploadDTO, cancelToken?: CancelToken): Promise<DiagnosisCustomerSitesReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-customer-sites/{site_id}/image";
        if (site_id === undefined || site_id === null)
            throw new Error("The parameter 'site_id' must be defined.");
        url_ = url_.replace("{site_id}", encodeURIComponent("" + site_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload_site_image_diagnosis_customer_sites__site_id__image_post(_response);
        });
    }

    protected processUpload_site_image_diagnosis_customer_sites__site_id__image_post(response: AxiosResponse): Promise<DiagnosisCustomerSitesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisCustomerSitesReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisCustomerSitesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisCustomerSitesReadDTO>(null as any);
    }

    /**
     * Delete Site Image
     * @return Successful Response
     */
    delete_site_image_diagnosis_customer_sites__site_id__image_delete(site_id: string, cancelToken?: CancelToken): Promise<DiagnosisCustomerSitesReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-customer-sites/{site_id}/image";
        if (site_id === undefined || site_id === null)
            throw new Error("The parameter 'site_id' must be defined.");
        url_ = url_.replace("{site_id}", encodeURIComponent("" + site_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_site_image_diagnosis_customer_sites__site_id__image_delete(_response);
        });
    }

    protected processDelete_site_image_diagnosis_customer_sites__site_id__image_delete(response: AxiosResponse): Promise<DiagnosisCustomerSitesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisCustomerSitesReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisCustomerSitesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisCustomerSitesReadDTO>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_energy_vectors__get( cancelToken?: CancelToken): Promise<DiagnosisEnergyVectorsReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-energy-vectors/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_energy_vectors__get(_response);
        });
    }

    protected processList_items_diagnosis_energy_vectors__get(response: AxiosResponse): Promise<DiagnosisEnergyVectorsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisEnergyVectorsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisEnergyVectorsReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyVectorsReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_energy_vectors__post(body: DiagnosisEnergyVectorsCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisEnergyVectorsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-vectors/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_energy_vectors__post(_response);
        });
    }

    protected processCreate_item_diagnosis_energy_vectors__post(response: AxiosResponse): Promise<DiagnosisEnergyVectorsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyVectorsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyVectorsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyVectorsReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_energy_vectors__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisEnergyVectorsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-vectors/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_energy_vectors__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_energy_vectors__item_id__get(response: AxiosResponse): Promise<DiagnosisEnergyVectorsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyVectorsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyVectorsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyVectorsReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_energy_vectors__item_id__put(item_id: string, body: DiagnosisEnergyVectorsCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisEnergyVectorsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-vectors/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_energy_vectors__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_energy_vectors__item_id__put(response: AxiosResponse): Promise<DiagnosisEnergyVectorsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyVectorsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyVectorsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyVectorsReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_energy_vectors__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-energy-vectors/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_energy_vectors__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_energy_vectors__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Diagnosis Id
     * @return Successful Response
     */
    search_by_diagnosis_id_diagnosis_energy_vectors_search_by_diagnosis_id__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisEnergyVectorsReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-energy-vectors/search_by_diagnosis_id/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_diagnosis_id_diagnosis_energy_vectors_search_by_diagnosis_id__diagnosis_id__get(_response);
        });
    }

    protected processSearch_by_diagnosis_id_diagnosis_energy_vectors_search_by_diagnosis_id__diagnosis_id__get(response: AxiosResponse): Promise<DiagnosisEnergyVectorsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisEnergyVectorsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisEnergyVectorsReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyVectorsReadDTO[]>(null as any);
    }

    /**
     * Copy From General
     * @return Successful Response
     */
    copy_from_general_diagnosis_energy_vectors_copy_from_general_post(body: CopyEnergyVectorDto, cancelToken?: CancelToken): Promise<DiagnosisEnergyVectorsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-vectors/copy_from_general";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopy_from_general_diagnosis_energy_vectors_copy_from_general_post(_response);
        });
    }

    protected processCopy_from_general_diagnosis_energy_vectors_copy_from_general_post(response: AxiosResponse): Promise<DiagnosisEnergyVectorsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyVectorsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyVectorsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyVectorsReadDTO>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_energy_balance__get( cancelToken?: CancelToken): Promise<DiagnosisEnergyBalanceReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-energy-balance/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_energy_balance__get(_response);
        });
    }

    protected processList_items_diagnosis_energy_balance__get(response: AxiosResponse): Promise<DiagnosisEnergyBalanceReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisEnergyBalanceReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisEnergyBalanceReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyBalanceReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_energy_balance__post(body: DiagnosisEnergyBalanceCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisEnergyBalanceReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-balance/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_energy_balance__post(_response);
        });
    }

    protected processCreate_item_diagnosis_energy_balance__post(response: AxiosResponse): Promise<DiagnosisEnergyBalanceReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyBalanceReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyBalanceReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyBalanceReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_energy_balance__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisEnergyBalanceReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-balance/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_energy_balance__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_energy_balance__item_id__get(response: AxiosResponse): Promise<DiagnosisEnergyBalanceReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyBalanceReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyBalanceReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyBalanceReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_energy_balance__item_id__put(item_id: string, body: DiagnosisEnergyBalanceCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisEnergyBalanceReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-balance/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_energy_balance__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_energy_balance__item_id__put(response: AxiosResponse): Promise<DiagnosisEnergyBalanceReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyBalanceReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyBalanceReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyBalanceReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_energy_balance__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-energy-balance/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_energy_balance__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_energy_balance__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Get By Diagnosis
     * @return Successful Response
     */
    get_by_diagnosis_diagnosis_energy_balance_by_diagnosis__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisEnergyBalanceReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-energy-balance/by-diagnosis/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_by_diagnosis_diagnosis_energy_balance_by_diagnosis__diagnosis_id__get(_response);
        });
    }

    protected processGet_by_diagnosis_diagnosis_energy_balance_by_diagnosis__diagnosis_id__get(response: AxiosResponse): Promise<DiagnosisEnergyBalanceReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisEnergyBalanceReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisEnergyBalanceReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyBalanceReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_consumption__get( cancelToken?: CancelToken): Promise<DiagnosisConsumptionReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-consumption/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_consumption__get(_response);
        });
    }

    protected processList_items_diagnosis_consumption__get(response: AxiosResponse): Promise<DiagnosisConsumptionReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisConsumptionReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisConsumptionReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisConsumptionReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_consumption__post(body: DiagnosisConsumptionCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisConsumptionReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-consumption/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_consumption__post(_response);
        });
    }

    protected processCreate_item_diagnosis_consumption__post(response: AxiosResponse): Promise<DiagnosisConsumptionReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisConsumptionReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisConsumptionReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisConsumptionReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_consumption__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisConsumptionReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-consumption/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_consumption__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_consumption__item_id__get(response: AxiosResponse): Promise<DiagnosisConsumptionReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisConsumptionReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisConsumptionReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisConsumptionReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_consumption__item_id__put(item_id: string, body: DiagnosisConsumptionCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisConsumptionReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-consumption/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_consumption__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_consumption__item_id__put(response: AxiosResponse): Promise<DiagnosisConsumptionReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisConsumptionReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisConsumptionReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisConsumptionReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_consumption__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-consumption/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_consumption__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_consumption__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Get By Diagnosis Id
     * @return Successful Response
     */
    get_by_diagnosis_id_diagnosis_consumption_by_diagnosis__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisConsumptionReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-consumption/by-diagnosis/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_by_diagnosis_id_diagnosis_consumption_by_diagnosis__diagnosis_id__get(_response);
        });
    }

    protected processGet_by_diagnosis_id_diagnosis_consumption_by_diagnosis__diagnosis_id__get(response: AxiosResponse): Promise<DiagnosisConsumptionReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisConsumptionReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisConsumptionReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisConsumptionReadDTO[]>(null as any);
    }

    /**
     * Get By Energy Vector Id
     * @return Successful Response
     */
    get_by_energy_vector_id_diagnosis_consumption_by_energy_vector__energy_vector_id__get(energy_vector_id: string, cancelToken?: CancelToken): Promise<DiagnosisConsumptionReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-consumption/by-energy-vector/{energy_vector_id}";
        if (energy_vector_id === undefined || energy_vector_id === null)
            throw new Error("The parameter 'energy_vector_id' must be defined.");
        url_ = url_.replace("{energy_vector_id}", encodeURIComponent("" + energy_vector_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_by_energy_vector_id_diagnosis_consumption_by_energy_vector__energy_vector_id__get(_response);
        });
    }

    protected processGet_by_energy_vector_id_diagnosis_consumption_by_energy_vector__energy_vector_id__get(response: AxiosResponse): Promise<DiagnosisConsumptionReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisConsumptionReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisConsumptionReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisConsumptionReadDTO[]>(null as any);
    }

    /**
     * Calculate Consumption
     * @return Successful Response
     */
    calculate_consumption_diagnosis_consumption_calculate__energy_vector_id__post(energy_vector_id: string, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/diagnosis-consumption/calculate/{energy_vector_id}";
        if (energy_vector_id === undefined || energy_vector_id === null)
            throw new Error("The parameter 'energy_vector_id' must be defined.");
        url_ = url_.replace("{energy_vector_id}", encodeURIComponent("" + energy_vector_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculate_consumption_diagnosis_consumption_calculate__energy_vector_id__post(_response);
        });
    }

    protected processCalculate_consumption_diagnosis_consumption_calculate__energy_vector_id__post(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Update Order
     * @return Successful Response
     */
    update_order_diagnosis_consumption_update_order_post(body: UpdateConsumptionsOrderDto, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/diagnosis-consumption/update_order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_order_diagnosis_consumption_update_order_post(_response);
        });
    }

    protected processUpdate_order_diagnosis_consumption_update_order_post(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Update Reference Period
     * @return Successful Response
     */
    update_reference_period_diagnosis_consumption__item_id__reference_period_patch(item_id: string, body: ReferencePeriodUpdateDto, cancelToken?: CancelToken): Promise<DiagnosisConsumptionReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-consumption/{item_id}/reference_period";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_reference_period_diagnosis_consumption__item_id__reference_period_patch(_response);
        });
    }

    protected processUpdate_reference_period_diagnosis_consumption__item_id__reference_period_patch(response: AxiosResponse): Promise<DiagnosisConsumptionReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisConsumptionReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisConsumptionReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisConsumptionReadDTO>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_consumption_data__get( cancelToken?: CancelToken): Promise<DiagnosisConsumptionDataReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-consumption-data/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_consumption_data__get(_response);
        });
    }

    protected processList_items_diagnosis_consumption_data__get(response: AxiosResponse): Promise<DiagnosisConsumptionDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisConsumptionDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisConsumptionDataReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisConsumptionDataReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_consumption_data__post(body: DiagnosisConsumptionDataCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisConsumptionDataReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-consumption-data/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_consumption_data__post(_response);
        });
    }

    protected processCreate_item_diagnosis_consumption_data__post(response: AxiosResponse): Promise<DiagnosisConsumptionDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisConsumptionDataReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisConsumptionDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisConsumptionDataReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_consumption_data__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisConsumptionDataReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-consumption-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_consumption_data__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_consumption_data__item_id__get(response: AxiosResponse): Promise<DiagnosisConsumptionDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisConsumptionDataReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisConsumptionDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisConsumptionDataReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_consumption_data__item_id__put(item_id: string, body: DiagnosisConsumptionDataCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisConsumptionDataReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-consumption-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_consumption_data__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_consumption_data__item_id__put(response: AxiosResponse): Promise<DiagnosisConsumptionDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisConsumptionDataReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisConsumptionDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisConsumptionDataReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_consumption_data__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-consumption-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_consumption_data__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_consumption_data__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Get By Consumption Id
     * @return Successful Response
     */
    get_by_consumption_id_diagnosis_consumption_data_by_consumption__consumption_id__get(consumption_id: string, cancelToken?: CancelToken): Promise<DiagnosisConsumptionDataReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-consumption-data/by-consumption/{consumption_id}";
        if (consumption_id === undefined || consumption_id === null)
            throw new Error("The parameter 'consumption_id' must be defined.");
        url_ = url_.replace("{consumption_id}", encodeURIComponent("" + consumption_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_by_consumption_id_diagnosis_consumption_data_by_consumption__consumption_id__get(_response);
        });
    }

    protected processGet_by_consumption_id_diagnosis_consumption_data_by_consumption__consumption_id__get(response: AxiosResponse): Promise<DiagnosisConsumptionDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisConsumptionDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisConsumptionDataReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisConsumptionDataReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_field_option__get( cancelToken?: CancelToken): Promise<FieldOptionReadDTO[]> {
        let url_ = this.baseUrl + "/field-option/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_field_option__get(_response);
        });
    }

    protected processList_items_field_option__get(response: AxiosResponse): Promise<FieldOptionReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldOptionReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FieldOptionReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FieldOptionReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_field_option__post(body: FieldOptionCreateDTO, cancelToken?: CancelToken): Promise<FieldOptionReadDTO> {
        let url_ = this.baseUrl + "/field-option/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_field_option__post(_response);
        });
    }

    protected processCreate_item_field_option__post(response: AxiosResponse): Promise<FieldOptionReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FieldOptionReadDTO.fromJS(resultData200);
            return Promise.resolve<FieldOptionReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FieldOptionReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_field_option__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<FieldOptionReadDTO> {
        let url_ = this.baseUrl + "/field-option/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_field_option__item_id__get(_response);
        });
    }

    protected processGet_item_field_option__item_id__get(response: AxiosResponse): Promise<FieldOptionReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FieldOptionReadDTO.fromJS(resultData200);
            return Promise.resolve<FieldOptionReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FieldOptionReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_field_option__item_id__put(item_id: string, body: FieldOptionCreateDTO, cancelToken?: CancelToken): Promise<FieldOptionReadDTO> {
        let url_ = this.baseUrl + "/field-option/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_field_option__item_id__put(_response);
        });
    }

    protected processUpdate_item_field_option__item_id__put(response: AxiosResponse): Promise<FieldOptionReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FieldOptionReadDTO.fromJS(resultData200);
            return Promise.resolve<FieldOptionReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FieldOptionReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_field_option__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/field-option/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_field_option__item_id__delete(_response);
        });
    }

    protected processDelete_item_field_option__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Table Code
     * @return Successful Response
     */
    search_by_table_code_field_option_search_by_table_code__table_code__get(table_code: string, cancelToken?: CancelToken): Promise<FieldOptionReadDTO[]> {
        let url_ = this.baseUrl + "/field-option/search_by_table_code/{table_code}";
        if (table_code === undefined || table_code === null)
            throw new Error("The parameter 'table_code' must be defined.");
        url_ = url_.replace("{table_code}", encodeURIComponent("" + table_code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_table_code_field_option_search_by_table_code__table_code__get(_response);
        });
    }

    protected processSearch_by_table_code_field_option_search_by_table_code__table_code__get(response: AxiosResponse): Promise<FieldOptionReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldOptionReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FieldOptionReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FieldOptionReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_indicators__get( cancelToken?: CancelToken): Promise<DiagnosisIndicatorsReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-indicators/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_indicators__get(_response);
        });
    }

    protected processList_items_diagnosis_indicators__get(response: AxiosResponse): Promise<DiagnosisIndicatorsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisIndicatorsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisIndicatorsReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorsReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_indicators__post(body: DiagnosisIndicatorsCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisIndicatorsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-indicators/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_indicators__post(_response);
        });
    }

    protected processCreate_item_diagnosis_indicators__post(response: AxiosResponse): Promise<DiagnosisIndicatorsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIndicatorsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIndicatorsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorsReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_indicators__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisIndicatorsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-indicators/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_indicators__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_indicators__item_id__get(response: AxiosResponse): Promise<DiagnosisIndicatorsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIndicatorsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIndicatorsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorsReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_indicators__item_id__put(item_id: string, body: DiagnosisIndicatorsCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisIndicatorsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-indicators/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_indicators__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_indicators__item_id__put(response: AxiosResponse): Promise<DiagnosisIndicatorsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIndicatorsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIndicatorsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorsReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_indicators__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-indicators/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_indicators__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_indicators__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Diagnosis Id
     * @return Successful Response
     */
    search_by_diagnosis_id_diagnosis_indicators_search_by_diagnosis_id__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisIndicatorsReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-indicators/search_by_diagnosis_id/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_diagnosis_id_diagnosis_indicators_search_by_diagnosis_id__diagnosis_id__get(_response);
        });
    }

    protected processSearch_by_diagnosis_id_diagnosis_indicators_search_by_diagnosis_id__diagnosis_id__get(response: AxiosResponse): Promise<DiagnosisIndicatorsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisIndicatorsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisIndicatorsReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorsReadDTO[]>(null as any);
    }

    /**
     * Create With Relations
     * @return Successful Response
     */
    create_with_relations_diagnosis_indicators_create_with_relations_post(body: DiagnosisIndicatorsCreateWithRelationsDTO, cancelToken?: CancelToken): Promise<DiagnosisIndicatorsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-indicators/create_with_relations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_with_relations_diagnosis_indicators_create_with_relations_post(_response);
        });
    }

    protected processCreate_with_relations_diagnosis_indicators_create_with_relations_post(response: AxiosResponse): Promise<DiagnosisIndicatorsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIndicatorsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIndicatorsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorsReadDTO>(null as any);
    }

    /**
     * Update With Relations
     * @return Successful Response
     */
    update_with_relations_diagnosis_indicators_update_with_relations__item_id__put(item_id: string, body: DiagnosisIndicatorsUpdateWithRelationsDTO, cancelToken?: CancelToken): Promise<DiagnosisIndicatorsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-indicators/update_with_relations/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_with_relations_diagnosis_indicators_update_with_relations__item_id__put(_response);
        });
    }

    protected processUpdate_with_relations_diagnosis_indicators_update_with_relations__item_id__put(response: AxiosResponse): Promise<DiagnosisIndicatorsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIndicatorsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIndicatorsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorsReadDTO>(null as any);
    }

    /**
     * Risolvi Formula
     * @return Successful Response
     */
    risolvi_formula_diagnosis_indicators_risolvi_formula__indicator_id__get(indicator_id: string, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/diagnosis-indicators/risolvi_formula/{indicator_id}";
        if (indicator_id === undefined || indicator_id === null)
            throw new Error("The parameter 'indicator_id' must be defined.");
        url_ = url_.replace("{indicator_id}", encodeURIComponent("" + indicator_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRisolvi_formula_diagnosis_indicators_risolvi_formula__indicator_id__get(_response);
        });
    }

    protected processRisolvi_formula_diagnosis_indicators_risolvi_formula__indicator_id__get(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Test Formula
     * @return Successful Response
     */
    test_formula_diagnosis_indicators_test_formula_post(body: any, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/diagnosis-indicators/test_formula";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTest_formula_diagnosis_indicators_test_formula_post(_response);
        });
    }

    protected processTest_formula_diagnosis_indicators_test_formula_post(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_interventions__get( cancelToken?: CancelToken): Promise<DiagnosisInterventionsReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-interventions/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_interventions__get(_response);
        });
    }

    protected processList_items_diagnosis_interventions__get(response: AxiosResponse): Promise<DiagnosisInterventionsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisInterventionsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisInterventionsReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisInterventionsReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_interventions__post(body: DiagnosisInterventionsCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisInterventionsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-interventions/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_interventions__post(_response);
        });
    }

    protected processCreate_item_diagnosis_interventions__post(response: AxiosResponse): Promise<DiagnosisInterventionsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisInterventionsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisInterventionsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisInterventionsReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_interventions__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisInterventionsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-interventions/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_interventions__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_interventions__item_id__get(response: AxiosResponse): Promise<DiagnosisInterventionsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisInterventionsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisInterventionsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisInterventionsReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_interventions__item_id__put(item_id: string, body: DiagnosisInterventionsCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisInterventionsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-interventions/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_interventions__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_interventions__item_id__put(response: AxiosResponse): Promise<DiagnosisInterventionsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisInterventionsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisInterventionsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisInterventionsReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_interventions__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-interventions/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_interventions__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_interventions__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Diagnosis Id
     * @return Successful Response
     */
    search_by_diagnosis_id_diagnosis_interventions_search_by_diagnosis_id__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisInterventionsReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-interventions/search_by_diagnosis_id/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_diagnosis_id_diagnosis_interventions_search_by_diagnosis_id__diagnosis_id__get(_response);
        });
    }

    protected processSearch_by_diagnosis_id_diagnosis_interventions_search_by_diagnosis_id__diagnosis_id__get(response: AxiosResponse): Promise<DiagnosisInterventionsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisInterventionsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisInterventionsReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisInterventionsReadDTO[]>(null as any);
    }

    /**
     * Search By Vector Id
     * @return Successful Response
     */
    search_by_vector_id_diagnosis_interventions_search_by_vector_id__vector_id__get(vector_id: string, cancelToken?: CancelToken): Promise<DiagnosisInterventionsReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-interventions/search_by_vector_id/{vector_id}";
        if (vector_id === undefined || vector_id === null)
            throw new Error("The parameter 'vector_id' must be defined.");
        url_ = url_.replace("{vector_id}", encodeURIComponent("" + vector_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_vector_id_diagnosis_interventions_search_by_vector_id__vector_id__get(_response);
        });
    }

    protected processSearch_by_vector_id_diagnosis_interventions_search_by_vector_id__vector_id__get(response: AxiosResponse): Promise<DiagnosisInterventionsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisInterventionsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisInterventionsReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisInterventionsReadDTO[]>(null as any);
    }

    /**
     * Move Up
     * @return Successful Response
     */
    move_up_diagnosis_interventions__item_id__move_up_post(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisInterventionsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-interventions/{item_id}/move_up";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMove_up_diagnosis_interventions__item_id__move_up_post(_response);
        });
    }

    protected processMove_up_diagnosis_interventions__item_id__move_up_post(response: AxiosResponse): Promise<DiagnosisInterventionsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisInterventionsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisInterventionsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisInterventionsReadDTO>(null as any);
    }

    /**
     * Move Down
     * @return Successful Response
     */
    move_down_diagnosis_interventions__item_id__move_down_post(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisInterventionsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-interventions/{item_id}/move_down";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMove_down_diagnosis_interventions__item_id__move_down_post(_response);
        });
    }

    protected processMove_down_diagnosis_interventions__item_id__move_down_post(response: AxiosResponse): Promise<DiagnosisInterventionsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisInterventionsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisInterventionsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisInterventionsReadDTO>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_meters__get( cancelToken?: CancelToken): Promise<DiagnosisMetersReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-meters/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_meters__get(_response);
        });
    }

    protected processList_items_diagnosis_meters__get(response: AxiosResponse): Promise<DiagnosisMetersReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisMetersReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisMetersReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisMetersReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_meters__post(body: DiagnosisMetersCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisMetersReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-meters/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_meters__post(_response);
        });
    }

    protected processCreate_item_diagnosis_meters__post(response: AxiosResponse): Promise<DiagnosisMetersReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisMetersReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisMetersReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisMetersReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_meters__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisMetersReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-meters/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_meters__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_meters__item_id__get(response: AxiosResponse): Promise<DiagnosisMetersReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisMetersReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisMetersReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisMetersReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_meters__item_id__put(item_id: string, body: DiagnosisMetersCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisMetersReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-meters/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_meters__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_meters__item_id__put(response: AxiosResponse): Promise<DiagnosisMetersReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisMetersReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisMetersReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisMetersReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_meters__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-meters/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_meters__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_meters__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Diagnosis Id
     * @return Successful Response
     */
    search_by_diagnosis_id_diagnosis_meters_search_by_diagnosis_id__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisMetersReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-meters/search_by_diagnosis_id/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_diagnosis_id_diagnosis_meters_search_by_diagnosis_id__diagnosis_id__get(_response);
        });
    }

    protected processSearch_by_diagnosis_id_diagnosis_meters_search_by_diagnosis_id__diagnosis_id__get(response: AxiosResponse): Promise<DiagnosisMetersReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisMetersReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisMetersReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisMetersReadDTO[]>(null as any);
    }

    /**
     * Update Order
     * @return Successful Response
     */
    update_order_diagnosis_meters_update_order_post(body: UpdateMetersOrderDto, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/diagnosis-meters/update_order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_order_diagnosis_meters_update_order_post(_response);
        });
    }

    protected processUpdate_order_diagnosis_meters_update_order_post(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_relevant_variables__get( cancelToken?: CancelToken): Promise<DiagnosisRelevantVariablesReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-relevant-variables/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_relevant_variables__get(_response);
        });
    }

    protected processList_items_diagnosis_relevant_variables__get(response: AxiosResponse): Promise<DiagnosisRelevantVariablesReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisRelevantVariablesReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisRelevantVariablesReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisRelevantVariablesReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_relevant_variables__post(body: DiagnosisRelevantVariablesCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisRelevantVariablesReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-relevant-variables/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_relevant_variables__post(_response);
        });
    }

    protected processCreate_item_diagnosis_relevant_variables__post(response: AxiosResponse): Promise<DiagnosisRelevantVariablesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisRelevantVariablesReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisRelevantVariablesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisRelevantVariablesReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_relevant_variables__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisRelevantVariablesReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-relevant-variables/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_relevant_variables__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_relevant_variables__item_id__get(response: AxiosResponse): Promise<DiagnosisRelevantVariablesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisRelevantVariablesReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisRelevantVariablesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisRelevantVariablesReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_relevant_variables__item_id__put(item_id: string, body: DiagnosisRelevantVariablesCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisRelevantVariablesReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-relevant-variables/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_relevant_variables__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_relevant_variables__item_id__put(response: AxiosResponse): Promise<DiagnosisRelevantVariablesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisRelevantVariablesReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisRelevantVariablesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisRelevantVariablesReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_relevant_variables__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-relevant-variables/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_relevant_variables__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_relevant_variables__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Diagnosis Id
     * @return Successful Response
     */
    search_by_diagnosis_id_diagnosis_relevant_variables_search_by_diagnosis_id__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisRelevantVariablesReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-relevant-variables/search_by_diagnosis_id/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_diagnosis_id_diagnosis_relevant_variables_search_by_diagnosis_id__diagnosis_id__get(_response);
        });
    }

    protected processSearch_by_diagnosis_id_diagnosis_relevant_variables_search_by_diagnosis_id__diagnosis_id__get(response: AxiosResponse): Promise<DiagnosisRelevantVariablesReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisRelevantVariablesReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisRelevantVariablesReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisRelevantVariablesReadDTO[]>(null as any);
    }

    /**
     * Update Order
     * @return Successful Response
     */
    update_order_diagnosis_relevant_variables_update_order_post(body: UpdateVariablesOrderDto, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/diagnosis-relevant-variables/update_order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_order_diagnosis_relevant_variables_update_order_post(_response);
        });
    }

    protected processUpdate_order_diagnosis_relevant_variables_update_order_post(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Get Vector Type Options
     * @return Successful Response
     */
    get_vector_type_options_energy_vectors_vector_type_options_get( cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/energy-vectors/vector-type-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_vector_type_options_energy_vectors_vector_type_options_get(_response);
        });
    }

    protected processGet_vector_type_options_energy_vectors_vector_type_options_get(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_energy_vectors__get( cancelToken?: CancelToken): Promise<EnergyVectorsReadDTO[]> {
        let url_ = this.baseUrl + "/energy-vectors/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_energy_vectors__get(_response);
        });
    }

    protected processList_items_energy_vectors__get(response: AxiosResponse): Promise<EnergyVectorsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnergyVectorsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EnergyVectorsReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyVectorsReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_energy_vectors__post(body: EnergyVectorsCreateDTO, cancelToken?: CancelToken): Promise<EnergyVectorsReadDTO> {
        let url_ = this.baseUrl + "/energy-vectors/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_energy_vectors__post(_response);
        });
    }

    protected processCreate_item_energy_vectors__post(response: AxiosResponse): Promise<EnergyVectorsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnergyVectorsReadDTO.fromJS(resultData200);
            return Promise.resolve<EnergyVectorsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyVectorsReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_energy_vectors__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<EnergyVectorsReadDTO> {
        let url_ = this.baseUrl + "/energy-vectors/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_energy_vectors__item_id__get(_response);
        });
    }

    protected processGet_item_energy_vectors__item_id__get(response: AxiosResponse): Promise<EnergyVectorsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnergyVectorsReadDTO.fromJS(resultData200);
            return Promise.resolve<EnergyVectorsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyVectorsReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_energy_vectors__item_id__put(item_id: string, body: EnergyVectorsCreateDTO, cancelToken?: CancelToken): Promise<EnergyVectorsReadDTO> {
        let url_ = this.baseUrl + "/energy-vectors/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_energy_vectors__item_id__put(_response);
        });
    }

    protected processUpdate_item_energy_vectors__item_id__put(response: AxiosResponse): Promise<EnergyVectorsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnergyVectorsReadDTO.fromJS(resultData200);
            return Promise.resolve<EnergyVectorsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyVectorsReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_energy_vectors__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/energy-vectors/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_energy_vectors__item_id__delete(_response);
        });
    }

    protected processDelete_item_energy_vectors__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_indicator_reference_periods__get( cancelToken?: CancelToken): Promise<IndicatorReferencePeriodsReadDTO[]> {
        let url_ = this.baseUrl + "/indicator-reference-periods/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_indicator_reference_periods__get(_response);
        });
    }

    protected processList_items_indicator_reference_periods__get(response: AxiosResponse): Promise<IndicatorReferencePeriodsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IndicatorReferencePeriodsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IndicatorReferencePeriodsReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IndicatorReferencePeriodsReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_indicator_reference_periods__post(body: IndicatorReferencePeriodsCreateDTO, cancelToken?: CancelToken): Promise<IndicatorReferencePeriodsReadDTO> {
        let url_ = this.baseUrl + "/indicator-reference-periods/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_indicator_reference_periods__post(_response);
        });
    }

    protected processCreate_item_indicator_reference_periods__post(response: AxiosResponse): Promise<IndicatorReferencePeriodsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IndicatorReferencePeriodsReadDTO.fromJS(resultData200);
            return Promise.resolve<IndicatorReferencePeriodsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IndicatorReferencePeriodsReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_indicator_reference_periods__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<IndicatorReferencePeriodsReadDTO> {
        let url_ = this.baseUrl + "/indicator-reference-periods/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_indicator_reference_periods__item_id__get(_response);
        });
    }

    protected processGet_item_indicator_reference_periods__item_id__get(response: AxiosResponse): Promise<IndicatorReferencePeriodsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IndicatorReferencePeriodsReadDTO.fromJS(resultData200);
            return Promise.resolve<IndicatorReferencePeriodsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IndicatorReferencePeriodsReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_indicator_reference_periods__item_id__put(item_id: string, body: IndicatorReferencePeriodsCreateDTO, cancelToken?: CancelToken): Promise<IndicatorReferencePeriodsReadDTO> {
        let url_ = this.baseUrl + "/indicator-reference-periods/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_indicator_reference_periods__item_id__put(_response);
        });
    }

    protected processUpdate_item_indicator_reference_periods__item_id__put(response: AxiosResponse): Promise<IndicatorReferencePeriodsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IndicatorReferencePeriodsReadDTO.fromJS(resultData200);
            return Promise.resolve<IndicatorReferencePeriodsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IndicatorReferencePeriodsReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_indicator_reference_periods__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/indicator-reference-periods/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_indicator_reference_periods__item_id__delete(_response);
        });
    }

    protected processDelete_item_indicator_reference_periods__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Indicator Id
     * @return Successful Response
     */
    search_by_indicator_id_indicator_reference_periods_search_by_indicator_id__indicator_id__get(indicator_id: string, cancelToken?: CancelToken): Promise<IndicatorReferencePeriodsReadDTO[]> {
        let url_ = this.baseUrl + "/indicator-reference-periods/search_by_indicator_id/{indicator_id}";
        if (indicator_id === undefined || indicator_id === null)
            throw new Error("The parameter 'indicator_id' must be defined.");
        url_ = url_.replace("{indicator_id}", encodeURIComponent("" + indicator_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_indicator_id_indicator_reference_periods_search_by_indicator_id__indicator_id__get(_response);
        });
    }

    protected processSearch_by_indicator_id_indicator_reference_periods_search_by_indicator_id__indicator_id__get(response: AxiosResponse): Promise<IndicatorReferencePeriodsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IndicatorReferencePeriodsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IndicatorReferencePeriodsReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IndicatorReferencePeriodsReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_meters_data__get( cancelToken?: CancelToken): Promise<MetersDataReadDTO[]> {
        let url_ = this.baseUrl + "/meters-data/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_meters_data__get(_response);
        });
    }

    protected processList_items_meters_data__get(response: AxiosResponse): Promise<MetersDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MetersDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MetersDataReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MetersDataReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_meters_data__post(body: MetersDataCreateDTO, cancelToken?: CancelToken): Promise<MetersDataReadDTO> {
        let url_ = this.baseUrl + "/meters-data/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_meters_data__post(_response);
        });
    }

    protected processCreate_item_meters_data__post(response: AxiosResponse): Promise<MetersDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MetersDataReadDTO.fromJS(resultData200);
            return Promise.resolve<MetersDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MetersDataReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_meters_data__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<MetersDataReadDTO> {
        let url_ = this.baseUrl + "/meters-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_meters_data__item_id__get(_response);
        });
    }

    protected processGet_item_meters_data__item_id__get(response: AxiosResponse): Promise<MetersDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MetersDataReadDTO.fromJS(resultData200);
            return Promise.resolve<MetersDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MetersDataReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_meters_data__item_id__put(item_id: string, body: MetersDataCreateDTO, cancelToken?: CancelToken): Promise<MetersDataReadDTO> {
        let url_ = this.baseUrl + "/meters-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_meters_data__item_id__put(_response);
        });
    }

    protected processUpdate_item_meters_data__item_id__put(response: AxiosResponse): Promise<MetersDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MetersDataReadDTO.fromJS(resultData200);
            return Promise.resolve<MetersDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MetersDataReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_meters_data__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/meters-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_meters_data__item_id__delete(_response);
        });
    }

    protected processDelete_item_meters_data__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Meter Id
     * @return Successful Response
     */
    search_by_meter_id_meters_data_search_by_meter_id__meter_id__get(meter_id: string, cancelToken?: CancelToken): Promise<MetersDataReadDTO[]> {
        let url_ = this.baseUrl + "/meters-data/search_by_meter_id/{meter_id}";
        if (meter_id === undefined || meter_id === null)
            throw new Error("The parameter 'meter_id' must be defined.");
        url_ = url_.replace("{meter_id}", encodeURIComponent("" + meter_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_meter_id_meters_data_search_by_meter_id__meter_id__get(_response);
        });
    }

    protected processSearch_by_meter_id_meters_data_search_by_meter_id__meter_id__get(response: AxiosResponse): Promise<MetersDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MetersDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MetersDataReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MetersDataReadDTO[]>(null as any);
    }

    /**
     * Batch Save
     * @return Successful Response
     */
    batch_save_meters_data_batch_post(body: BatchMetersDataRequest, cancelToken?: CancelToken): Promise<BatchSaveResponse> {
        let url_ = this.baseUrl + "/meters-data/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatch_save_meters_data_batch_post(_response);
        });
    }

    protected processBatch_save_meters_data_batch_post(response: AxiosResponse): Promise<BatchSaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatchSaveResponse.fromJS(resultData200);
            return Promise.resolve<BatchSaveResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatchSaveResponse>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_monthly_indicator_values__get( cancelToken?: CancelToken): Promise<MonthlyIndicatorValuesReadDTO[]> {
        let url_ = this.baseUrl + "/monthly-indicator-values/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_monthly_indicator_values__get(_response);
        });
    }

    protected processList_items_monthly_indicator_values__get(response: AxiosResponse): Promise<MonthlyIndicatorValuesReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonthlyIndicatorValuesReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MonthlyIndicatorValuesReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthlyIndicatorValuesReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_monthly_indicator_values__post(body: MonthlyIndicatorValuesCreateDTO, cancelToken?: CancelToken): Promise<MonthlyIndicatorValuesReadDTO> {
        let url_ = this.baseUrl + "/monthly-indicator-values/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_monthly_indicator_values__post(_response);
        });
    }

    protected processCreate_item_monthly_indicator_values__post(response: AxiosResponse): Promise<MonthlyIndicatorValuesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MonthlyIndicatorValuesReadDTO.fromJS(resultData200);
            return Promise.resolve<MonthlyIndicatorValuesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthlyIndicatorValuesReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_monthly_indicator_values__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<MonthlyIndicatorValuesReadDTO> {
        let url_ = this.baseUrl + "/monthly-indicator-values/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_monthly_indicator_values__item_id__get(_response);
        });
    }

    protected processGet_item_monthly_indicator_values__item_id__get(response: AxiosResponse): Promise<MonthlyIndicatorValuesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MonthlyIndicatorValuesReadDTO.fromJS(resultData200);
            return Promise.resolve<MonthlyIndicatorValuesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthlyIndicatorValuesReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_monthly_indicator_values__item_id__put(item_id: string, body: MonthlyIndicatorValuesCreateDTO, cancelToken?: CancelToken): Promise<MonthlyIndicatorValuesReadDTO> {
        let url_ = this.baseUrl + "/monthly-indicator-values/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_monthly_indicator_values__item_id__put(_response);
        });
    }

    protected processUpdate_item_monthly_indicator_values__item_id__put(response: AxiosResponse): Promise<MonthlyIndicatorValuesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MonthlyIndicatorValuesReadDTO.fromJS(resultData200);
            return Promise.resolve<MonthlyIndicatorValuesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthlyIndicatorValuesReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_monthly_indicator_values__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/monthly-indicator-values/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_monthly_indicator_values__item_id__delete(_response);
        });
    }

    protected processDelete_item_monthly_indicator_values__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Indicator Id
     * @return Successful Response
     */
    search_by_indicator_id_monthly_indicator_values_search_by_indicator_id__indicator_id__get(indicator_id: string, cancelToken?: CancelToken): Promise<MonthlyIndicatorValuesReadDTO[]> {
        let url_ = this.baseUrl + "/monthly-indicator-values/search_by_indicator_id/{indicator_id}";
        if (indicator_id === undefined || indicator_id === null)
            throw new Error("The parameter 'indicator_id' must be defined.");
        url_ = url_.replace("{indicator_id}", encodeURIComponent("" + indicator_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_indicator_id_monthly_indicator_values_search_by_indicator_id__indicator_id__get(_response);
        });
    }

    protected processSearch_by_indicator_id_monthly_indicator_values_search_by_indicator_id__indicator_id__get(response: AxiosResponse): Promise<MonthlyIndicatorValuesReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonthlyIndicatorValuesReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MonthlyIndicatorValuesReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthlyIndicatorValuesReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_monthly_vector_values__get( cancelToken?: CancelToken): Promise<MonthlyVectorValuesReadDTO[]> {
        let url_ = this.baseUrl + "/monthly-vector-values/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_monthly_vector_values__get(_response);
        });
    }

    protected processList_items_monthly_vector_values__get(response: AxiosResponse): Promise<MonthlyVectorValuesReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonthlyVectorValuesReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MonthlyVectorValuesReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthlyVectorValuesReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_monthly_vector_values__post(body: MonthlyVectorValuesCreateDTO, cancelToken?: CancelToken): Promise<MonthlyVectorValuesReadDTO> {
        let url_ = this.baseUrl + "/monthly-vector-values/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_monthly_vector_values__post(_response);
        });
    }

    protected processCreate_item_monthly_vector_values__post(response: AxiosResponse): Promise<MonthlyVectorValuesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MonthlyVectorValuesReadDTO.fromJS(resultData200);
            return Promise.resolve<MonthlyVectorValuesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthlyVectorValuesReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_monthly_vector_values__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<MonthlyVectorValuesReadDTO> {
        let url_ = this.baseUrl + "/monthly-vector-values/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_monthly_vector_values__item_id__get(_response);
        });
    }

    protected processGet_item_monthly_vector_values__item_id__get(response: AxiosResponse): Promise<MonthlyVectorValuesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MonthlyVectorValuesReadDTO.fromJS(resultData200);
            return Promise.resolve<MonthlyVectorValuesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthlyVectorValuesReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_monthly_vector_values__item_id__put(item_id: string, body: MonthlyVectorValuesCreateDTO, cancelToken?: CancelToken): Promise<MonthlyVectorValuesReadDTO> {
        let url_ = this.baseUrl + "/monthly-vector-values/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_monthly_vector_values__item_id__put(_response);
        });
    }

    protected processUpdate_item_monthly_vector_values__item_id__put(response: AxiosResponse): Promise<MonthlyVectorValuesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MonthlyVectorValuesReadDTO.fromJS(resultData200);
            return Promise.resolve<MonthlyVectorValuesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthlyVectorValuesReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_monthly_vector_values__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/monthly-vector-values/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_monthly_vector_values__item_id__delete(_response);
        });
    }

    protected processDelete_item_monthly_vector_values__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Vector Id
     * @return Successful Response
     */
    search_by_vector_id_monthly_vector_values_search_by_vector_id__vector_id__get(vector_id: string, cancelToken?: CancelToken): Promise<MonthlyVectorValuesReadDTO[]> {
        let url_ = this.baseUrl + "/monthly-vector-values/search_by_vector_id/{vector_id}";
        if (vector_id === undefined || vector_id === null)
            throw new Error("The parameter 'vector_id' must be defined.");
        url_ = url_.replace("{vector_id}", encodeURIComponent("" + vector_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_vector_id_monthly_vector_values_search_by_vector_id__vector_id__get(_response);
        });
    }

    protected processSearch_by_vector_id_monthly_vector_values_search_by_vector_id__vector_id__get(response: AxiosResponse): Promise<MonthlyVectorValuesReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonthlyVectorValuesReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MonthlyVectorValuesReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthlyVectorValuesReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_pod_timetables__get( cancelToken?: CancelToken): Promise<PodTimetablesReadDTO[]> {
        let url_ = this.baseUrl + "/pod-timetables/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_pod_timetables__get(_response);
        });
    }

    protected processList_items_pod_timetables__get(response: AxiosResponse): Promise<PodTimetablesReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PodTimetablesReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PodTimetablesReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodTimetablesReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_pod_timetables__post(body: PodTimetablesCreateDTO, cancelToken?: CancelToken): Promise<PodTimetablesReadDTO> {
        let url_ = this.baseUrl + "/pod-timetables/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_pod_timetables__post(_response);
        });
    }

    protected processCreate_item_pod_timetables__post(response: AxiosResponse): Promise<PodTimetablesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PodTimetablesReadDTO.fromJS(resultData200);
            return Promise.resolve<PodTimetablesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodTimetablesReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_pod_timetables__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<PodTimetablesReadDTO> {
        let url_ = this.baseUrl + "/pod-timetables/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_pod_timetables__item_id__get(_response);
        });
    }

    protected processGet_item_pod_timetables__item_id__get(response: AxiosResponse): Promise<PodTimetablesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PodTimetablesReadDTO.fromJS(resultData200);
            return Promise.resolve<PodTimetablesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodTimetablesReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_pod_timetables__item_id__put(item_id: string, body: PodTimetablesCreateDTO, cancelToken?: CancelToken): Promise<PodTimetablesReadDTO> {
        let url_ = this.baseUrl + "/pod-timetables/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_pod_timetables__item_id__put(_response);
        });
    }

    protected processUpdate_item_pod_timetables__item_id__put(response: AxiosResponse): Promise<PodTimetablesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PodTimetablesReadDTO.fromJS(resultData200);
            return Promise.resolve<PodTimetablesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodTimetablesReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_pod_timetables__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/pod-timetables/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_pod_timetables__item_id__delete(_response);
        });
    }

    protected processDelete_item_pod_timetables__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Diagnosis Id
     * @return Successful Response
     */
    search_by_diagnosis_id_pod_timetables_search_by_diagnosis_id__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<PodTimetablesReadDTO[]> {
        let url_ = this.baseUrl + "/pod-timetables/search_by_diagnosis_id/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_diagnosis_id_pod_timetables_search_by_diagnosis_id__diagnosis_id__get(_response);
        });
    }

    protected processSearch_by_diagnosis_id_pod_timetables_search_by_diagnosis_id__diagnosis_id__get(response: AxiosResponse): Promise<PodTimetablesReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PodTimetablesReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PodTimetablesReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodTimetablesReadDTO[]>(null as any);
    }

    /**
     * Update Order
     * @return Successful Response
     */
    update_order_pod_timetables_update_order_post(body: UpdatePodTimetablesOrderDto, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/pod-timetables/update_order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_order_pod_timetables_update_order_post(_response);
        });
    }

    protected processUpdate_order_pod_timetables_update_order_post(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_pod_timetables_data__get( cancelToken?: CancelToken): Promise<PodTimetablesDataReadDTO[]> {
        let url_ = this.baseUrl + "/pod-timetables-data/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_pod_timetables_data__get(_response);
        });
    }

    protected processList_items_pod_timetables_data__get(response: AxiosResponse): Promise<PodTimetablesDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PodTimetablesDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PodTimetablesDataReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodTimetablesDataReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_pod_timetables_data__post(body: PodTimetablesDataCreateDTO, cancelToken?: CancelToken): Promise<PodTimetablesDataReadDTO> {
        let url_ = this.baseUrl + "/pod-timetables-data/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_pod_timetables_data__post(_response);
        });
    }

    protected processCreate_item_pod_timetables_data__post(response: AxiosResponse): Promise<PodTimetablesDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PodTimetablesDataReadDTO.fromJS(resultData200);
            return Promise.resolve<PodTimetablesDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodTimetablesDataReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_pod_timetables_data__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<PodTimetablesDataReadDTO> {
        let url_ = this.baseUrl + "/pod-timetables-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_pod_timetables_data__item_id__get(_response);
        });
    }

    protected processGet_item_pod_timetables_data__item_id__get(response: AxiosResponse): Promise<PodTimetablesDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PodTimetablesDataReadDTO.fromJS(resultData200);
            return Promise.resolve<PodTimetablesDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodTimetablesDataReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_pod_timetables_data__item_id__put(item_id: string, body: PodTimetablesDataCreateDTO, cancelToken?: CancelToken): Promise<PodTimetablesDataReadDTO> {
        let url_ = this.baseUrl + "/pod-timetables-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_pod_timetables_data__item_id__put(_response);
        });
    }

    protected processUpdate_item_pod_timetables_data__item_id__put(response: AxiosResponse): Promise<PodTimetablesDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PodTimetablesDataReadDTO.fromJS(resultData200);
            return Promise.resolve<PodTimetablesDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodTimetablesDataReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_pod_timetables_data__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/pod-timetables-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_pod_timetables_data__item_id__delete(_response);
        });
    }

    protected processDelete_item_pod_timetables_data__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Pod Timetable Id
     * @return Successful Response
     */
    search_by_pod_timetable_id_pod_timetables_data_search_by_pod_timetable_id__pod_timetable_id__get(pod_timetable_id: string, cancelToken?: CancelToken): Promise<PodTimetablesDataReadDTO[]> {
        let url_ = this.baseUrl + "/pod-timetables-data/search_by_pod_timetable_id/{pod_timetable_id}";
        if (pod_timetable_id === undefined || pod_timetable_id === null)
            throw new Error("The parameter 'pod_timetable_id' must be defined.");
        url_ = url_.replace("{pod_timetable_id}", encodeURIComponent("" + pod_timetable_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_pod_timetable_id_pod_timetables_data_search_by_pod_timetable_id__pod_timetable_id__get(_response);
        });
    }

    protected processSearch_by_pod_timetable_id_pod_timetables_data_search_by_pod_timetable_id__pod_timetable_id__get(response: AxiosResponse): Promise<PodTimetablesDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PodTimetablesDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PodTimetablesDataReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodTimetablesDataReadDTO[]>(null as any);
    }

    /**
     * Batch Save
     * @return Successful Response
     */
    batch_save_pod_timetables_data_batch_post(body: BatchPodTimetablesDataRequest, cancelToken?: CancelToken): Promise<BatchSaveResponse> {
        let url_ = this.baseUrl + "/pod-timetables-data/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatch_save_pod_timetables_data_batch_post(_response);
        });
    }

    protected processBatch_save_pod_timetables_data_batch_post(response: AxiosResponse): Promise<BatchSaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatchSaveResponse.fromJS(resultData200);
            return Promise.resolve<BatchSaveResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatchSaveResponse>(null as any);
    }

    /**
     * Restituisce i dati aggregati (somma) per tutti i POD di una diagnosi
     * @return Successful Response
     */
    get_total_by_diagnosis_pod_timetables_data_total_by_diagnosis__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<PodTimetablesDataTotalReadDTO[]> {
        let url_ = this.baseUrl + "/pod-timetables-data/total_by_diagnosis/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_total_by_diagnosis_pod_timetables_data_total_by_diagnosis__diagnosis_id__get(_response);
        });
    }

    protected processGet_total_by_diagnosis_pod_timetables_data_total_by_diagnosis__diagnosis_id__get(response: AxiosResponse): Promise<PodTimetablesDataTotalReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PodTimetablesDataTotalReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PodTimetablesDataTotalReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodTimetablesDataTotalReadDTO[]>(null as any);
    }

    /**
     * Aggrega i dati per giorno e ora per tutti i POD di una diagnosi
     * @param season (optional) 
     * @return Successful Response
     */
    get_weekly_profile_by_diagnosis_pod_timetables_data_diagnosis__diagnosis_id__weekly_profile_get(diagnosis_id: string, season?: SeasonEnum | undefined, cancelToken?: CancelToken): Promise<WeeklyProfileResponse> {
        let url_ = this.baseUrl + "/pod-timetables-data/diagnosis/{diagnosis_id}/weekly-profile?";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        if (season === null)
            throw new Error("The parameter 'season' cannot be null.");
        else if (season !== undefined)
            url_ += "season=" + encodeURIComponent("" + season) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_weekly_profile_by_diagnosis_pod_timetables_data_diagnosis__diagnosis_id__weekly_profile_get(_response);
        });
    }

    protected processGet_weekly_profile_by_diagnosis_pod_timetables_data_diagnosis__diagnosis_id__weekly_profile_get(response: AxiosResponse): Promise<WeeklyProfileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WeeklyProfileResponse.fromJS(resultData200);
            return Promise.resolve<WeeklyProfileResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WeeklyProfileResponse>(null as any);
    }

    /**
     * Aggrega i dati per giorno e ora
     * @param season (optional) 
     * @return Successful Response
     */
    get_weekly_profile_pod_timetables_data__pod_timetable_id__weekly_profile_get(pod_timetable_id: string, season?: SeasonEnum | undefined, cancelToken?: CancelToken): Promise<WeeklyProfileResponse> {
        let url_ = this.baseUrl + "/pod-timetables-data/{pod_timetable_id}/weekly-profile?";
        if (pod_timetable_id === undefined || pod_timetable_id === null)
            throw new Error("The parameter 'pod_timetable_id' must be defined.");
        url_ = url_.replace("{pod_timetable_id}", encodeURIComponent("" + pod_timetable_id));
        if (season === null)
            throw new Error("The parameter 'season' cannot be null.");
        else if (season !== undefined)
            url_ += "season=" + encodeURIComponent("" + season) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_weekly_profile_pod_timetables_data__pod_timetable_id__weekly_profile_get(_response);
        });
    }

    protected processGet_weekly_profile_pod_timetables_data__pod_timetable_id__weekly_profile_get(response: AxiosResponse): Promise<WeeklyProfileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WeeklyProfileResponse.fromJS(resultData200);
            return Promise.resolve<WeeklyProfileResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WeeklyProfileResponse>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_self_production_plants__get( cancelToken?: CancelToken): Promise<SelfProductionPlantsReadDTO[]> {
        let url_ = this.baseUrl + "/self-production-plants/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_self_production_plants__get(_response);
        });
    }

    protected processList_items_self_production_plants__get(response: AxiosResponse): Promise<SelfProductionPlantsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelfProductionPlantsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SelfProductionPlantsReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelfProductionPlantsReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_self_production_plants__post(body: SelfProductionPlantsCreateDTO, cancelToken?: CancelToken): Promise<SelfProductionPlantsReadDTO> {
        let url_ = this.baseUrl + "/self-production-plants/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_self_production_plants__post(_response);
        });
    }

    protected processCreate_item_self_production_plants__post(response: AxiosResponse): Promise<SelfProductionPlantsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelfProductionPlantsReadDTO.fromJS(resultData200);
            return Promise.resolve<SelfProductionPlantsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelfProductionPlantsReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_self_production_plants__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<SelfProductionPlantsReadDTO> {
        let url_ = this.baseUrl + "/self-production-plants/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_self_production_plants__item_id__get(_response);
        });
    }

    protected processGet_item_self_production_plants__item_id__get(response: AxiosResponse): Promise<SelfProductionPlantsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelfProductionPlantsReadDTO.fromJS(resultData200);
            return Promise.resolve<SelfProductionPlantsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelfProductionPlantsReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_self_production_plants__item_id__put(item_id: string, body: SelfProductionPlantsCreateDTO, cancelToken?: CancelToken): Promise<SelfProductionPlantsReadDTO> {
        let url_ = this.baseUrl + "/self-production-plants/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_self_production_plants__item_id__put(_response);
        });
    }

    protected processUpdate_item_self_production_plants__item_id__put(response: AxiosResponse): Promise<SelfProductionPlantsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelfProductionPlantsReadDTO.fromJS(resultData200);
            return Promise.resolve<SelfProductionPlantsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelfProductionPlantsReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_self_production_plants__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/self-production-plants/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_self_production_plants__item_id__delete(_response);
        });
    }

    protected processDelete_item_self_production_plants__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Site Id
     * @return Successful Response
     */
    search_by_site_id_self_production_plants_search_by_site_id__site_id__get(site_id: string, cancelToken?: CancelToken): Promise<SelfProductionPlantsReadDTO[]> {
        let url_ = this.baseUrl + "/self-production-plants/search_by_site_id/{site_id}";
        if (site_id === undefined || site_id === null)
            throw new Error("The parameter 'site_id' must be defined.");
        url_ = url_.replace("{site_id}", encodeURIComponent("" + site_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_site_id_self_production_plants_search_by_site_id__site_id__get(_response);
        });
    }

    protected processSearch_by_site_id_self_production_plants_search_by_site_id__site_id__get(response: AxiosResponse): Promise<SelfProductionPlantsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelfProductionPlantsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SelfProductionPlantsReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelfProductionPlantsReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_self_production_plants__get( cancelToken?: CancelToken): Promise<DiagnosisSelfProductionPlantsReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-self-production-plants/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_self_production_plants__get(_response);
        });
    }

    protected processList_items_diagnosis_self_production_plants__get(response: AxiosResponse): Promise<DiagnosisSelfProductionPlantsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisSelfProductionPlantsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisSelfProductionPlantsReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisSelfProductionPlantsReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_self_production_plants__post(body: DiagnosisSelfProductionPlantsCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisSelfProductionPlantsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-self-production-plants/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_self_production_plants__post(_response);
        });
    }

    protected processCreate_item_diagnosis_self_production_plants__post(response: AxiosResponse): Promise<DiagnosisSelfProductionPlantsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisSelfProductionPlantsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisSelfProductionPlantsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisSelfProductionPlantsReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_self_production_plants__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisSelfProductionPlantsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-self-production-plants/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_self_production_plants__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_self_production_plants__item_id__get(response: AxiosResponse): Promise<DiagnosisSelfProductionPlantsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisSelfProductionPlantsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisSelfProductionPlantsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisSelfProductionPlantsReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_self_production_plants__item_id__put(item_id: string, body: DiagnosisSelfProductionPlantsCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisSelfProductionPlantsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-self-production-plants/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_self_production_plants__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_self_production_plants__item_id__put(response: AxiosResponse): Promise<DiagnosisSelfProductionPlantsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisSelfProductionPlantsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisSelfProductionPlantsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisSelfProductionPlantsReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_self_production_plants__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-self-production-plants/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_self_production_plants__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_self_production_plants__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Diagnosis Id
     * @return Successful Response
     */
    search_by_diagnosis_id_diagnosis_self_production_plants_search_by_diagnosis_id__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisSelfProductionPlantsReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-self-production-plants/search_by_diagnosis_id/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_diagnosis_id_diagnosis_self_production_plants_search_by_diagnosis_id__diagnosis_id__get(_response);
        });
    }

    protected processSearch_by_diagnosis_id_diagnosis_self_production_plants_search_by_diagnosis_id__diagnosis_id__get(response: AxiosResponse): Promise<DiagnosisSelfProductionPlantsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisSelfProductionPlantsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisSelfProductionPlantsReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisSelfProductionPlantsReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_variables_data__get( cancelToken?: CancelToken): Promise<VariablesDataReadDTO[]> {
        let url_ = this.baseUrl + "/variables-data/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_variables_data__get(_response);
        });
    }

    protected processList_items_variables_data__get(response: AxiosResponse): Promise<VariablesDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VariablesDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VariablesDataReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VariablesDataReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_variables_data__post(body: VariablesDataCreateDTO, cancelToken?: CancelToken): Promise<VariablesDataReadDTO> {
        let url_ = this.baseUrl + "/variables-data/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_variables_data__post(_response);
        });
    }

    protected processCreate_item_variables_data__post(response: AxiosResponse): Promise<VariablesDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VariablesDataReadDTO.fromJS(resultData200);
            return Promise.resolve<VariablesDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VariablesDataReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_variables_data__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<VariablesDataReadDTO> {
        let url_ = this.baseUrl + "/variables-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_variables_data__item_id__get(_response);
        });
    }

    protected processGet_item_variables_data__item_id__get(response: AxiosResponse): Promise<VariablesDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VariablesDataReadDTO.fromJS(resultData200);
            return Promise.resolve<VariablesDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VariablesDataReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_variables_data__item_id__put(item_id: string, body: VariablesDataCreateDTO, cancelToken?: CancelToken): Promise<VariablesDataReadDTO> {
        let url_ = this.baseUrl + "/variables-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_variables_data__item_id__put(_response);
        });
    }

    protected processUpdate_item_variables_data__item_id__put(response: AxiosResponse): Promise<VariablesDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VariablesDataReadDTO.fromJS(resultData200);
            return Promise.resolve<VariablesDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VariablesDataReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_variables_data__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/variables-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_variables_data__item_id__delete(_response);
        });
    }

    protected processDelete_item_variables_data__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Variable Id
     * @return Successful Response
     */
    search_by_variable_id_variables_data_search_by_variable_id__variable_id__get(variable_id: string, cancelToken?: CancelToken): Promise<VariablesDataReadDTO[]> {
        let url_ = this.baseUrl + "/variables-data/search_by_variable_id/{variable_id}";
        if (variable_id === undefined || variable_id === null)
            throw new Error("The parameter 'variable_id' must be defined.");
        url_ = url_.replace("{variable_id}", encodeURIComponent("" + variable_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_variable_id_variables_data_search_by_variable_id__variable_id__get(_response);
        });
    }

    protected processSearch_by_variable_id_variables_data_search_by_variable_id__variable_id__get(response: AxiosResponse): Promise<VariablesDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VariablesDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VariablesDataReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VariablesDataReadDTO[]>(null as any);
    }

    /**
     * Batch Save
     * @return Successful Response
     */
    batch_save_variables_data_batch_post(body: BatchVariablesDataRequest, cancelToken?: CancelToken): Promise<BatchSaveResponse> {
        let url_ = this.baseUrl + "/variables-data/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatch_save_variables_data_batch_post(_response);
        });
    }

    protected processBatch_save_variables_data_batch_post(response: AxiosResponse): Promise<BatchSaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatchSaveResponse.fromJS(resultData200);
            return Promise.resolve<BatchSaveResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatchSaveResponse>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_vector_reference_periods__get( cancelToken?: CancelToken): Promise<VectorReferencePeriodsReadDTO[]> {
        let url_ = this.baseUrl + "/vector-reference-periods/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_vector_reference_periods__get(_response);
        });
    }

    protected processList_items_vector_reference_periods__get(response: AxiosResponse): Promise<VectorReferencePeriodsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VectorReferencePeriodsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VectorReferencePeriodsReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VectorReferencePeriodsReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_vector_reference_periods__post(body: VectorReferencePeriodsCreateDTO, cancelToken?: CancelToken): Promise<VectorReferencePeriodsReadDTO> {
        let url_ = this.baseUrl + "/vector-reference-periods/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_vector_reference_periods__post(_response);
        });
    }

    protected processCreate_item_vector_reference_periods__post(response: AxiosResponse): Promise<VectorReferencePeriodsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VectorReferencePeriodsReadDTO.fromJS(resultData200);
            return Promise.resolve<VectorReferencePeriodsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VectorReferencePeriodsReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_vector_reference_periods__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<VectorReferencePeriodsReadDTO> {
        let url_ = this.baseUrl + "/vector-reference-periods/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_vector_reference_periods__item_id__get(_response);
        });
    }

    protected processGet_item_vector_reference_periods__item_id__get(response: AxiosResponse): Promise<VectorReferencePeriodsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VectorReferencePeriodsReadDTO.fromJS(resultData200);
            return Promise.resolve<VectorReferencePeriodsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VectorReferencePeriodsReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_vector_reference_periods__item_id__put(item_id: string, body: VectorReferencePeriodsCreateDTO, cancelToken?: CancelToken): Promise<VectorReferencePeriodsReadDTO> {
        let url_ = this.baseUrl + "/vector-reference-periods/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_vector_reference_periods__item_id__put(_response);
        });
    }

    protected processUpdate_item_vector_reference_periods__item_id__put(response: AxiosResponse): Promise<VectorReferencePeriodsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VectorReferencePeriodsReadDTO.fromJS(resultData200);
            return Promise.resolve<VectorReferencePeriodsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VectorReferencePeriodsReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_vector_reference_periods__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/vector-reference-periods/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_vector_reference_periods__item_id__delete(_response);
        });
    }

    protected processDelete_item_vector_reference_periods__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Vector Id
     * @return Successful Response
     */
    search_by_vector_id_vector_reference_periods_search_by_vector_id__vector_id__get(vector_id: string, cancelToken?: CancelToken): Promise<VectorReferencePeriodsReadDTO[]> {
        let url_ = this.baseUrl + "/vector-reference-periods/search_by_vector_id/{vector_id}";
        if (vector_id === undefined || vector_id === null)
            throw new Error("The parameter 'vector_id' must be defined.");
        url_ = url_.replace("{vector_id}", encodeURIComponent("" + vector_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_vector_id_vector_reference_periods_search_by_vector_id__vector_id__get(_response);
        });
    }

    protected processSearch_by_vector_id_vector_reference_periods_search_by_vector_id__vector_id__get(response: AxiosResponse): Promise<VectorReferencePeriodsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VectorReferencePeriodsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VectorReferencePeriodsReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VectorReferencePeriodsReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_user__get( cancelToken?: CancelToken): Promise<UserReadDTO[]> {
        let url_ = this.baseUrl + "/user/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_user__get(_response);
        });
    }

    protected processList_items_user__get(response: AxiosResponse): Promise<UserReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserReadDTO[]>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_user__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<UserReadDTO> {
        let url_ = this.baseUrl + "/user/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_user__item_id__get(_response);
        });
    }

    protected processGet_item_user__item_id__get(response: AxiosResponse): Promise<UserReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserReadDTO.fromJS(resultData200);
            return Promise.resolve<UserReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_user__item_id__put(item_id: string, body: UserCreateDTO, cancelToken?: CancelToken): Promise<UserReadDTO> {
        let url_ = this.baseUrl + "/user/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_user__item_id__put(_response);
        });
    }

    protected processUpdate_item_user__item_id__put(response: AxiosResponse): Promise<UserReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserReadDTO.fromJS(resultData200);
            return Promise.resolve<UserReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_user__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/user/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_user__item_id__delete(_response);
        });
    }

    protected processDelete_item_user__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Get All Units Of Measure
     * @return Successful Response
     */
    get_all_units_of_measure_units_of_measure_all_get( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/units-of-measure/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_all_units_of_measure_units_of_measure_all_get(_response);
        });
    }

    protected processGet_all_units_of_measure_units_of_measure_all_get(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Get Categories
     * @return Successful Response
     */
    get_categories_units_of_measure_categories_get( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/units-of-measure/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_categories_units_of_measure_categories_get(_response);
        });
    }

    protected processGet_categories_units_of_measure_categories_get(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Get Units By Category
     * @return Successful Response
     */
    get_units_by_category_units_of_measure_by_category__category__get(category: string, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/units-of-measure/by-category/{category}";
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_units_by_category_units_of_measure_by_category__category__get(_response);
        });
    }

    protected processGet_units_by_category_units_of_measure_by_category__category__get(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Get Grouped Units
     * @return Successful Response
     */
    get_grouped_units_units_of_measure_grouped_get( cancelToken?: CancelToken): Promise<{ [key: string]: string[]; }> {
        let url_ = this.baseUrl + "/units-of-measure/grouped";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_grouped_units_units_of_measure_grouped_get(_response);
        });
    }

    protected processGet_grouped_units_units_of_measure_grouped_get(response: AxiosResponse): Promise<{ [key: string]: string[]; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: string[]; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string[]; }>(null as any);
    }

    /**
     * Get Units By Same Category
     * @return Successful Response
     */
    get_units_by_same_category_units_of_measure_by_same_category__udm__get(udm: string, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/units-of-measure/by-same-category/{udm}";
        if (udm === undefined || udm === null)
            throw new Error("The parameter 'udm' must be defined.");
        url_ = url_.replace("{udm}", encodeURIComponent("" + udm));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_units_by_same_category_units_of_measure_by_same_category__udm__get(_response);
        });
    }

    protected processGet_units_by_same_category_units_of_measure_by_same_category__udm__get(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Convert Value
     * @param value Valore da convertire
     * @param from_udm Unità di misura di origine
     * @param to_udm Unità di misura di destinazione
     * @param densita (optional) Densità in kg/l (richiesta per conversioni Volume <-> Massa)
     * @return Successful Response
     */
    convert_value_units_of_measure_convert_get(value: number, from_udm: string, to_udm: string, densita?: number | null | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/units-of-measure/convert?";
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined and cannot be null.");
        else
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        if (from_udm === undefined || from_udm === null)
            throw new Error("The parameter 'from_udm' must be defined and cannot be null.");
        else
            url_ += "from_udm=" + encodeURIComponent("" + from_udm) + "&";
        if (to_udm === undefined || to_udm === null)
            throw new Error("The parameter 'to_udm' must be defined and cannot be null.");
        else
            url_ += "to_udm=" + encodeURIComponent("" + to_udm) + "&";
        if (densita !== undefined && densita !== null)
            url_ += "densita=" + encodeURIComponent("" + densita) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConvert_value_units_of_measure_convert_get(_response);
        });
    }

    protected processConvert_value_units_of_measure_convert_get(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Check Units Equivalent
     * @param udm1 Prima unità di misura
     * @param udm2 Seconda unità di misura
     * @param densita (optional) Densità in kg/l (per equivalenza MassaVolume in formule)
     * @return Successful Response
     */
    check_units_equivalent_units_of_measure_are_equivalent_get(udm1: string, udm2: string, densita?: number | null | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/units-of-measure/are-equivalent?";
        if (udm1 === undefined || udm1 === null)
            throw new Error("The parameter 'udm1' must be defined and cannot be null.");
        else
            url_ += "udm1=" + encodeURIComponent("" + udm1) + "&";
        if (udm2 === undefined || udm2 === null)
            throw new Error("The parameter 'udm2' must be defined and cannot be null.");
        else
            url_ += "udm2=" + encodeURIComponent("" + udm2) + "&";
        if (densita !== undefined && densita !== null)
            url_ += "densita=" + encodeURIComponent("" + densita) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheck_units_equivalent_units_of_measure_are_equivalent_get(_response);
        });
    }

    protected processCheck_units_equivalent_units_of_measure_are_equivalent_get(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_indicator_meters__get( cancelToken?: CancelToken): Promise<DiagnosisIndicatorMetersReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-indicator-meters/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_indicator_meters__get(_response);
        });
    }

    protected processList_items_diagnosis_indicator_meters__get(response: AxiosResponse): Promise<DiagnosisIndicatorMetersReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisIndicatorMetersReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisIndicatorMetersReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorMetersReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_indicator_meters__post(body: DiagnosisIndicatorMetersCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisIndicatorMetersReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-indicator-meters/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_indicator_meters__post(_response);
        });
    }

    protected processCreate_item_diagnosis_indicator_meters__post(response: AxiosResponse): Promise<DiagnosisIndicatorMetersReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIndicatorMetersReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIndicatorMetersReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorMetersReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_indicator_meters__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisIndicatorMetersReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-indicator-meters/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_indicator_meters__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_indicator_meters__item_id__get(response: AxiosResponse): Promise<DiagnosisIndicatorMetersReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIndicatorMetersReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIndicatorMetersReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorMetersReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_indicator_meters__item_id__put(item_id: string, body: DiagnosisIndicatorMetersCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisIndicatorMetersReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-indicator-meters/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_indicator_meters__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_indicator_meters__item_id__put(response: AxiosResponse): Promise<DiagnosisIndicatorMetersReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIndicatorMetersReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIndicatorMetersReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorMetersReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_indicator_meters__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-indicator-meters/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_indicator_meters__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_indicator_meters__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Get By Indicator Id
     * @return Successful Response
     */
    get_by_indicator_id_diagnosis_indicator_meters_by_indicator__indicator_id__get(indicator_id: string, cancelToken?: CancelToken): Promise<DiagnosisIndicatorMetersReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-indicator-meters/by-indicator/{indicator_id}";
        if (indicator_id === undefined || indicator_id === null)
            throw new Error("The parameter 'indicator_id' must be defined.");
        url_ = url_.replace("{indicator_id}", encodeURIComponent("" + indicator_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_by_indicator_id_diagnosis_indicator_meters_by_indicator__indicator_id__get(_response);
        });
    }

    protected processGet_by_indicator_id_diagnosis_indicator_meters_by_indicator__indicator_id__get(response: AxiosResponse): Promise<DiagnosisIndicatorMetersReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisIndicatorMetersReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisIndicatorMetersReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorMetersReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_indicator_relevant_variables__get( cancelToken?: CancelToken): Promise<DiagnosisIndicatorRelevantVariablesReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-indicator-relevant-variables/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_indicator_relevant_variables__get(_response);
        });
    }

    protected processList_items_diagnosis_indicator_relevant_variables__get(response: AxiosResponse): Promise<DiagnosisIndicatorRelevantVariablesReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisIndicatorRelevantVariablesReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisIndicatorRelevantVariablesReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorRelevantVariablesReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_indicator_relevant_variables__post(body: DiagnosisIndicatorRelevantVariablesCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisIndicatorRelevantVariablesReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-indicator-relevant-variables/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_indicator_relevant_variables__post(_response);
        });
    }

    protected processCreate_item_diagnosis_indicator_relevant_variables__post(response: AxiosResponse): Promise<DiagnosisIndicatorRelevantVariablesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIndicatorRelevantVariablesReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIndicatorRelevantVariablesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorRelevantVariablesReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_indicator_relevant_variables__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisIndicatorRelevantVariablesReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-indicator-relevant-variables/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_indicator_relevant_variables__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_indicator_relevant_variables__item_id__get(response: AxiosResponse): Promise<DiagnosisIndicatorRelevantVariablesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIndicatorRelevantVariablesReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIndicatorRelevantVariablesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorRelevantVariablesReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_indicator_relevant_variables__item_id__put(item_id: string, body: DiagnosisIndicatorRelevantVariablesCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisIndicatorRelevantVariablesReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-indicator-relevant-variables/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_indicator_relevant_variables__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_indicator_relevant_variables__item_id__put(response: AxiosResponse): Promise<DiagnosisIndicatorRelevantVariablesReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIndicatorRelevantVariablesReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIndicatorRelevantVariablesReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorRelevantVariablesReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_indicator_relevant_variables__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-indicator-relevant-variables/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_indicator_relevant_variables__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_indicator_relevant_variables__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Get By Indicator Id
     * @return Successful Response
     */
    get_by_indicator_id_diagnosis_indicator_relevant_variables_by_indicator__indicator_id__get(indicator_id: string, cancelToken?: CancelToken): Promise<DiagnosisIndicatorRelevantVariablesReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-indicator-relevant-variables/by-indicator/{indicator_id}";
        if (indicator_id === undefined || indicator_id === null)
            throw new Error("The parameter 'indicator_id' must be defined.");
        url_ = url_.replace("{indicator_id}", encodeURIComponent("" + indicator_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_by_indicator_id_diagnosis_indicator_relevant_variables_by_indicator__indicator_id__get(_response);
        });
    }

    protected processGet_by_indicator_id_diagnosis_indicator_relevant_variables_by_indicator__indicator_id__get(response: AxiosResponse): Promise<DiagnosisIndicatorRelevantVariablesReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisIndicatorRelevantVariablesReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisIndicatorRelevantVariablesReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorRelevantVariablesReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_indicator_consumptions__get( cancelToken?: CancelToken): Promise<DiagnosisIndicatorConsumptionsReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-indicator-consumptions/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_indicator_consumptions__get(_response);
        });
    }

    protected processList_items_diagnosis_indicator_consumptions__get(response: AxiosResponse): Promise<DiagnosisIndicatorConsumptionsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisIndicatorConsumptionsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisIndicatorConsumptionsReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorConsumptionsReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_indicator_consumptions__post(body: DiagnosisIndicatorConsumptionsCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisIndicatorConsumptionsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-indicator-consumptions/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_indicator_consumptions__post(_response);
        });
    }

    protected processCreate_item_diagnosis_indicator_consumptions__post(response: AxiosResponse): Promise<DiagnosisIndicatorConsumptionsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIndicatorConsumptionsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIndicatorConsumptionsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorConsumptionsReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_indicator_consumptions__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisIndicatorConsumptionsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-indicator-consumptions/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_indicator_consumptions__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_indicator_consumptions__item_id__get(response: AxiosResponse): Promise<DiagnosisIndicatorConsumptionsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIndicatorConsumptionsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIndicatorConsumptionsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorConsumptionsReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_indicator_consumptions__item_id__put(item_id: string, body: DiagnosisIndicatorConsumptionsCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisIndicatorConsumptionsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-indicator-consumptions/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_indicator_consumptions__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_indicator_consumptions__item_id__put(response: AxiosResponse): Promise<DiagnosisIndicatorConsumptionsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIndicatorConsumptionsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIndicatorConsumptionsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorConsumptionsReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_indicator_consumptions__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-indicator-consumptions/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_indicator_consumptions__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_indicator_consumptions__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Get By Indicator Id
     * @return Successful Response
     */
    get_by_indicator_id_diagnosis_indicator_consumptions_by_indicator__indicator_id__get(indicator_id: string, cancelToken?: CancelToken): Promise<DiagnosisIndicatorConsumptionsReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-indicator-consumptions/by-indicator/{indicator_id}";
        if (indicator_id === undefined || indicator_id === null)
            throw new Error("The parameter 'indicator_id' must be defined.");
        url_ = url_.replace("{indicator_id}", encodeURIComponent("" + indicator_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_by_indicator_id_diagnosis_indicator_consumptions_by_indicator__indicator_id__get(_response);
        });
    }

    protected processGet_by_indicator_id_diagnosis_indicator_consumptions_by_indicator__indicator_id__get(response: AxiosResponse): Promise<DiagnosisIndicatorConsumptionsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisIndicatorConsumptionsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisIndicatorConsumptionsReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIndicatorConsumptionsReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_incidence_enea__get( cancelToken?: CancelToken): Promise<IncidenceEneaReadDTO[]> {
        let url_ = this.baseUrl + "/incidence-enea/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_incidence_enea__get(_response);
        });
    }

    protected processList_items_incidence_enea__get(response: AxiosResponse): Promise<IncidenceEneaReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncidenceEneaReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IncidenceEneaReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidenceEneaReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_incidence_enea__post(body: IncidenceEneaCreateDTO, cancelToken?: CancelToken): Promise<IncidenceEneaReadDTO> {
        let url_ = this.baseUrl + "/incidence-enea/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_incidence_enea__post(_response);
        });
    }

    protected processCreate_item_incidence_enea__post(response: AxiosResponse): Promise<IncidenceEneaReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidenceEneaReadDTO.fromJS(resultData200);
            return Promise.resolve<IncidenceEneaReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidenceEneaReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_incidence_enea__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<IncidenceEneaReadDTO> {
        let url_ = this.baseUrl + "/incidence-enea/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_incidence_enea__item_id__get(_response);
        });
    }

    protected processGet_item_incidence_enea__item_id__get(response: AxiosResponse): Promise<IncidenceEneaReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidenceEneaReadDTO.fromJS(resultData200);
            return Promise.resolve<IncidenceEneaReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidenceEneaReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_incidence_enea__item_id__put(item_id: string, body: IncidenceEneaCreateDTO, cancelToken?: CancelToken): Promise<IncidenceEneaReadDTO> {
        let url_ = this.baseUrl + "/incidence-enea/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_incidence_enea__item_id__put(_response);
        });
    }

    protected processUpdate_item_incidence_enea__item_id__put(response: AxiosResponse): Promise<IncidenceEneaReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidenceEneaReadDTO.fromJS(resultData200);
            return Promise.resolve<IncidenceEneaReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidenceEneaReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_incidence_enea__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/incidence-enea/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_incidence_enea__item_id__delete(_response);
        });
    }

    protected processDelete_item_incidence_enea__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_incidence_enea__get( cancelToken?: CancelToken): Promise<DiagnosisIncidenceEneaReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-incidence-enea/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_incidence_enea__get(_response);
        });
    }

    protected processList_items_diagnosis_incidence_enea__get(response: AxiosResponse): Promise<DiagnosisIncidenceEneaReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisIncidenceEneaReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisIncidenceEneaReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIncidenceEneaReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_incidence_enea__post(body: DiagnosisIncidenceEneaCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisIncidenceEneaReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-incidence-enea/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_incidence_enea__post(_response);
        });
    }

    protected processCreate_item_diagnosis_incidence_enea__post(response: AxiosResponse): Promise<DiagnosisIncidenceEneaReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIncidenceEneaReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIncidenceEneaReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIncidenceEneaReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_incidence_enea__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisIncidenceEneaReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-incidence-enea/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_incidence_enea__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_incidence_enea__item_id__get(response: AxiosResponse): Promise<DiagnosisIncidenceEneaReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIncidenceEneaReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIncidenceEneaReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIncidenceEneaReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_incidence_enea__item_id__put(item_id: string, body: DiagnosisIncidenceEneaCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisIncidenceEneaReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-incidence-enea/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_incidence_enea__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_incidence_enea__item_id__put(response: AxiosResponse): Promise<DiagnosisIncidenceEneaReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIncidenceEneaReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIncidenceEneaReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIncidenceEneaReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_incidence_enea__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-incidence-enea/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_incidence_enea__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_incidence_enea__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Diagnosis Id
     * @return Successful Response
     */
    search_by_diagnosis_id_diagnosis_incidence_enea_search_by_diagnosis_id__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisIncidenceEneaReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-incidence-enea/search_by_diagnosis_id/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_diagnosis_id_diagnosis_incidence_enea_search_by_diagnosis_id__diagnosis_id__get(_response);
        });
    }

    protected processSearch_by_diagnosis_id_diagnosis_incidence_enea_search_by_diagnosis_id__diagnosis_id__get(response: AxiosResponse): Promise<DiagnosisIncidenceEneaReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIncidenceEneaReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIncidenceEneaReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIncidenceEneaReadDTO>(null as any);
    }

    /**
     * Copy From General
     * @return Successful Response
     */
    copy_from_general_diagnosis_incidence_enea_copy_from_general_post(body: CopyIncidenceEneaDto, cancelToken?: CancelToken): Promise<DiagnosisIncidenceEneaReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-incidence-enea/copy_from_general";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopy_from_general_diagnosis_incidence_enea_copy_from_general_post(_response);
        });
    }

    protected processCopy_from_general_diagnosis_incidence_enea_copy_from_general_post(response: AxiosResponse): Promise<DiagnosisIncidenceEneaReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIncidenceEneaReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIncidenceEneaReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIncidenceEneaReadDTO>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_incidence_enea_percentage__get( cancelToken?: CancelToken): Promise<IncidenceEneaPercentageReadDTO[]> {
        let url_ = this.baseUrl + "/incidence-enea-percentage/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_incidence_enea_percentage__get(_response);
        });
    }

    protected processList_items_incidence_enea_percentage__get(response: AxiosResponse): Promise<IncidenceEneaPercentageReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncidenceEneaPercentageReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IncidenceEneaPercentageReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidenceEneaPercentageReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_incidence_enea_percentage__post(body: IncidenceEneaPercentageCreateDTO, cancelToken?: CancelToken): Promise<IncidenceEneaPercentageReadDTO> {
        let url_ = this.baseUrl + "/incidence-enea-percentage/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_incidence_enea_percentage__post(_response);
        });
    }

    protected processCreate_item_incidence_enea_percentage__post(response: AxiosResponse): Promise<IncidenceEneaPercentageReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidenceEneaPercentageReadDTO.fromJS(resultData200);
            return Promise.resolve<IncidenceEneaPercentageReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidenceEneaPercentageReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_incidence_enea_percentage__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<IncidenceEneaPercentageReadDTO> {
        let url_ = this.baseUrl + "/incidence-enea-percentage/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_incidence_enea_percentage__item_id__get(_response);
        });
    }

    protected processGet_item_incidence_enea_percentage__item_id__get(response: AxiosResponse): Promise<IncidenceEneaPercentageReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidenceEneaPercentageReadDTO.fromJS(resultData200);
            return Promise.resolve<IncidenceEneaPercentageReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidenceEneaPercentageReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_incidence_enea_percentage__item_id__put(item_id: string, body: IncidenceEneaPercentageCreateDTO, cancelToken?: CancelToken): Promise<IncidenceEneaPercentageReadDTO> {
        let url_ = this.baseUrl + "/incidence-enea-percentage/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_incidence_enea_percentage__item_id__put(_response);
        });
    }

    protected processUpdate_item_incidence_enea_percentage__item_id__put(response: AxiosResponse): Promise<IncidenceEneaPercentageReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidenceEneaPercentageReadDTO.fromJS(resultData200);
            return Promise.resolve<IncidenceEneaPercentageReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidenceEneaPercentageReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_incidence_enea_percentage__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/incidence-enea-percentage/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_incidence_enea_percentage__item_id__delete(_response);
        });
    }

    protected processDelete_item_incidence_enea_percentage__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Get By Incidence Enea Id
     * @return Successful Response
     */
    get_by_incidence_enea_id_incidence_enea_percentage_by_incidence_enea__incidence_enea_id__get(incidence_enea_id: string, cancelToken?: CancelToken): Promise<IncidenceEneaPercentageReadDTO[]> {
        let url_ = this.baseUrl + "/incidence-enea-percentage/by_incidence_enea/{incidence_enea_id}";
        if (incidence_enea_id === undefined || incidence_enea_id === null)
            throw new Error("The parameter 'incidence_enea_id' must be defined.");
        url_ = url_.replace("{incidence_enea_id}", encodeURIComponent("" + incidence_enea_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_by_incidence_enea_id_incidence_enea_percentage_by_incidence_enea__incidence_enea_id__get(_response);
        });
    }

    protected processGet_by_incidence_enea_id_incidence_enea_percentage_by_incidence_enea__incidence_enea_id__get(response: AxiosResponse): Promise<IncidenceEneaPercentageReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncidenceEneaPercentageReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IncidenceEneaPercentageReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidenceEneaPercentageReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_incidence_enea_percentage__get( cancelToken?: CancelToken): Promise<DiagnosisIncidenceEneaPercentageReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-incidence-enea-percentage/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_incidence_enea_percentage__get(_response);
        });
    }

    protected processList_items_diagnosis_incidence_enea_percentage__get(response: AxiosResponse): Promise<DiagnosisIncidenceEneaPercentageReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisIncidenceEneaPercentageReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisIncidenceEneaPercentageReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIncidenceEneaPercentageReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_incidence_enea_percentage__post(body: DiagnosisIncidenceEneaPercentageCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisIncidenceEneaPercentageReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-incidence-enea-percentage/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_incidence_enea_percentage__post(_response);
        });
    }

    protected processCreate_item_diagnosis_incidence_enea_percentage__post(response: AxiosResponse): Promise<DiagnosisIncidenceEneaPercentageReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIncidenceEneaPercentageReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIncidenceEneaPercentageReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIncidenceEneaPercentageReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_incidence_enea_percentage__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisIncidenceEneaPercentageReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-incidence-enea-percentage/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_incidence_enea_percentage__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_incidence_enea_percentage__item_id__get(response: AxiosResponse): Promise<DiagnosisIncidenceEneaPercentageReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIncidenceEneaPercentageReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIncidenceEneaPercentageReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIncidenceEneaPercentageReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_incidence_enea_percentage__item_id__put(item_id: string, body: DiagnosisIncidenceEneaPercentageCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisIncidenceEneaPercentageReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-incidence-enea-percentage/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_incidence_enea_percentage__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_incidence_enea_percentage__item_id__put(response: AxiosResponse): Promise<DiagnosisIncidenceEneaPercentageReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisIncidenceEneaPercentageReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisIncidenceEneaPercentageReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIncidenceEneaPercentageReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_incidence_enea_percentage__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-incidence-enea-percentage/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_incidence_enea_percentage__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_incidence_enea_percentage__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Get By Incidence Enea Id
     * @return Successful Response
     */
    get_by_incidence_enea_id_diagnosis_incidence_enea_percentage_by_incidence_enea__incidence_enea_id__get(incidence_enea_id: string, cancelToken?: CancelToken): Promise<DiagnosisIncidenceEneaPercentageReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-incidence-enea-percentage/by_incidence_enea/{incidence_enea_id}";
        if (incidence_enea_id === undefined || incidence_enea_id === null)
            throw new Error("The parameter 'incidence_enea_id' must be defined.");
        url_ = url_.replace("{incidence_enea_id}", encodeURIComponent("" + incidence_enea_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_by_incidence_enea_id_diagnosis_incidence_enea_percentage_by_incidence_enea__incidence_enea_id__get(_response);
        });
    }

    protected processGet_by_incidence_enea_id_diagnosis_incidence_enea_percentage_by_incidence_enea__incidence_enea_id__get(response: AxiosResponse): Promise<DiagnosisIncidenceEneaPercentageReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisIncidenceEneaPercentageReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisIncidenceEneaPercentageReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisIncidenceEneaPercentageReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_consumption_energy_vector_functional_area__get( cancelToken?: CancelToken): Promise<ConsumptionEnergyVectorFunctionalAreaReadDTO[]> {
        let url_ = this.baseUrl + "/consumption-energy-vector-functional-area/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_consumption_energy_vector_functional_area__get(_response);
        });
    }

    protected processList_items_consumption_energy_vector_functional_area__get(response: AxiosResponse): Promise<ConsumptionEnergyVectorFunctionalAreaReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsumptionEnergyVectorFunctionalAreaReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ConsumptionEnergyVectorFunctionalAreaReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumptionEnergyVectorFunctionalAreaReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_consumption_energy_vector_functional_area__post(body: ConsumptionEnergyVectorFunctionalAreaCreateDTO, cancelToken?: CancelToken): Promise<ConsumptionEnergyVectorFunctionalAreaReadDTO> {
        let url_ = this.baseUrl + "/consumption-energy-vector-functional-area/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_consumption_energy_vector_functional_area__post(_response);
        });
    }

    protected processCreate_item_consumption_energy_vector_functional_area__post(response: AxiosResponse): Promise<ConsumptionEnergyVectorFunctionalAreaReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConsumptionEnergyVectorFunctionalAreaReadDTO.fromJS(resultData200);
            return Promise.resolve<ConsumptionEnergyVectorFunctionalAreaReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumptionEnergyVectorFunctionalAreaReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_consumption_energy_vector_functional_area__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<ConsumptionEnergyVectorFunctionalAreaReadDTO> {
        let url_ = this.baseUrl + "/consumption-energy-vector-functional-area/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_consumption_energy_vector_functional_area__item_id__get(_response);
        });
    }

    protected processGet_item_consumption_energy_vector_functional_area__item_id__get(response: AxiosResponse): Promise<ConsumptionEnergyVectorFunctionalAreaReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConsumptionEnergyVectorFunctionalAreaReadDTO.fromJS(resultData200);
            return Promise.resolve<ConsumptionEnergyVectorFunctionalAreaReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumptionEnergyVectorFunctionalAreaReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_consumption_energy_vector_functional_area__item_id__put(item_id: string, body: ConsumptionEnergyVectorFunctionalAreaCreateDTO, cancelToken?: CancelToken): Promise<ConsumptionEnergyVectorFunctionalAreaReadDTO> {
        let url_ = this.baseUrl + "/consumption-energy-vector-functional-area/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_consumption_energy_vector_functional_area__item_id__put(_response);
        });
    }

    protected processUpdate_item_consumption_energy_vector_functional_area__item_id__put(response: AxiosResponse): Promise<ConsumptionEnergyVectorFunctionalAreaReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConsumptionEnergyVectorFunctionalAreaReadDTO.fromJS(resultData200);
            return Promise.resolve<ConsumptionEnergyVectorFunctionalAreaReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumptionEnergyVectorFunctionalAreaReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_consumption_energy_vector_functional_area__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/consumption-energy-vector-functional-area/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_consumption_energy_vector_functional_area__item_id__delete(_response);
        });
    }

    protected processDelete_item_consumption_energy_vector_functional_area__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Get By Energy Vector
     * @return Successful Response
     */
    get_by_energy_vector_consumption_energy_vector_functional_area_by_energy_vector__energy_vector_id__get(energy_vector_id: string, cancelToken?: CancelToken): Promise<ConsumptionEnergyVectorFunctionalAreaReadDTO[]> {
        let url_ = this.baseUrl + "/consumption-energy-vector-functional-area/by-energy-vector/{energy_vector_id}";
        if (energy_vector_id === undefined || energy_vector_id === null)
            throw new Error("The parameter 'energy_vector_id' must be defined.");
        url_ = url_.replace("{energy_vector_id}", encodeURIComponent("" + energy_vector_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_by_energy_vector_consumption_energy_vector_functional_area_by_energy_vector__energy_vector_id__get(_response);
        });
    }

    protected processGet_by_energy_vector_consumption_energy_vector_functional_area_by_energy_vector__energy_vector_id__get(response: AxiosResponse): Promise<ConsumptionEnergyVectorFunctionalAreaReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsumptionEnergyVectorFunctionalAreaReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ConsumptionEnergyVectorFunctionalAreaReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumptionEnergyVectorFunctionalAreaReadDTO[]>(null as any);
    }

    /**
     * Recalculate For Diagnosis
     * @return Successful Response
     */
    recalculate_for_diagnosis_consumption_energy_vector_functional_area_recalculate_for_diagnosis__diagnosis_id__post(diagnosis_id: string, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/consumption-energy-vector-functional-area/recalculate-for-diagnosis/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecalculate_for_diagnosis_consumption_energy_vector_functional_area_recalculate_for_diagnosis__diagnosis_id__post(_response);
        });
    }

    protected processRecalculate_for_diagnosis_consumption_energy_vector_functional_area_recalculate_for_diagnosis__diagnosis_id__post(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_energy_use_settings__get( cancelToken?: CancelToken): Promise<EnergyUseSettingsReadDTO[]> {
        let url_ = this.baseUrl + "/energy-use-settings/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_energy_use_settings__get(_response);
        });
    }

    protected processList_items_energy_use_settings__get(response: AxiosResponse): Promise<EnergyUseSettingsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnergyUseSettingsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EnergyUseSettingsReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyUseSettingsReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_energy_use_settings__post(body: EnergyUseSettingsCreateDTO, cancelToken?: CancelToken): Promise<EnergyUseSettingsReadDTO> {
        let url_ = this.baseUrl + "/energy-use-settings/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_energy_use_settings__post(_response);
        });
    }

    protected processCreate_item_energy_use_settings__post(response: AxiosResponse): Promise<EnergyUseSettingsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnergyUseSettingsReadDTO.fromJS(resultData200);
            return Promise.resolve<EnergyUseSettingsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyUseSettingsReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_energy_use_settings__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<EnergyUseSettingsReadDTO> {
        let url_ = this.baseUrl + "/energy-use-settings/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_energy_use_settings__item_id__get(_response);
        });
    }

    protected processGet_item_energy_use_settings__item_id__get(response: AxiosResponse): Promise<EnergyUseSettingsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnergyUseSettingsReadDTO.fromJS(resultData200);
            return Promise.resolve<EnergyUseSettingsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyUseSettingsReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_energy_use_settings__item_id__put(item_id: string, body: EnergyUseSettingsCreateDTO, cancelToken?: CancelToken): Promise<EnergyUseSettingsReadDTO> {
        let url_ = this.baseUrl + "/energy-use-settings/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_energy_use_settings__item_id__put(_response);
        });
    }

    protected processUpdate_item_energy_use_settings__item_id__put(response: AxiosResponse): Promise<EnergyUseSettingsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnergyUseSettingsReadDTO.fromJS(resultData200);
            return Promise.resolve<EnergyUseSettingsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyUseSettingsReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_energy_use_settings__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/energy-use-settings/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_energy_use_settings__item_id__delete(_response);
        });
    }

    protected processDelete_item_energy_use_settings__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_energy_use_settings__get( cancelToken?: CancelToken): Promise<DiagnosisEnergyUseSettingsReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-settings/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_energy_use_settings__get(_response);
        });
    }

    protected processList_items_diagnosis_energy_use_settings__get(response: AxiosResponse): Promise<DiagnosisEnergyUseSettingsReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisEnergyUseSettingsReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisEnergyUseSettingsReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseSettingsReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_energy_use_settings__post(body: DiagnosisEnergyUseSettingsCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseSettingsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-settings/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_energy_use_settings__post(_response);
        });
    }

    protected processCreate_item_diagnosis_energy_use_settings__post(response: AxiosResponse): Promise<DiagnosisEnergyUseSettingsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyUseSettingsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyUseSettingsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseSettingsReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_energy_use_settings__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseSettingsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-settings/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_energy_use_settings__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_energy_use_settings__item_id__get(response: AxiosResponse): Promise<DiagnosisEnergyUseSettingsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyUseSettingsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyUseSettingsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseSettingsReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_energy_use_settings__item_id__put(item_id: string, body: DiagnosisEnergyUseSettingsCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseSettingsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-settings/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_energy_use_settings__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_energy_use_settings__item_id__put(response: AxiosResponse): Promise<DiagnosisEnergyUseSettingsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyUseSettingsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyUseSettingsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseSettingsReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_energy_use_settings__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-settings/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_energy_use_settings__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_energy_use_settings__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Diagnosis Id
     * @return Successful Response
     */
    search_by_diagnosis_id_diagnosis_energy_use_settings_search_by_diagnosis_id__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseSettingsReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-settings/search_by_diagnosis_id/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_diagnosis_id_diagnosis_energy_use_settings_search_by_diagnosis_id__diagnosis_id__get(_response);
        });
    }

    protected processSearch_by_diagnosis_id_diagnosis_energy_use_settings_search_by_diagnosis_id__diagnosis_id__get(response: AxiosResponse): Promise<DiagnosisEnergyUseSettingsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyUseSettingsReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyUseSettingsReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseSettingsReadDTO>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_energy_use__get( cancelToken?: CancelToken): Promise<EnergyUseReadDTO[]> {
        let url_ = this.baseUrl + "/energy-use/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_energy_use__get(_response);
        });
    }

    protected processList_items_energy_use__get(response: AxiosResponse): Promise<EnergyUseReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnergyUseReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EnergyUseReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyUseReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_energy_use__post(body: EnergyUseCreateDTO, cancelToken?: CancelToken): Promise<EnergyUseReadDTO> {
        let url_ = this.baseUrl + "/energy-use/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_energy_use__post(_response);
        });
    }

    protected processCreate_item_energy_use__post(response: AxiosResponse): Promise<EnergyUseReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnergyUseReadDTO.fromJS(resultData200);
            return Promise.resolve<EnergyUseReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyUseReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_energy_use__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<EnergyUseReadDTO> {
        let url_ = this.baseUrl + "/energy-use/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_energy_use__item_id__get(_response);
        });
    }

    protected processGet_item_energy_use__item_id__get(response: AxiosResponse): Promise<EnergyUseReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnergyUseReadDTO.fromJS(resultData200);
            return Promise.resolve<EnergyUseReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyUseReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_energy_use__item_id__put(item_id: string, body: EnergyUseCreateDTO, cancelToken?: CancelToken): Promise<EnergyUseReadDTO> {
        let url_ = this.baseUrl + "/energy-use/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_energy_use__item_id__put(_response);
        });
    }

    protected processUpdate_item_energy_use__item_id__put(response: AxiosResponse): Promise<EnergyUseReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnergyUseReadDTO.fromJS(resultData200);
            return Promise.resolve<EnergyUseReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnergyUseReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_energy_use__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/energy-use/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_energy_use__item_id__delete(_response);
        });
    }

    protected processDelete_item_energy_use__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_energy_use__get( cancelToken?: CancelToken): Promise<DiagnosisEnergyUseReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-energy-use/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_energy_use__get(_response);
        });
    }

    protected processList_items_diagnosis_energy_use__get(response: AxiosResponse): Promise<DiagnosisEnergyUseReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisEnergyUseReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisEnergyUseReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_energy_use__post(body: DiagnosisEnergyUseCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-use/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_energy_use__post(_response);
        });
    }

    protected processCreate_item_diagnosis_energy_use__post(response: AxiosResponse): Promise<DiagnosisEnergyUseReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyUseReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyUseReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_energy_use__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-use/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_energy_use__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_energy_use__item_id__get(response: AxiosResponse): Promise<DiagnosisEnergyUseReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyUseReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyUseReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_energy_use__item_id__put(item_id: string, body: DiagnosisEnergyUseCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-use/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_energy_use__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_energy_use__item_id__put(response: AxiosResponse): Promise<DiagnosisEnergyUseReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyUseReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyUseReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_energy_use__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-energy-use/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_energy_use__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_energy_use__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Diagnosis Id
     * @return Successful Response
     */
    search_by_diagnosis_id_diagnosis_energy_use_search_by_diagnosis_id__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-energy-use/search_by_diagnosis_id/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_diagnosis_id_diagnosis_energy_use_search_by_diagnosis_id__diagnosis_id__get(_response);
        });
    }

    protected processSearch_by_diagnosis_id_diagnosis_energy_use_search_by_diagnosis_id__diagnosis_id__get(response: AxiosResponse): Promise<DiagnosisEnergyUseReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisEnergyUseReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisEnergyUseReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseReadDTO[]>(null as any);
    }

    /**
     * Copy Energy Use
     * @return Successful Response
     */
    copy_energy_use_diagnosis_energy_use_copy_post(body: CopyEnergyUseDto, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-use/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopy_energy_use_diagnosis_energy_use_copy_post(_response);
        });
    }

    protected processCopy_energy_use_diagnosis_energy_use_copy_post(response: AxiosResponse): Promise<DiagnosisEnergyUseReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyUseReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyUseReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseReadDTO>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_energy_use_vector_data__get( cancelToken?: CancelToken): Promise<DiagnosisEnergyUseVectorDataReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-vector-data/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_energy_use_vector_data__get(_response);
        });
    }

    protected processList_items_diagnosis_energy_use_vector_data__get(response: AxiosResponse): Promise<DiagnosisEnergyUseVectorDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisEnergyUseVectorDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisEnergyUseVectorDataReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseVectorDataReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_energy_use_vector_data__post(body: DiagnosisEnergyUseVectorDataCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseVectorDataReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-vector-data/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_energy_use_vector_data__post(_response);
        });
    }

    protected processCreate_item_diagnosis_energy_use_vector_data__post(response: AxiosResponse): Promise<DiagnosisEnergyUseVectorDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyUseVectorDataReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyUseVectorDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseVectorDataReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_energy_use_vector_data__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseVectorDataReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-vector-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_energy_use_vector_data__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_energy_use_vector_data__item_id__get(response: AxiosResponse): Promise<DiagnosisEnergyUseVectorDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyUseVectorDataReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyUseVectorDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseVectorDataReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_energy_use_vector_data__item_id__put(item_id: string, body: DiagnosisEnergyUseVectorDataCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseVectorDataReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-vector-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_energy_use_vector_data__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_energy_use_vector_data__item_id__put(response: AxiosResponse): Promise<DiagnosisEnergyUseVectorDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyUseVectorDataReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyUseVectorDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseVectorDataReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_energy_use_vector_data__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-vector-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_energy_use_vector_data__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_energy_use_vector_data__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Diagnosis Id
     * @return Successful Response
     */
    search_by_diagnosis_id_diagnosis_energy_use_vector_data_search_by_diagnosis_id__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseVectorDataReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-vector-data/search_by_diagnosis_id/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_diagnosis_id_diagnosis_energy_use_vector_data_search_by_diagnosis_id__diagnosis_id__get(_response);
        });
    }

    protected processSearch_by_diagnosis_id_diagnosis_energy_use_vector_data_search_by_diagnosis_id__diagnosis_id__get(response: AxiosResponse): Promise<DiagnosisEnergyUseVectorDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisEnergyUseVectorDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisEnergyUseVectorDataReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseVectorDataReadDTO[]>(null as any);
    }

    /**
     * Recalculate
     * @return Successful Response
     */
    recalculate_diagnosis_energy_use_vector_data_recalculate_post(body: RecalculateDto, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseVectorDataReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-vector-data/recalculate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecalculate_diagnosis_energy_use_vector_data_recalculate_post(_response);
        });
    }

    protected processRecalculate_diagnosis_energy_use_vector_data_recalculate_post(response: AxiosResponse): Promise<DiagnosisEnergyUseVectorDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisEnergyUseVectorDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisEnergyUseVectorDataReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseVectorDataReadDTO[]>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_diagnosis_energy_use_totals_data__get( cancelToken?: CancelToken): Promise<DiagnosisEnergyUseTotalsDataReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-totals-data/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_diagnosis_energy_use_totals_data__get(_response);
        });
    }

    protected processList_items_diagnosis_energy_use_totals_data__get(response: AxiosResponse): Promise<DiagnosisEnergyUseTotalsDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisEnergyUseTotalsDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisEnergyUseTotalsDataReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseTotalsDataReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_diagnosis_energy_use_totals_data__post(body: DiagnosisEnergyUseTotalsDataCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseTotalsDataReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-totals-data/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_diagnosis_energy_use_totals_data__post(_response);
        });
    }

    protected processCreate_item_diagnosis_energy_use_totals_data__post(response: AxiosResponse): Promise<DiagnosisEnergyUseTotalsDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyUseTotalsDataReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyUseTotalsDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseTotalsDataReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_diagnosis_energy_use_totals_data__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseTotalsDataReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-totals-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_diagnosis_energy_use_totals_data__item_id__get(_response);
        });
    }

    protected processGet_item_diagnosis_energy_use_totals_data__item_id__get(response: AxiosResponse): Promise<DiagnosisEnergyUseTotalsDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyUseTotalsDataReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyUseTotalsDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseTotalsDataReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_diagnosis_energy_use_totals_data__item_id__put(item_id: string, body: DiagnosisEnergyUseTotalsDataCreateDTO, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseTotalsDataReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-totals-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_diagnosis_energy_use_totals_data__item_id__put(_response);
        });
    }

    protected processUpdate_item_diagnosis_energy_use_totals_data__item_id__put(response: AxiosResponse): Promise<DiagnosisEnergyUseTotalsDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyUseTotalsDataReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyUseTotalsDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseTotalsDataReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_diagnosis_energy_use_totals_data__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-totals-data/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_diagnosis_energy_use_totals_data__item_id__delete(_response);
        });
    }

    protected processDelete_item_diagnosis_energy_use_totals_data__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Diagnosis Id
     * @return Successful Response
     */
    search_by_diagnosis_id_diagnosis_energy_use_totals_data_search_by_diagnosis_id__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseTotalsDataReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-totals-data/search_by_diagnosis_id/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_diagnosis_id_diagnosis_energy_use_totals_data_search_by_diagnosis_id__diagnosis_id__get(_response);
        });
    }

    protected processSearch_by_diagnosis_id_diagnosis_energy_use_totals_data_search_by_diagnosis_id__diagnosis_id__get(response: AxiosResponse): Promise<DiagnosisEnergyUseTotalsDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisEnergyUseTotalsDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisEnergyUseTotalsDataReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseTotalsDataReadDTO[]>(null as any);
    }

    /**
     * Recalculate
     * @return Successful Response
     */
    recalculate_diagnosis_energy_use_totals_data_recalculate_post(body: RecalculateDto, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseTotalsDataReadDTO[]> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-totals-data/recalculate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecalculate_diagnosis_energy_use_totals_data_recalculate_post(_response);
        });
    }

    protected processRecalculate_diagnosis_energy_use_totals_data_recalculate_post(response: AxiosResponse): Promise<DiagnosisEnergyUseTotalsDataReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosisEnergyUseTotalsDataReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DiagnosisEnergyUseTotalsDataReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseTotalsDataReadDTO[]>(null as any);
    }

    /**
     * Update User Values
     * @return Successful Response
     */
    update_user_values_diagnosis_energy_use_totals_data__item_id__update_user_values_put(item_id: string, body: UpdateUserValuesDto, cancelToken?: CancelToken): Promise<DiagnosisEnergyUseTotalsDataReadDTO> {
        let url_ = this.baseUrl + "/diagnosis-energy-use-totals-data/{item_id}/update_user_values";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_user_values_diagnosis_energy_use_totals_data__item_id__update_user_values_put(_response);
        });
    }

    protected processUpdate_user_values_diagnosis_energy_use_totals_data__item_id__update_user_values_put(response: AxiosResponse): Promise<DiagnosisEnergyUseTotalsDataReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisEnergyUseTotalsDataReadDTO.fromJS(resultData200);
            return Promise.resolve<DiagnosisEnergyUseTotalsDataReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisEnergyUseTotalsDataReadDTO>(null as any);
    }

    /**
     * List Items
     * @return Successful Response
     */
    list_items_unit_cost_override__get( cancelToken?: CancelToken): Promise<UnitCostOverrideReadDTO[]> {
        let url_ = this.baseUrl + "/unit-cost-override/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList_items_unit_cost_override__get(_response);
        });
    }

    protected processList_items_unit_cost_override__get(response: AxiosResponse): Promise<UnitCostOverrideReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitCostOverrideReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UnitCostOverrideReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitCostOverrideReadDTO[]>(null as any);
    }

    /**
     * Create Item
     * @return Successful Response
     */
    create_item_unit_cost_override__post(body: UnitCostOverrideCreateDTO, cancelToken?: CancelToken): Promise<UnitCostOverrideReadDTO> {
        let url_ = this.baseUrl + "/unit-cost-override/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate_item_unit_cost_override__post(_response);
        });
    }

    protected processCreate_item_unit_cost_override__post(response: AxiosResponse): Promise<UnitCostOverrideReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UnitCostOverrideReadDTO.fromJS(resultData200);
            return Promise.resolve<UnitCostOverrideReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitCostOverrideReadDTO>(null as any);
    }

    /**
     * Get Item
     * @return Successful Response
     */
    get_item_unit_cost_override__item_id__get(item_id: string, cancelToken?: CancelToken): Promise<UnitCostOverrideReadDTO> {
        let url_ = this.baseUrl + "/unit-cost-override/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_item_unit_cost_override__item_id__get(_response);
        });
    }

    protected processGet_item_unit_cost_override__item_id__get(response: AxiosResponse): Promise<UnitCostOverrideReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UnitCostOverrideReadDTO.fromJS(resultData200);
            return Promise.resolve<UnitCostOverrideReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitCostOverrideReadDTO>(null as any);
    }

    /**
     * Update Item
     * @return Successful Response
     */
    update_item_unit_cost_override__item_id__put(item_id: string, body: UnitCostOverrideCreateDTO, cancelToken?: CancelToken): Promise<UnitCostOverrideReadDTO> {
        let url_ = this.baseUrl + "/unit-cost-override/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate_item_unit_cost_override__item_id__put(_response);
        });
    }

    protected processUpdate_item_unit_cost_override__item_id__put(response: AxiosResponse): Promise<UnitCostOverrideReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UnitCostOverrideReadDTO.fromJS(resultData200);
            return Promise.resolve<UnitCostOverrideReadDTO>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitCostOverrideReadDTO>(null as any);
    }

    /**
     * Delete Item
     * @return Successful Response
     */
    delete_item_unit_cost_override__item_id__delete(item_id: string, cancelToken?: CancelToken): Promise<DeleteStatusResponse> {
        let url_ = this.baseUrl + "/unit-cost-override/{item_id}";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_item_unit_cost_override__item_id__delete(_response);
        });
    }

    protected processDelete_item_unit_cost_override__item_id__delete(response: AxiosResponse): Promise<DeleteStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStatusResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStatusResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStatusResponse>(null as any);
    }

    /**
     * Search By Diagnosis Id
     * @return Successful Response
     */
    search_by_diagnosis_id_unit_cost_override_search_by_diagnosis_id__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<UnitCostOverrideReadDTO[]> {
        let url_ = this.baseUrl + "/unit-cost-override/search_by_diagnosis_id/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_by_diagnosis_id_unit_cost_override_search_by_diagnosis_id__diagnosis_id__get(_response);
        });
    }

    protected processSearch_by_diagnosis_id_unit_cost_override_search_by_diagnosis_id__diagnosis_id__get(response: AxiosResponse): Promise<UnitCostOverrideReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitCostOverrideReadDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UnitCostOverrideReadDTO[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitCostOverrideReadDTO[]>(null as any);
    }

    /**
     * Get Final Checks
     * @return Successful Response
     */
    get_final_checks_diagnosis_close_export__diagnosis_id__final_checks_get(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisChecklistResponse> {
        let url_ = this.baseUrl + "/diagnosis-close-export/{diagnosis_id}/final-checks";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_final_checks_diagnosis_close_export__diagnosis_id__final_checks_get(_response);
        });
    }

    protected processGet_final_checks_diagnosis_close_export__diagnosis_id__final_checks_get(response: AxiosResponse): Promise<DiagnosisChecklistResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisChecklistResponse.fromJS(resultData200);
            return Promise.resolve<DiagnosisChecklistResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisChecklistResponse>(null as any);
    }

    /**
     * Get Required Fields Checklist
     * @return Successful Response
     */
    get_required_fields_checklist_diagnosis_close_export__diagnosis_id__required_fields_checklist_get(diagnosis_id: string, cancelToken?: CancelToken): Promise<DiagnosisChecklistResponse> {
        let url_ = this.baseUrl + "/diagnosis-close-export/{diagnosis_id}/required-fields-checklist";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_required_fields_checklist_diagnosis_close_export__diagnosis_id__required_fields_checklist_get(_response);
        });
    }

    protected processGet_required_fields_checklist_diagnosis_close_export__diagnosis_id__required_fields_checklist_get(response: AxiosResponse): Promise<DiagnosisChecklistResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosisChecklistResponse.fromJS(resultData200);
            return Promise.resolve<DiagnosisChecklistResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosisChecklistResponse>(null as any);
    }

    /**
     * Genera la descrizione del processo produttivo dello stabilimento
     * @return Successful Response
     */
    process_description_ai_process_description__diagnosis_id__get(diagnosis_id: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/ai/process-description/{diagnosis_id}";
        if (diagnosis_id === undefined || diagnosis_id === null)
            throw new Error("The parameter 'diagnosis_id' must be defined.");
        url_ = url_.replace("{diagnosis_id}", encodeURIComponent("" + diagnosis_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcess_description_ai_process_description__diagnosis_id__get(_response);
        });
    }

    protected processProcess_description_ai_process_description__diagnosis_id__get(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Recommend items for a diagnosis
     * @return Successful Response
     */
    recommender_ai_recommender_post(body: RecommenderRequest, cancelToken?: CancelToken): Promise<SearchResultItem[]> {
        let url_ = this.baseUrl + "/ai/recommender";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecommender_ai_recommender_post(_response);
        });
    }

    protected processRecommender_ai_recommender_post(response: AxiosResponse): Promise<SearchResultItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchResultItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SearchResultItem[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchResultItem[]>(null as any);
    }

    /**
     * Free-text search for items
     * @return Successful Response
     */
    search_ai_search_post(body: SearchRequest, cancelToken?: CancelToken): Promise<SearchResultItem[]> {
        let url_ = this.baseUrl + "/ai/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch_ai_search_post(_response);
        });
    }

    protected processSearch_ai_search_post(response: AxiosResponse): Promise<SearchResultItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchResultItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SearchResultItem[]>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchResultItem[]>(null as any);
    }

    /**
     * Record user feedback on a search result
     * @return Successful Response
     */
    feedback_ai_feedback_post(body: FeedbackRequest, cancelToken?: CancelToken): Promise<FeedbackResponse> {
        let url_ = this.baseUrl + "/ai/feedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFeedback_ai_feedback_post(_response);
        });
    }

    protected processFeedback_ai_feedback_post(response: AxiosResponse): Promise<FeedbackResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeedbackResponse.fromJS(resultData200);
            return Promise.resolve<FeedbackResponse>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeedbackResponse>(null as any);
    }

    /**
     * Health Live
     * @return Successful Response
     */
    health_live_health_live_get( cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/health/live";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHealth_live_health_live_get(_response);
        });
    }

    protected processHealth_live_health_live_get(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Health Check
     * @return Successful Response
     */
    health_check_health_get( cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHealth_check_health_get(_response);
        });
    }

    protected processHealth_check_health_get(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Root
     * @return Successful Response
     */
    root__get( cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoot__get(_response);
        });
    }

    protected processRoot__get(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export class APILogCreateDTO implements IAPILogCreateDTO {
    endpoint?: string | undefined;
    method?: string | undefined;
    timestamp?: string | undefined;
    response_time?: number | undefined;

    constructor(data?: IAPILogCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endpoint = _data["endpoint"];
            this.method = _data["method"];
            this.timestamp = _data["timestamp"];
            this.response_time = _data["response_time"];
        }
    }

    static fromJS(data: any): APILogCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APILogCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endpoint"] = this.endpoint;
        data["method"] = this.method;
        data["timestamp"] = this.timestamp;
        data["response_time"] = this.response_time;
        return data;
    }
}

export interface IAPILogCreateDTO {
    endpoint?: string | undefined;
    method?: string | undefined;
    timestamp?: string | undefined;
    response_time?: number | undefined;
}

export class APILogReadDTO implements IAPILogReadDTO {
    endpoint?: string | undefined;
    method?: string | undefined;
    timestamp?: string | undefined;
    response_time?: number | undefined;
    id?: string;

    constructor(data?: IAPILogReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endpoint = _data["endpoint"];
            this.method = _data["method"];
            this.timestamp = _data["timestamp"];
            this.response_time = _data["response_time"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): APILogReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APILogReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endpoint"] = this.endpoint;
        data["method"] = this.method;
        data["timestamp"] = this.timestamp;
        data["response_time"] = this.response_time;
        data["id"] = this.id;
        return data;
    }
}

export interface IAPILogReadDTO {
    endpoint?: string | undefined;
    method?: string | undefined;
    timestamp?: string | undefined;
    response_time?: number | undefined;
    id?: string;
}

export class AcceptInviteRequest implements IAcceptInviteRequest {
    token!: string;
    password!: string;
    password_confirm!: string;
    firstname!: string;
    lastname!: string;

    constructor(data?: IAcceptInviteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.password = _data["password"];
            this.password_confirm = _data["password_confirm"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
        }
    }

    static fromJS(data: any): AcceptInviteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptInviteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["password"] = this.password;
        data["password_confirm"] = this.password_confirm;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        return data;
    }
}

export interface IAcceptInviteRequest {
    token: string;
    password: string;
    password_confirm: string;
    firstname: string;
    lastname: string;
}

export class BatchMetersDataRequest implements IBatchMetersDataRequest {
    items!: MetersDataBatchItem[];

    constructor(data?: IBatchMetersDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MetersDataBatchItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchMetersDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatchMetersDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatchMetersDataRequest {
    items: MetersDataBatchItem[];
}

export class BatchPodTimetablesDataRequest implements IBatchPodTimetablesDataRequest {
    items!: PodTimetablesDataBatchItem[];

    constructor(data?: IBatchPodTimetablesDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PodTimetablesDataBatchItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchPodTimetablesDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatchPodTimetablesDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatchPodTimetablesDataRequest {
    items: PodTimetablesDataBatchItem[];
}

export class BatchSaveResponse implements IBatchSaveResponse {
    status?: string;

    constructor(data?: IBatchSaveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.status = "success";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : "success";
        }
    }

    static fromJS(data: any): BatchSaveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BatchSaveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface IBatchSaveResponse {
    status?: string;
}

export class BatchVariablesDataRequest implements IBatchVariablesDataRequest {
    items!: VariablesDataBatchItem[];

    constructor(data?: IBatchVariablesDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VariablesDataBatchItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchVariablesDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatchVariablesDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatchVariablesDataRequest {
    items: VariablesDataBatchItem[];
}

export class Body_import_excel_census_code_a_import_excel__vector_id__post implements IBody_import_excel_census_code_a_import_excel__vector_id__post {
    file!: string;

    [key: string]: any;

    constructor(data?: IBody_import_excel_census_code_a_import_excel__vector_id__post) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): Body_import_excel_census_code_a_import_excel__vector_id__post {
        data = typeof data === 'object' ? data : {};
        let result = new Body_import_excel_census_code_a_import_excel__vector_id__post();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        return data;
    }
}

export interface IBody_import_excel_census_code_a_import_excel__vector_id__post {
    file: string;

    [key: string]: any;
}

export class Body_import_excel_census_code_b_import_excel__vector_id__post implements IBody_import_excel_census_code_b_import_excel__vector_id__post {
    file!: string;

    [key: string]: any;

    constructor(data?: IBody_import_excel_census_code_b_import_excel__vector_id__post) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): Body_import_excel_census_code_b_import_excel__vector_id__post {
        data = typeof data === 'object' ? data : {};
        let result = new Body_import_excel_census_code_b_import_excel__vector_id__post();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        return data;
    }
}

export interface IBody_import_excel_census_code_b_import_excel__vector_id__post {
    file: string;

    [key: string]: any;
}

export class Body_import_excel_census_code_c_import_excel__vector_id__post implements IBody_import_excel_census_code_c_import_excel__vector_id__post {
    file!: string;

    [key: string]: any;

    constructor(data?: IBody_import_excel_census_code_c_import_excel__vector_id__post) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): Body_import_excel_census_code_c_import_excel__vector_id__post {
        data = typeof data === 'object' ? data : {};
        let result = new Body_import_excel_census_code_c_import_excel__vector_id__post();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        return data;
    }
}

export interface IBody_import_excel_census_code_c_import_excel__vector_id__post {
    file: string;

    [key: string]: any;
}

/** DTO per creare CensusCommonData + CensusCodeA */
export class CensusCodeACreateDTO implements ICensusCodeACreateDTO {
    vector_id!: string;
    code?: string | undefined;
    quantity?: number | undefined;
    utility?: string | undefined;
    department?: string | undefined;
    index?: number | undefined;
    macro_utility?: string | undefined;
    functional_area?: string | undefined;
    energy_use_id?: string | undefined;
    technology?: string | undefined;
    power_rating_kw?: number | undefined;
    total_power_rating_kw?: number | undefined;
    installation_year?: string | undefined;
    hours_per_year?: number | undefined;
    fcu_fc?: number | undefined;
    annual_consumption_kwha?: number | undefined;
    annual_consumption_percentage?: number | undefined;
    annual_cost?: number | undefined;
    data_accuracy?: string | undefined;
    monitoring_system_asis_id?: string | undefined;
    monitoring_system_tobe_id?: string | undefined;
    notes?: string | undefined;
    current_rating_a?: number | undefined;
    voltage_rating_v?: number | undefined;
    cos_phi?: number | undefined;
    regulation_system?: string | undefined;

    constructor(data?: ICensusCodeACreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vector_id = _data["vector_id"];
            this.code = _data["code"];
            this.quantity = _data["quantity"];
            this.utility = _data["utility"];
            this.department = _data["department"];
            this.index = _data["index"];
            this.macro_utility = _data["macro_utility"];
            this.functional_area = _data["functional_area"];
            this.energy_use_id = _data["energy_use_id"];
            this.technology = _data["technology"];
            this.power_rating_kw = _data["power_rating_kw"];
            this.total_power_rating_kw = _data["total_power_rating_kw"];
            this.installation_year = _data["installation_year"];
            this.hours_per_year = _data["hours_per_year"];
            this.fcu_fc = _data["fcu_fc"];
            this.annual_consumption_kwha = _data["annual_consumption_kwha"];
            this.annual_consumption_percentage = _data["annual_consumption_percentage"];
            this.annual_cost = _data["annual_cost"];
            this.data_accuracy = _data["data_accuracy"];
            this.monitoring_system_asis_id = _data["monitoring_system_asis_id"];
            this.monitoring_system_tobe_id = _data["monitoring_system_tobe_id"];
            this.notes = _data["notes"];
            this.current_rating_a = _data["current_rating_a"];
            this.voltage_rating_v = _data["voltage_rating_v"];
            this.cos_phi = _data["cos_phi"];
            this.regulation_system = _data["regulation_system"];
        }
    }

    static fromJS(data: any): CensusCodeACreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CensusCodeACreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vector_id"] = this.vector_id;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        data["utility"] = this.utility;
        data["department"] = this.department;
        data["index"] = this.index;
        data["macro_utility"] = this.macro_utility;
        data["functional_area"] = this.functional_area;
        data["energy_use_id"] = this.energy_use_id;
        data["technology"] = this.technology;
        data["power_rating_kw"] = this.power_rating_kw;
        data["total_power_rating_kw"] = this.total_power_rating_kw;
        data["installation_year"] = this.installation_year;
        data["hours_per_year"] = this.hours_per_year;
        data["fcu_fc"] = this.fcu_fc;
        data["annual_consumption_kwha"] = this.annual_consumption_kwha;
        data["annual_consumption_percentage"] = this.annual_consumption_percentage;
        data["annual_cost"] = this.annual_cost;
        data["data_accuracy"] = this.data_accuracy;
        data["monitoring_system_asis_id"] = this.monitoring_system_asis_id;
        data["monitoring_system_tobe_id"] = this.monitoring_system_tobe_id;
        data["notes"] = this.notes;
        data["current_rating_a"] = this.current_rating_a;
        data["voltage_rating_v"] = this.voltage_rating_v;
        data["cos_phi"] = this.cos_phi;
        data["regulation_system"] = this.regulation_system;
        return data;
    }
}

/** DTO per creare CensusCommonData + CensusCodeA */
export interface ICensusCodeACreateDTO {
    vector_id: string;
    code?: string | undefined;
    quantity?: number | undefined;
    utility?: string | undefined;
    department?: string | undefined;
    index?: number | undefined;
    macro_utility?: string | undefined;
    functional_area?: string | undefined;
    energy_use_id?: string | undefined;
    technology?: string | undefined;
    power_rating_kw?: number | undefined;
    total_power_rating_kw?: number | undefined;
    installation_year?: string | undefined;
    hours_per_year?: number | undefined;
    fcu_fc?: number | undefined;
    annual_consumption_kwha?: number | undefined;
    annual_consumption_percentage?: number | undefined;
    annual_cost?: number | undefined;
    data_accuracy?: string | undefined;
    monitoring_system_asis_id?: string | undefined;
    monitoring_system_tobe_id?: string | undefined;
    notes?: string | undefined;
    current_rating_a?: number | undefined;
    voltage_rating_v?: number | undefined;
    cos_phi?: number | undefined;
    regulation_system?: string | undefined;
}

/** DTO per leggere CensusCommonData + CensusCodeA */
export class CensusCodeAReadDTO implements ICensusCodeAReadDTO {
    id!: string;
    vector_id!: string;
    code?: string | undefined;
    quantity?: number | undefined;
    utility?: string | undefined;
    department?: string | undefined;
    index?: number | undefined;
    macro_utility?: string | undefined;
    functional_area?: string | undefined;
    energy_use_id?: string | undefined;
    technology?: string | undefined;
    power_rating_kw?: number | undefined;
    total_power_rating_kw?: number | undefined;
    installation_year?: string | undefined;
    hours_per_year?: number | undefined;
    fcu_fc?: number | undefined;
    annual_consumption_kwha?: number | undefined;
    annual_consumption_percentage?: number | undefined;
    annual_cost?: number | undefined;
    data_accuracy?: string | undefined;
    data_grouping?: string | undefined;
    monitoring_system_asis_id?: string | undefined;
    monitoring_system_tobe_id?: string | undefined;
    notes?: string | undefined;
    current_rating_a?: number | undefined;
    voltage_rating_v?: number | undefined;
    cos_phi?: number | undefined;
    regulation_system?: string | undefined;

    constructor(data?: ICensusCodeAReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vector_id = _data["vector_id"];
            this.code = _data["code"];
            this.quantity = _data["quantity"];
            this.utility = _data["utility"];
            this.department = _data["department"];
            this.index = _data["index"];
            this.macro_utility = _data["macro_utility"];
            this.functional_area = _data["functional_area"];
            this.energy_use_id = _data["energy_use_id"];
            this.technology = _data["technology"];
            this.power_rating_kw = _data["power_rating_kw"];
            this.total_power_rating_kw = _data["total_power_rating_kw"];
            this.installation_year = _data["installation_year"];
            this.hours_per_year = _data["hours_per_year"];
            this.fcu_fc = _data["fcu_fc"];
            this.annual_consumption_kwha = _data["annual_consumption_kwha"];
            this.annual_consumption_percentage = _data["annual_consumption_percentage"];
            this.annual_cost = _data["annual_cost"];
            this.data_accuracy = _data["data_accuracy"];
            this.data_grouping = _data["data_grouping"];
            this.monitoring_system_asis_id = _data["monitoring_system_asis_id"];
            this.monitoring_system_tobe_id = _data["monitoring_system_tobe_id"];
            this.notes = _data["notes"];
            this.current_rating_a = _data["current_rating_a"];
            this.voltage_rating_v = _data["voltage_rating_v"];
            this.cos_phi = _data["cos_phi"];
            this.regulation_system = _data["regulation_system"];
        }
    }

    static fromJS(data: any): CensusCodeAReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CensusCodeAReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vector_id"] = this.vector_id;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        data["utility"] = this.utility;
        data["department"] = this.department;
        data["index"] = this.index;
        data["macro_utility"] = this.macro_utility;
        data["functional_area"] = this.functional_area;
        data["energy_use_id"] = this.energy_use_id;
        data["technology"] = this.technology;
        data["power_rating_kw"] = this.power_rating_kw;
        data["total_power_rating_kw"] = this.total_power_rating_kw;
        data["installation_year"] = this.installation_year;
        data["hours_per_year"] = this.hours_per_year;
        data["fcu_fc"] = this.fcu_fc;
        data["annual_consumption_kwha"] = this.annual_consumption_kwha;
        data["annual_consumption_percentage"] = this.annual_consumption_percentage;
        data["annual_cost"] = this.annual_cost;
        data["data_accuracy"] = this.data_accuracy;
        data["data_grouping"] = this.data_grouping;
        data["monitoring_system_asis_id"] = this.monitoring_system_asis_id;
        data["monitoring_system_tobe_id"] = this.monitoring_system_tobe_id;
        data["notes"] = this.notes;
        data["current_rating_a"] = this.current_rating_a;
        data["voltage_rating_v"] = this.voltage_rating_v;
        data["cos_phi"] = this.cos_phi;
        data["regulation_system"] = this.regulation_system;
        return data;
    }
}

/** DTO per leggere CensusCommonData + CensusCodeA */
export interface ICensusCodeAReadDTO {
    id: string;
    vector_id: string;
    code?: string | undefined;
    quantity?: number | undefined;
    utility?: string | undefined;
    department?: string | undefined;
    index?: number | undefined;
    macro_utility?: string | undefined;
    functional_area?: string | undefined;
    energy_use_id?: string | undefined;
    technology?: string | undefined;
    power_rating_kw?: number | undefined;
    total_power_rating_kw?: number | undefined;
    installation_year?: string | undefined;
    hours_per_year?: number | undefined;
    fcu_fc?: number | undefined;
    annual_consumption_kwha?: number | undefined;
    annual_consumption_percentage?: number | undefined;
    annual_cost?: number | undefined;
    data_accuracy?: string | undefined;
    data_grouping?: string | undefined;
    monitoring_system_asis_id?: string | undefined;
    monitoring_system_tobe_id?: string | undefined;
    notes?: string | undefined;
    current_rating_a?: number | undefined;
    voltage_rating_v?: number | undefined;
    cos_phi?: number | undefined;
    regulation_system?: string | undefined;
}

/** DTO per creare CensusCommonData + CensusCodeB */
export class CensusCodeBCreateDTO implements ICensusCodeBCreateDTO {
    vector_id!: string;
    code?: string | undefined;
    quantity?: number | undefined;
    utility?: string | undefined;
    department?: string | undefined;
    index?: number | undefined;
    macro_utility?: string | undefined;
    functional_area?: string | undefined;
    energy_use_id?: string | undefined;
    technology?: string | undefined;
    power_rating_kw?: number | undefined;
    total_power_rating_kw?: number | undefined;
    installation_year?: string | undefined;
    hours_per_year?: number | undefined;
    fcu_fc?: number | undefined;
    annual_consumption_kwha?: number | undefined;
    annual_consumption_percentage?: number | undefined;
    annual_cost?: number | undefined;
    data_accuracy?: string | undefined;
    monitoring_system_asis_id?: string | undefined;
    monitoring_system_tobe_id?: string | undefined;
    notes?: string | undefined;
    efficiency?: number | undefined;
    annual_consumption_sm3a?: number | undefined;

    constructor(data?: ICensusCodeBCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vector_id = _data["vector_id"];
            this.code = _data["code"];
            this.quantity = _data["quantity"];
            this.utility = _data["utility"];
            this.department = _data["department"];
            this.index = _data["index"];
            this.macro_utility = _data["macro_utility"];
            this.functional_area = _data["functional_area"];
            this.energy_use_id = _data["energy_use_id"];
            this.technology = _data["technology"];
            this.power_rating_kw = _data["power_rating_kw"];
            this.total_power_rating_kw = _data["total_power_rating_kw"];
            this.installation_year = _data["installation_year"];
            this.hours_per_year = _data["hours_per_year"];
            this.fcu_fc = _data["fcu_fc"];
            this.annual_consumption_kwha = _data["annual_consumption_kwha"];
            this.annual_consumption_percentage = _data["annual_consumption_percentage"];
            this.annual_cost = _data["annual_cost"];
            this.data_accuracy = _data["data_accuracy"];
            this.monitoring_system_asis_id = _data["monitoring_system_asis_id"];
            this.monitoring_system_tobe_id = _data["monitoring_system_tobe_id"];
            this.notes = _data["notes"];
            this.efficiency = _data["efficiency"];
            this.annual_consumption_sm3a = _data["annual_consumption_sm3a"];
        }
    }

    static fromJS(data: any): CensusCodeBCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CensusCodeBCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vector_id"] = this.vector_id;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        data["utility"] = this.utility;
        data["department"] = this.department;
        data["index"] = this.index;
        data["macro_utility"] = this.macro_utility;
        data["functional_area"] = this.functional_area;
        data["energy_use_id"] = this.energy_use_id;
        data["technology"] = this.technology;
        data["power_rating_kw"] = this.power_rating_kw;
        data["total_power_rating_kw"] = this.total_power_rating_kw;
        data["installation_year"] = this.installation_year;
        data["hours_per_year"] = this.hours_per_year;
        data["fcu_fc"] = this.fcu_fc;
        data["annual_consumption_kwha"] = this.annual_consumption_kwha;
        data["annual_consumption_percentage"] = this.annual_consumption_percentage;
        data["annual_cost"] = this.annual_cost;
        data["data_accuracy"] = this.data_accuracy;
        data["monitoring_system_asis_id"] = this.monitoring_system_asis_id;
        data["monitoring_system_tobe_id"] = this.monitoring_system_tobe_id;
        data["notes"] = this.notes;
        data["efficiency"] = this.efficiency;
        data["annual_consumption_sm3a"] = this.annual_consumption_sm3a;
        return data;
    }
}

/** DTO per creare CensusCommonData + CensusCodeB */
export interface ICensusCodeBCreateDTO {
    vector_id: string;
    code?: string | undefined;
    quantity?: number | undefined;
    utility?: string | undefined;
    department?: string | undefined;
    index?: number | undefined;
    macro_utility?: string | undefined;
    functional_area?: string | undefined;
    energy_use_id?: string | undefined;
    technology?: string | undefined;
    power_rating_kw?: number | undefined;
    total_power_rating_kw?: number | undefined;
    installation_year?: string | undefined;
    hours_per_year?: number | undefined;
    fcu_fc?: number | undefined;
    annual_consumption_kwha?: number | undefined;
    annual_consumption_percentage?: number | undefined;
    annual_cost?: number | undefined;
    data_accuracy?: string | undefined;
    monitoring_system_asis_id?: string | undefined;
    monitoring_system_tobe_id?: string | undefined;
    notes?: string | undefined;
    efficiency?: number | undefined;
    annual_consumption_sm3a?: number | undefined;
}

/** DTO per leggere CensusCommonData + CensusCodeB */
export class CensusCodeBReadDTO implements ICensusCodeBReadDTO {
    id!: string;
    vector_id!: string;
    code?: string | undefined;
    quantity?: number | undefined;
    utility?: string | undefined;
    department?: string | undefined;
    index?: number | undefined;
    macro_utility?: string | undefined;
    functional_area?: string | undefined;
    energy_use_id?: string | undefined;
    technology?: string | undefined;
    power_rating_kw?: number | undefined;
    total_power_rating_kw?: number | undefined;
    installation_year?: string | undefined;
    hours_per_year?: number | undefined;
    fcu_fc?: number | undefined;
    annual_consumption_kwha?: number | undefined;
    annual_consumption_percentage?: number | undefined;
    annual_cost?: number | undefined;
    data_accuracy?: string | undefined;
    data_grouping?: string | undefined;
    monitoring_system_asis_id?: string | undefined;
    monitoring_system_tobe_id?: string | undefined;
    notes?: string | undefined;
    efficiency?: number | undefined;
    annual_consumption_sm3a?: number | undefined;

    constructor(data?: ICensusCodeBReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vector_id = _data["vector_id"];
            this.code = _data["code"];
            this.quantity = _data["quantity"];
            this.utility = _data["utility"];
            this.department = _data["department"];
            this.index = _data["index"];
            this.macro_utility = _data["macro_utility"];
            this.functional_area = _data["functional_area"];
            this.energy_use_id = _data["energy_use_id"];
            this.technology = _data["technology"];
            this.power_rating_kw = _data["power_rating_kw"];
            this.total_power_rating_kw = _data["total_power_rating_kw"];
            this.installation_year = _data["installation_year"];
            this.hours_per_year = _data["hours_per_year"];
            this.fcu_fc = _data["fcu_fc"];
            this.annual_consumption_kwha = _data["annual_consumption_kwha"];
            this.annual_consumption_percentage = _data["annual_consumption_percentage"];
            this.annual_cost = _data["annual_cost"];
            this.data_accuracy = _data["data_accuracy"];
            this.data_grouping = _data["data_grouping"];
            this.monitoring_system_asis_id = _data["monitoring_system_asis_id"];
            this.monitoring_system_tobe_id = _data["monitoring_system_tobe_id"];
            this.notes = _data["notes"];
            this.efficiency = _data["efficiency"];
            this.annual_consumption_sm3a = _data["annual_consumption_sm3a"];
        }
    }

    static fromJS(data: any): CensusCodeBReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CensusCodeBReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vector_id"] = this.vector_id;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        data["utility"] = this.utility;
        data["department"] = this.department;
        data["index"] = this.index;
        data["macro_utility"] = this.macro_utility;
        data["functional_area"] = this.functional_area;
        data["energy_use_id"] = this.energy_use_id;
        data["technology"] = this.technology;
        data["power_rating_kw"] = this.power_rating_kw;
        data["total_power_rating_kw"] = this.total_power_rating_kw;
        data["installation_year"] = this.installation_year;
        data["hours_per_year"] = this.hours_per_year;
        data["fcu_fc"] = this.fcu_fc;
        data["annual_consumption_kwha"] = this.annual_consumption_kwha;
        data["annual_consumption_percentage"] = this.annual_consumption_percentage;
        data["annual_cost"] = this.annual_cost;
        data["data_accuracy"] = this.data_accuracy;
        data["data_grouping"] = this.data_grouping;
        data["monitoring_system_asis_id"] = this.monitoring_system_asis_id;
        data["monitoring_system_tobe_id"] = this.monitoring_system_tobe_id;
        data["notes"] = this.notes;
        data["efficiency"] = this.efficiency;
        data["annual_consumption_sm3a"] = this.annual_consumption_sm3a;
        return data;
    }
}

/** DTO per leggere CensusCommonData + CensusCodeB */
export interface ICensusCodeBReadDTO {
    id: string;
    vector_id: string;
    code?: string | undefined;
    quantity?: number | undefined;
    utility?: string | undefined;
    department?: string | undefined;
    index?: number | undefined;
    macro_utility?: string | undefined;
    functional_area?: string | undefined;
    energy_use_id?: string | undefined;
    technology?: string | undefined;
    power_rating_kw?: number | undefined;
    total_power_rating_kw?: number | undefined;
    installation_year?: string | undefined;
    hours_per_year?: number | undefined;
    fcu_fc?: number | undefined;
    annual_consumption_kwha?: number | undefined;
    annual_consumption_percentage?: number | undefined;
    annual_cost?: number | undefined;
    data_accuracy?: string | undefined;
    data_grouping?: string | undefined;
    monitoring_system_asis_id?: string | undefined;
    monitoring_system_tobe_id?: string | undefined;
    notes?: string | undefined;
    efficiency?: number | undefined;
    annual_consumption_sm3a?: number | undefined;
}

/** DTO per creare CensusCommonData + CensusCodeC */
export class CensusCodeCCreateDTO implements ICensusCodeCCreateDTO {
    vector_id!: string;
    code?: string | undefined;
    quantity?: number | undefined;
    utility?: string | undefined;
    department?: string | undefined;
    index?: number | undefined;
    macro_utility?: string | undefined;
    functional_area?: string | undefined;
    energy_use_id?: string | undefined;
    technology?: string | undefined;
    power_rating_kw?: number | undefined;
    total_power_rating_kw?: number | undefined;
    installation_year?: string | undefined;
    hours_per_year?: number | undefined;
    fcu_fc?: number | undefined;
    annual_consumption_kwha?: number | undefined;
    annual_consumption_percentage?: number | undefined;
    annual_cost?: number | undefined;
    data_accuracy?: string | undefined;
    monitoring_system_asis_id?: string | undefined;
    monitoring_system_tobe_id?: string | undefined;
    notes?: string | undefined;
    efficiency?: number | undefined;
    annual_consumption_liters?: number | undefined;

    constructor(data?: ICensusCodeCCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vector_id = _data["vector_id"];
            this.code = _data["code"];
            this.quantity = _data["quantity"];
            this.utility = _data["utility"];
            this.department = _data["department"];
            this.index = _data["index"];
            this.macro_utility = _data["macro_utility"];
            this.functional_area = _data["functional_area"];
            this.energy_use_id = _data["energy_use_id"];
            this.technology = _data["technology"];
            this.power_rating_kw = _data["power_rating_kw"];
            this.total_power_rating_kw = _data["total_power_rating_kw"];
            this.installation_year = _data["installation_year"];
            this.hours_per_year = _data["hours_per_year"];
            this.fcu_fc = _data["fcu_fc"];
            this.annual_consumption_kwha = _data["annual_consumption_kwha"];
            this.annual_consumption_percentage = _data["annual_consumption_percentage"];
            this.annual_cost = _data["annual_cost"];
            this.data_accuracy = _data["data_accuracy"];
            this.monitoring_system_asis_id = _data["monitoring_system_asis_id"];
            this.monitoring_system_tobe_id = _data["monitoring_system_tobe_id"];
            this.notes = _data["notes"];
            this.efficiency = _data["efficiency"];
            this.annual_consumption_liters = _data["annual_consumption_liters"];
        }
    }

    static fromJS(data: any): CensusCodeCCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CensusCodeCCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vector_id"] = this.vector_id;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        data["utility"] = this.utility;
        data["department"] = this.department;
        data["index"] = this.index;
        data["macro_utility"] = this.macro_utility;
        data["functional_area"] = this.functional_area;
        data["energy_use_id"] = this.energy_use_id;
        data["technology"] = this.technology;
        data["power_rating_kw"] = this.power_rating_kw;
        data["total_power_rating_kw"] = this.total_power_rating_kw;
        data["installation_year"] = this.installation_year;
        data["hours_per_year"] = this.hours_per_year;
        data["fcu_fc"] = this.fcu_fc;
        data["annual_consumption_kwha"] = this.annual_consumption_kwha;
        data["annual_consumption_percentage"] = this.annual_consumption_percentage;
        data["annual_cost"] = this.annual_cost;
        data["data_accuracy"] = this.data_accuracy;
        data["monitoring_system_asis_id"] = this.monitoring_system_asis_id;
        data["monitoring_system_tobe_id"] = this.monitoring_system_tobe_id;
        data["notes"] = this.notes;
        data["efficiency"] = this.efficiency;
        data["annual_consumption_liters"] = this.annual_consumption_liters;
        return data;
    }
}

/** DTO per creare CensusCommonData + CensusCodeC */
export interface ICensusCodeCCreateDTO {
    vector_id: string;
    code?: string | undefined;
    quantity?: number | undefined;
    utility?: string | undefined;
    department?: string | undefined;
    index?: number | undefined;
    macro_utility?: string | undefined;
    functional_area?: string | undefined;
    energy_use_id?: string | undefined;
    technology?: string | undefined;
    power_rating_kw?: number | undefined;
    total_power_rating_kw?: number | undefined;
    installation_year?: string | undefined;
    hours_per_year?: number | undefined;
    fcu_fc?: number | undefined;
    annual_consumption_kwha?: number | undefined;
    annual_consumption_percentage?: number | undefined;
    annual_cost?: number | undefined;
    data_accuracy?: string | undefined;
    monitoring_system_asis_id?: string | undefined;
    monitoring_system_tobe_id?: string | undefined;
    notes?: string | undefined;
    efficiency?: number | undefined;
    annual_consumption_liters?: number | undefined;
}

/** DTO per leggere CensusCommonData + CensusCodeC */
export class CensusCodeCReadDTO implements ICensusCodeCReadDTO {
    id!: string;
    vector_id!: string;
    code?: string | undefined;
    quantity?: number | undefined;
    utility?: string | undefined;
    department?: string | undefined;
    index?: number | undefined;
    macro_utility?: string | undefined;
    functional_area?: string | undefined;
    energy_use_id?: string | undefined;
    technology?: string | undefined;
    power_rating_kw?: number | undefined;
    total_power_rating_kw?: number | undefined;
    installation_year?: string | undefined;
    hours_per_year?: number | undefined;
    fcu_fc?: number | undefined;
    annual_consumption_kwha?: number | undefined;
    annual_consumption_percentage?: number | undefined;
    annual_cost?: number | undefined;
    data_accuracy?: string | undefined;
    data_grouping?: string | undefined;
    monitoring_system_asis_id?: string | undefined;
    monitoring_system_tobe_id?: string | undefined;
    notes?: string | undefined;
    efficiency?: number | undefined;
    annual_consumption_liters?: number | undefined;

    constructor(data?: ICensusCodeCReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vector_id = _data["vector_id"];
            this.code = _data["code"];
            this.quantity = _data["quantity"];
            this.utility = _data["utility"];
            this.department = _data["department"];
            this.index = _data["index"];
            this.macro_utility = _data["macro_utility"];
            this.functional_area = _data["functional_area"];
            this.energy_use_id = _data["energy_use_id"];
            this.technology = _data["technology"];
            this.power_rating_kw = _data["power_rating_kw"];
            this.total_power_rating_kw = _data["total_power_rating_kw"];
            this.installation_year = _data["installation_year"];
            this.hours_per_year = _data["hours_per_year"];
            this.fcu_fc = _data["fcu_fc"];
            this.annual_consumption_kwha = _data["annual_consumption_kwha"];
            this.annual_consumption_percentage = _data["annual_consumption_percentage"];
            this.annual_cost = _data["annual_cost"];
            this.data_accuracy = _data["data_accuracy"];
            this.data_grouping = _data["data_grouping"];
            this.monitoring_system_asis_id = _data["monitoring_system_asis_id"];
            this.monitoring_system_tobe_id = _data["monitoring_system_tobe_id"];
            this.notes = _data["notes"];
            this.efficiency = _data["efficiency"];
            this.annual_consumption_liters = _data["annual_consumption_liters"];
        }
    }

    static fromJS(data: any): CensusCodeCReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CensusCodeCReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vector_id"] = this.vector_id;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        data["utility"] = this.utility;
        data["department"] = this.department;
        data["index"] = this.index;
        data["macro_utility"] = this.macro_utility;
        data["functional_area"] = this.functional_area;
        data["energy_use_id"] = this.energy_use_id;
        data["technology"] = this.technology;
        data["power_rating_kw"] = this.power_rating_kw;
        data["total_power_rating_kw"] = this.total_power_rating_kw;
        data["installation_year"] = this.installation_year;
        data["hours_per_year"] = this.hours_per_year;
        data["fcu_fc"] = this.fcu_fc;
        data["annual_consumption_kwha"] = this.annual_consumption_kwha;
        data["annual_consumption_percentage"] = this.annual_consumption_percentage;
        data["annual_cost"] = this.annual_cost;
        data["data_accuracy"] = this.data_accuracy;
        data["data_grouping"] = this.data_grouping;
        data["monitoring_system_asis_id"] = this.monitoring_system_asis_id;
        data["monitoring_system_tobe_id"] = this.monitoring_system_tobe_id;
        data["notes"] = this.notes;
        data["efficiency"] = this.efficiency;
        data["annual_consumption_liters"] = this.annual_consumption_liters;
        return data;
    }
}

/** DTO per leggere CensusCommonData + CensusCodeC */
export interface ICensusCodeCReadDTO {
    id: string;
    vector_id: string;
    code?: string | undefined;
    quantity?: number | undefined;
    utility?: string | undefined;
    department?: string | undefined;
    index?: number | undefined;
    macro_utility?: string | undefined;
    functional_area?: string | undefined;
    energy_use_id?: string | undefined;
    technology?: string | undefined;
    power_rating_kw?: number | undefined;
    total_power_rating_kw?: number | undefined;
    installation_year?: string | undefined;
    hours_per_year?: number | undefined;
    fcu_fc?: number | undefined;
    annual_consumption_kwha?: number | undefined;
    annual_consumption_percentage?: number | undefined;
    annual_cost?: number | undefined;
    data_accuracy?: string | undefined;
    data_grouping?: string | undefined;
    monitoring_system_asis_id?: string | undefined;
    monitoring_system_tobe_id?: string | undefined;
    notes?: string | undefined;
    efficiency?: number | undefined;
    annual_consumption_liters?: number | undefined;
}

export class CensusCommonDataCreateDTO implements ICensusCommonDataCreateDTO {
    vector_id?: string | undefined;
    code?: string | undefined;
    quantity?: number | undefined;
    utility?: string | undefined;
    department?: string | undefined;
    index?: number | undefined;
    macro_utility?: string | undefined;
    functional_area?: FunctionalArea | undefined;
    energy_use_id?: string | undefined;
    technology?: string | undefined;
    power_rating_kw?: number | undefined;
    total_power_rating_kw?: number | undefined;
    installation_year?: string | undefined;
    hours_per_year?: number | undefined;
    fcu_fc?: number | undefined;
    annual_consumption_kwha?: number | undefined;
    annual_consumption_percentage?: number | undefined;
    annual_cost?: number | undefined;
    data_accuracy?: string | undefined;
    monitoring_system_asis_id?: string | undefined;
    monitoring_system_tobe_id?: string | undefined;
    notes?: string | undefined;

    constructor(data?: ICensusCommonDataCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vector_id = _data["vector_id"];
            this.code = _data["code"];
            this.quantity = _data["quantity"];
            this.utility = _data["utility"];
            this.department = _data["department"];
            this.index = _data["index"];
            this.macro_utility = _data["macro_utility"];
            this.functional_area = _data["functional_area"];
            this.energy_use_id = _data["energy_use_id"];
            this.technology = _data["technology"];
            this.power_rating_kw = _data["power_rating_kw"];
            this.total_power_rating_kw = _data["total_power_rating_kw"];
            this.installation_year = _data["installation_year"];
            this.hours_per_year = _data["hours_per_year"];
            this.fcu_fc = _data["fcu_fc"];
            this.annual_consumption_kwha = _data["annual_consumption_kwha"];
            this.annual_consumption_percentage = _data["annual_consumption_percentage"];
            this.annual_cost = _data["annual_cost"];
            this.data_accuracy = _data["data_accuracy"];
            this.monitoring_system_asis_id = _data["monitoring_system_asis_id"];
            this.monitoring_system_tobe_id = _data["monitoring_system_tobe_id"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CensusCommonDataCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CensusCommonDataCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vector_id"] = this.vector_id;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        data["utility"] = this.utility;
        data["department"] = this.department;
        data["index"] = this.index;
        data["macro_utility"] = this.macro_utility;
        data["functional_area"] = this.functional_area;
        data["energy_use_id"] = this.energy_use_id;
        data["technology"] = this.technology;
        data["power_rating_kw"] = this.power_rating_kw;
        data["total_power_rating_kw"] = this.total_power_rating_kw;
        data["installation_year"] = this.installation_year;
        data["hours_per_year"] = this.hours_per_year;
        data["fcu_fc"] = this.fcu_fc;
        data["annual_consumption_kwha"] = this.annual_consumption_kwha;
        data["annual_consumption_percentage"] = this.annual_consumption_percentage;
        data["annual_cost"] = this.annual_cost;
        data["data_accuracy"] = this.data_accuracy;
        data["monitoring_system_asis_id"] = this.monitoring_system_asis_id;
        data["monitoring_system_tobe_id"] = this.monitoring_system_tobe_id;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICensusCommonDataCreateDTO {
    vector_id?: string | undefined;
    code?: string | undefined;
    quantity?: number | undefined;
    utility?: string | undefined;
    department?: string | undefined;
    index?: number | undefined;
    macro_utility?: string | undefined;
    functional_area?: FunctionalArea | undefined;
    energy_use_id?: string | undefined;
    technology?: string | undefined;
    power_rating_kw?: number | undefined;
    total_power_rating_kw?: number | undefined;
    installation_year?: string | undefined;
    hours_per_year?: number | undefined;
    fcu_fc?: number | undefined;
    annual_consumption_kwha?: number | undefined;
    annual_consumption_percentage?: number | undefined;
    annual_cost?: number | undefined;
    data_accuracy?: string | undefined;
    monitoring_system_asis_id?: string | undefined;
    monitoring_system_tobe_id?: string | undefined;
    notes?: string | undefined;
}

export class CensusCommonDataReadDTO implements ICensusCommonDataReadDTO {
    vector_id?: string | undefined;
    code?: string | undefined;
    quantity?: number | undefined;
    utility?: string | undefined;
    department?: string | undefined;
    index?: number | undefined;
    macro_utility?: string | undefined;
    functional_area?: FunctionalArea | undefined;
    energy_use_id?: string | undefined;
    technology?: string | undefined;
    power_rating_kw?: number | undefined;
    total_power_rating_kw?: number | undefined;
    installation_year?: string | undefined;
    hours_per_year?: number | undefined;
    fcu_fc?: number | undefined;
    annual_consumption_kwha?: number | undefined;
    annual_consumption_percentage?: number | undefined;
    annual_cost?: number | undefined;
    data_accuracy?: string | undefined;
    monitoring_system_asis_id?: string | undefined;
    monitoring_system_tobe_id?: string | undefined;
    notes?: string | undefined;
    id?: string;

    constructor(data?: ICensusCommonDataReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vector_id = _data["vector_id"];
            this.code = _data["code"];
            this.quantity = _data["quantity"];
            this.utility = _data["utility"];
            this.department = _data["department"];
            this.index = _data["index"];
            this.macro_utility = _data["macro_utility"];
            this.functional_area = _data["functional_area"];
            this.energy_use_id = _data["energy_use_id"];
            this.technology = _data["technology"];
            this.power_rating_kw = _data["power_rating_kw"];
            this.total_power_rating_kw = _data["total_power_rating_kw"];
            this.installation_year = _data["installation_year"];
            this.hours_per_year = _data["hours_per_year"];
            this.fcu_fc = _data["fcu_fc"];
            this.annual_consumption_kwha = _data["annual_consumption_kwha"];
            this.annual_consumption_percentage = _data["annual_consumption_percentage"];
            this.annual_cost = _data["annual_cost"];
            this.data_accuracy = _data["data_accuracy"];
            this.monitoring_system_asis_id = _data["monitoring_system_asis_id"];
            this.monitoring_system_tobe_id = _data["monitoring_system_tobe_id"];
            this.notes = _data["notes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CensusCommonDataReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CensusCommonDataReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vector_id"] = this.vector_id;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        data["utility"] = this.utility;
        data["department"] = this.department;
        data["index"] = this.index;
        data["macro_utility"] = this.macro_utility;
        data["functional_area"] = this.functional_area;
        data["energy_use_id"] = this.energy_use_id;
        data["technology"] = this.technology;
        data["power_rating_kw"] = this.power_rating_kw;
        data["total_power_rating_kw"] = this.total_power_rating_kw;
        data["installation_year"] = this.installation_year;
        data["hours_per_year"] = this.hours_per_year;
        data["fcu_fc"] = this.fcu_fc;
        data["annual_consumption_kwha"] = this.annual_consumption_kwha;
        data["annual_consumption_percentage"] = this.annual_consumption_percentage;
        data["annual_cost"] = this.annual_cost;
        data["data_accuracy"] = this.data_accuracy;
        data["monitoring_system_asis_id"] = this.monitoring_system_asis_id;
        data["monitoring_system_tobe_id"] = this.monitoring_system_tobe_id;
        data["notes"] = this.notes;
        data["id"] = this.id;
        return data;
    }
}

export interface ICensusCommonDataReadDTO {
    vector_id?: string | undefined;
    code?: string | undefined;
    quantity?: number | undefined;
    utility?: string | undefined;
    department?: string | undefined;
    index?: number | undefined;
    macro_utility?: string | undefined;
    functional_area?: FunctionalArea | undefined;
    energy_use_id?: string | undefined;
    technology?: string | undefined;
    power_rating_kw?: number | undefined;
    total_power_rating_kw?: number | undefined;
    installation_year?: string | undefined;
    hours_per_year?: number | undefined;
    fcu_fc?: number | undefined;
    annual_consumption_kwha?: number | undefined;
    annual_consumption_percentage?: number | undefined;
    annual_cost?: number | undefined;
    data_accuracy?: string | undefined;
    monitoring_system_asis_id?: string | undefined;
    monitoring_system_tobe_id?: string | undefined;
    notes?: string | undefined;
    id?: string;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    current_password!: string;
    new_password!: string;
    new_password_confirm!: string;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.current_password = _data["current_password"];
            this.new_password = _data["new_password"];
            this.new_password_confirm = _data["new_password_confirm"];
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current_password"] = this.current_password;
        data["new_password"] = this.new_password;
        data["new_password_confirm"] = this.new_password_confirm;
        return data;
    }
}

export interface IChangePasswordRequest {
    current_password: string;
    new_password: string;
    new_password_confirm: string;
}

export class ConsumptionDataCreateDTO implements IConsumptionDataCreateDTO {
    indicator_id?: string | undefined;
    year!: number;
    value?: number | undefined;

    constructor(data?: IConsumptionDataCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indicator_id = _data["indicator_id"];
            this.year = _data["year"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ConsumptionDataCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionDataCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicator_id"] = this.indicator_id;
        data["year"] = this.year;
        data["value"] = this.value;
        return data;
    }
}

export interface IConsumptionDataCreateDTO {
    indicator_id?: string | undefined;
    year: number;
    value?: number | undefined;
}

export class ConsumptionDataReadDTO implements IConsumptionDataReadDTO {
    indicator_id?: string | undefined;
    year!: number;
    value?: number | undefined;
    id?: string;

    constructor(data?: IConsumptionDataReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indicator_id = _data["indicator_id"];
            this.year = _data["year"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ConsumptionDataReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionDataReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicator_id"] = this.indicator_id;
        data["year"] = this.year;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface IConsumptionDataReadDTO {
    indicator_id?: string | undefined;
    year: number;
    value?: number | undefined;
    id?: string;
}

export class ConsumptionEnergyVectorFunctionalAreaCreateDTO implements IConsumptionEnergyVectorFunctionalAreaCreateDTO {
    diagnosis_energy_vector_id!: string;
    functional_area!: FunctionalArea;
    estimated_consumption?: number | undefined;
    estimated_consumption_incidence?: number | undefined;
    monitored_consumption_asis?: number | undefined;
    monitored_consumption_asis_coverage?: number | undefined;
    enea_coverage?: number | undefined;
    monitored_consumption_tobe?: number | undefined;
    monitored_consumption_tobe_coverage?: number | undefined;

    constructor(data?: IConsumptionEnergyVectorFunctionalAreaCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_energy_vector_id = _data["diagnosis_energy_vector_id"];
            this.functional_area = _data["functional_area"];
            this.estimated_consumption = _data["estimated_consumption"];
            this.estimated_consumption_incidence = _data["estimated_consumption_incidence"];
            this.monitored_consumption_asis = _data["monitored_consumption_asis"];
            this.monitored_consumption_asis_coverage = _data["monitored_consumption_asis_coverage"];
            this.enea_coverage = _data["enea_coverage"];
            this.monitored_consumption_tobe = _data["monitored_consumption_tobe"];
            this.monitored_consumption_tobe_coverage = _data["monitored_consumption_tobe_coverage"];
        }
    }

    static fromJS(data: any): ConsumptionEnergyVectorFunctionalAreaCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionEnergyVectorFunctionalAreaCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_energy_vector_id"] = this.diagnosis_energy_vector_id;
        data["functional_area"] = this.functional_area;
        data["estimated_consumption"] = this.estimated_consumption;
        data["estimated_consumption_incidence"] = this.estimated_consumption_incidence;
        data["monitored_consumption_asis"] = this.monitored_consumption_asis;
        data["monitored_consumption_asis_coverage"] = this.monitored_consumption_asis_coverage;
        data["enea_coverage"] = this.enea_coverage;
        data["monitored_consumption_tobe"] = this.monitored_consumption_tobe;
        data["monitored_consumption_tobe_coverage"] = this.monitored_consumption_tobe_coverage;
        return data;
    }
}

export interface IConsumptionEnergyVectorFunctionalAreaCreateDTO {
    diagnosis_energy_vector_id: string;
    functional_area: FunctionalArea;
    estimated_consumption?: number | undefined;
    estimated_consumption_incidence?: number | undefined;
    monitored_consumption_asis?: number | undefined;
    monitored_consumption_asis_coverage?: number | undefined;
    enea_coverage?: number | undefined;
    monitored_consumption_tobe?: number | undefined;
    monitored_consumption_tobe_coverage?: number | undefined;
}

export class ConsumptionEnergyVectorFunctionalAreaReadDTO implements IConsumptionEnergyVectorFunctionalAreaReadDTO {
    diagnosis_energy_vector_id!: string;
    functional_area!: FunctionalArea;
    estimated_consumption?: number | undefined;
    estimated_consumption_incidence?: number | undefined;
    monitored_consumption_asis?: number | undefined;
    monitored_consumption_asis_coverage?: number | undefined;
    enea_coverage?: number | undefined;
    monitored_consumption_tobe?: number | undefined;
    monitored_consumption_tobe_coverage?: number | undefined;
    id?: string;

    constructor(data?: IConsumptionEnergyVectorFunctionalAreaReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_energy_vector_id = _data["diagnosis_energy_vector_id"];
            this.functional_area = _data["functional_area"];
            this.estimated_consumption = _data["estimated_consumption"];
            this.estimated_consumption_incidence = _data["estimated_consumption_incidence"];
            this.monitored_consumption_asis = _data["monitored_consumption_asis"];
            this.monitored_consumption_asis_coverage = _data["monitored_consumption_asis_coverage"];
            this.enea_coverage = _data["enea_coverage"];
            this.monitored_consumption_tobe = _data["monitored_consumption_tobe"];
            this.monitored_consumption_tobe_coverage = _data["monitored_consumption_tobe_coverage"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ConsumptionEnergyVectorFunctionalAreaReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionEnergyVectorFunctionalAreaReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_energy_vector_id"] = this.diagnosis_energy_vector_id;
        data["functional_area"] = this.functional_area;
        data["estimated_consumption"] = this.estimated_consumption;
        data["estimated_consumption_incidence"] = this.estimated_consumption_incidence;
        data["monitored_consumption_asis"] = this.monitored_consumption_asis;
        data["monitored_consumption_asis_coverage"] = this.monitored_consumption_asis_coverage;
        data["enea_coverage"] = this.enea_coverage;
        data["monitored_consumption_tobe"] = this.monitored_consumption_tobe;
        data["monitored_consumption_tobe_coverage"] = this.monitored_consumption_tobe_coverage;
        data["id"] = this.id;
        return data;
    }
}

export interface IConsumptionEnergyVectorFunctionalAreaReadDTO {
    diagnosis_energy_vector_id: string;
    functional_area: FunctionalArea;
    estimated_consumption?: number | undefined;
    estimated_consumption_incidence?: number | undefined;
    monitored_consumption_asis?: number | undefined;
    monitored_consumption_asis_coverage?: number | undefined;
    enea_coverage?: number | undefined;
    monitored_consumption_tobe?: number | undefined;
    monitored_consumption_tobe_coverage?: number | undefined;
    id?: string;
}

export class ConsumptionRelation implements IConsumptionRelation {
    consumption_id!: string;
    code!: string;

    [key: string]: any;

    constructor(data?: IConsumptionRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.consumption_id = _data["consumption_id"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ConsumptionRelation {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["consumption_id"] = this.consumption_id;
        data["code"] = this.code;
        return data;
    }
}

export interface IConsumptionRelation {
    consumption_id: string;
    code: string;

    [key: string]: any;
}

export class ConsumptionTotalsCreateDTO implements IConsumptionTotalsCreateDTO {
    diagnosis_consumption_id!: string;
    year!: number;
    quantity?: number | undefined;
    price?: number | undefined;
    unit_cost?: number | undefined;

    constructor(data?: IConsumptionTotalsCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_consumption_id = _data["diagnosis_consumption_id"];
            this.year = _data["year"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.unit_cost = _data["unit_cost"];
        }
    }

    static fromJS(data: any): ConsumptionTotalsCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionTotalsCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_consumption_id"] = this.diagnosis_consumption_id;
        data["year"] = this.year;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["unit_cost"] = this.unit_cost;
        return data;
    }
}

export interface IConsumptionTotalsCreateDTO {
    diagnosis_consumption_id: string;
    year: number;
    quantity?: number | undefined;
    price?: number | undefined;
    unit_cost?: number | undefined;
}

export class ConsumptionTotalsReadDTO implements IConsumptionTotalsReadDTO {
    diagnosis_consumption_id!: string;
    year!: number;
    quantity?: number | undefined;
    price?: number | undefined;
    unit_cost?: number | undefined;
    id?: string;

    constructor(data?: IConsumptionTotalsReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_consumption_id = _data["diagnosis_consumption_id"];
            this.year = _data["year"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.unit_cost = _data["unit_cost"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ConsumptionTotalsReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionTotalsReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_consumption_id"] = this.diagnosis_consumption_id;
        data["year"] = this.year;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["unit_cost"] = this.unit_cost;
        data["id"] = this.id;
        return data;
    }
}

export interface IConsumptionTotalsReadDTO {
    diagnosis_consumption_id: string;
    year: number;
    quantity?: number | undefined;
    price?: number | undefined;
    unit_cost?: number | undefined;
    id?: string;
}

export enum ConsumptionType {
    Total = "total",
    Withdrawn = "withdrawn",
    Self_consumed = "self_consumed",
}

export class CopyEnergyUseDto implements ICopyEnergyUseDto {
    energy_use_id!: string;
    diagnosis_id!: string;

    [key: string]: any;

    constructor(data?: ICopyEnergyUseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.energy_use_id = _data["energy_use_id"];
            this.diagnosis_id = _data["diagnosis_id"];
        }
    }

    static fromJS(data: any): CopyEnergyUseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CopyEnergyUseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["energy_use_id"] = this.energy_use_id;
        data["diagnosis_id"] = this.diagnosis_id;
        return data;
    }
}

export interface ICopyEnergyUseDto {
    energy_use_id: string;
    diagnosis_id: string;

    [key: string]: any;
}

export class CopyEnergyVectorDto implements ICopyEnergyVectorDto {
    energy_vector_id!: string;
    diagnosis_id!: string;

    [key: string]: any;

    constructor(data?: ICopyEnergyVectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.energy_vector_id = _data["energy_vector_id"];
            this.diagnosis_id = _data["diagnosis_id"];
        }
    }

    static fromJS(data: any): CopyEnergyVectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CopyEnergyVectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["energy_vector_id"] = this.energy_vector_id;
        data["diagnosis_id"] = this.diagnosis_id;
        return data;
    }
}

export interface ICopyEnergyVectorDto {
    energy_vector_id: string;
    diagnosis_id: string;

    [key: string]: any;
}

export class CopyIncidenceEneaDto implements ICopyIncidenceEneaDto {
    incidence_enea_id!: string;
    diagnosis_id!: string;

    constructor(data?: ICopyIncidenceEneaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incidence_enea_id = _data["incidence_enea_id"];
            this.diagnosis_id = _data["diagnosis_id"];
        }
    }

    static fromJS(data: any): CopyIncidenceEneaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CopyIncidenceEneaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidence_enea_id"] = this.incidence_enea_id;
        data["diagnosis_id"] = this.diagnosis_id;
        return data;
    }
}

export interface ICopyIncidenceEneaDto {
    incidence_enea_id: string;
    diagnosis_id: string;
}

export class CustomerCreateDTO implements ICustomerCreateDTO {
    company_name!: string;
    company_name_type?: string | undefined;
    ateco_2007?: string | undefined;
    ateco_2022?: string | undefined;
    ateco_2025?: string | undefined;
    last_update?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    voluntary?: boolean | undefined;
    type?: string | undefined;
    multi_site?: boolean | undefined;
    clustering?: string | undefined;
    employee_count?: number | undefined;
    revenue?: number | undefined;
    balance_sheet_assets?: number | undefined;
    size_category?: string | undefined;
    consumption_category?: string | undefined;
    average_annual_consumption?: number | undefined;
    high_electricity_consumption?: boolean | undefined;
    high_gas_consumption?: boolean | undefined;
    certifications?: string | undefined;
    vat_number?: string | undefined;
    tax_code?: string | undefined;
    certified_email?: string | undefined;
    legal_representative?: string | undefined;
    legal_representative_phone?: string | undefined;
    legal_representative_email?: string | undefined;
    contact_person?: string | undefined;
    contact_person_phone?: string | undefined;
    contact_person_email?: string | undefined;

    constructor(data?: ICustomerCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company_name = _data["company_name"];
            this.company_name_type = _data["company_name_type"];
            this.ateco_2007 = _data["ateco_2007"];
            this.ateco_2022 = _data["ateco_2022"];
            this.ateco_2025 = _data["ateco_2025"];
            this.last_update = _data["last_update"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.voluntary = _data["voluntary"];
            this.type = _data["type"];
            this.multi_site = _data["multi_site"];
            this.clustering = _data["clustering"];
            this.employee_count = _data["employee_count"];
            this.revenue = _data["revenue"];
            this.balance_sheet_assets = _data["balance_sheet_assets"];
            this.size_category = _data["size_category"];
            this.consumption_category = _data["consumption_category"];
            this.average_annual_consumption = _data["average_annual_consumption"];
            this.high_electricity_consumption = _data["high_electricity_consumption"];
            this.high_gas_consumption = _data["high_gas_consumption"];
            this.certifications = _data["certifications"];
            this.vat_number = _data["vat_number"];
            this.tax_code = _data["tax_code"];
            this.certified_email = _data["certified_email"];
            this.legal_representative = _data["legal_representative"];
            this.legal_representative_phone = _data["legal_representative_phone"];
            this.legal_representative_email = _data["legal_representative_email"];
            this.contact_person = _data["contact_person"];
            this.contact_person_phone = _data["contact_person_phone"];
            this.contact_person_email = _data["contact_person_email"];
        }
    }

    static fromJS(data: any): CustomerCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company_name"] = this.company_name;
        data["company_name_type"] = this.company_name_type;
        data["ateco_2007"] = this.ateco_2007;
        data["ateco_2022"] = this.ateco_2022;
        data["ateco_2025"] = this.ateco_2025;
        data["last_update"] = this.last_update;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["voluntary"] = this.voluntary;
        data["type"] = this.type;
        data["multi_site"] = this.multi_site;
        data["clustering"] = this.clustering;
        data["employee_count"] = this.employee_count;
        data["revenue"] = this.revenue;
        data["balance_sheet_assets"] = this.balance_sheet_assets;
        data["size_category"] = this.size_category;
        data["consumption_category"] = this.consumption_category;
        data["average_annual_consumption"] = this.average_annual_consumption;
        data["high_electricity_consumption"] = this.high_electricity_consumption;
        data["high_gas_consumption"] = this.high_gas_consumption;
        data["certifications"] = this.certifications;
        data["vat_number"] = this.vat_number;
        data["tax_code"] = this.tax_code;
        data["certified_email"] = this.certified_email;
        data["legal_representative"] = this.legal_representative;
        data["legal_representative_phone"] = this.legal_representative_phone;
        data["legal_representative_email"] = this.legal_representative_email;
        data["contact_person"] = this.contact_person;
        data["contact_person_phone"] = this.contact_person_phone;
        data["contact_person_email"] = this.contact_person_email;
        return data;
    }
}

export interface ICustomerCreateDTO {
    company_name: string;
    company_name_type?: string | undefined;
    ateco_2007?: string | undefined;
    ateco_2022?: string | undefined;
    ateco_2025?: string | undefined;
    last_update?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    voluntary?: boolean | undefined;
    type?: string | undefined;
    multi_site?: boolean | undefined;
    clustering?: string | undefined;
    employee_count?: number | undefined;
    revenue?: number | undefined;
    balance_sheet_assets?: number | undefined;
    size_category?: string | undefined;
    consumption_category?: string | undefined;
    average_annual_consumption?: number | undefined;
    high_electricity_consumption?: boolean | undefined;
    high_gas_consumption?: boolean | undefined;
    certifications?: string | undefined;
    vat_number?: string | undefined;
    tax_code?: string | undefined;
    certified_email?: string | undefined;
    legal_representative?: string | undefined;
    legal_representative_phone?: string | undefined;
    legal_representative_email?: string | undefined;
    contact_person?: string | undefined;
    contact_person_phone?: string | undefined;
    contact_person_email?: string | undefined;
}

export class CustomerReadDTO implements ICustomerReadDTO {
    company_name!: string;
    company_name_type?: string | undefined;
    ateco_2007?: string | undefined;
    ateco_2022?: string | undefined;
    ateco_2025?: string | undefined;
    last_update?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    voluntary?: boolean | undefined;
    type?: string | undefined;
    multi_site?: boolean | undefined;
    clustering?: string | undefined;
    employee_count?: number | undefined;
    revenue?: number | undefined;
    balance_sheet_assets?: number | undefined;
    size_category?: string | undefined;
    consumption_category?: string | undefined;
    average_annual_consumption?: number | undefined;
    high_electricity_consumption?: boolean | undefined;
    high_gas_consumption?: boolean | undefined;
    certifications?: string | undefined;
    vat_number?: string | undefined;
    tax_code?: string | undefined;
    certified_email?: string | undefined;
    legal_representative?: string | undefined;
    legal_representative_phone?: string | undefined;
    legal_representative_email?: string | undefined;
    contact_person?: string | undefined;
    contact_person_phone?: string | undefined;
    contact_person_email?: string | undefined;
    id?: string;

    constructor(data?: ICustomerReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company_name = _data["company_name"];
            this.company_name_type = _data["company_name_type"];
            this.ateco_2007 = _data["ateco_2007"];
            this.ateco_2022 = _data["ateco_2022"];
            this.ateco_2025 = _data["ateco_2025"];
            this.last_update = _data["last_update"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.voluntary = _data["voluntary"];
            this.type = _data["type"];
            this.multi_site = _data["multi_site"];
            this.clustering = _data["clustering"];
            this.employee_count = _data["employee_count"];
            this.revenue = _data["revenue"];
            this.balance_sheet_assets = _data["balance_sheet_assets"];
            this.size_category = _data["size_category"];
            this.consumption_category = _data["consumption_category"];
            this.average_annual_consumption = _data["average_annual_consumption"];
            this.high_electricity_consumption = _data["high_electricity_consumption"];
            this.high_gas_consumption = _data["high_gas_consumption"];
            this.certifications = _data["certifications"];
            this.vat_number = _data["vat_number"];
            this.tax_code = _data["tax_code"];
            this.certified_email = _data["certified_email"];
            this.legal_representative = _data["legal_representative"];
            this.legal_representative_phone = _data["legal_representative_phone"];
            this.legal_representative_email = _data["legal_representative_email"];
            this.contact_person = _data["contact_person"];
            this.contact_person_phone = _data["contact_person_phone"];
            this.contact_person_email = _data["contact_person_email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company_name"] = this.company_name;
        data["company_name_type"] = this.company_name_type;
        data["ateco_2007"] = this.ateco_2007;
        data["ateco_2022"] = this.ateco_2022;
        data["ateco_2025"] = this.ateco_2025;
        data["last_update"] = this.last_update;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["voluntary"] = this.voluntary;
        data["type"] = this.type;
        data["multi_site"] = this.multi_site;
        data["clustering"] = this.clustering;
        data["employee_count"] = this.employee_count;
        data["revenue"] = this.revenue;
        data["balance_sheet_assets"] = this.balance_sheet_assets;
        data["size_category"] = this.size_category;
        data["consumption_category"] = this.consumption_category;
        data["average_annual_consumption"] = this.average_annual_consumption;
        data["high_electricity_consumption"] = this.high_electricity_consumption;
        data["high_gas_consumption"] = this.high_gas_consumption;
        data["certifications"] = this.certifications;
        data["vat_number"] = this.vat_number;
        data["tax_code"] = this.tax_code;
        data["certified_email"] = this.certified_email;
        data["legal_representative"] = this.legal_representative;
        data["legal_representative_phone"] = this.legal_representative_phone;
        data["legal_representative_email"] = this.legal_representative_email;
        data["contact_person"] = this.contact_person;
        data["contact_person_phone"] = this.contact_person_phone;
        data["contact_person_email"] = this.contact_person_email;
        data["id"] = this.id;
        return data;
    }
}

export interface ICustomerReadDTO {
    company_name: string;
    company_name_type?: string | undefined;
    ateco_2007?: string | undefined;
    ateco_2022?: string | undefined;
    ateco_2025?: string | undefined;
    last_update?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    voluntary?: boolean | undefined;
    type?: string | undefined;
    multi_site?: boolean | undefined;
    clustering?: string | undefined;
    employee_count?: number | undefined;
    revenue?: number | undefined;
    balance_sheet_assets?: number | undefined;
    size_category?: string | undefined;
    consumption_category?: string | undefined;
    average_annual_consumption?: number | undefined;
    high_electricity_consumption?: boolean | undefined;
    high_gas_consumption?: boolean | undefined;
    certifications?: string | undefined;
    vat_number?: string | undefined;
    tax_code?: string | undefined;
    certified_email?: string | undefined;
    legal_representative?: string | undefined;
    legal_representative_phone?: string | undefined;
    legal_representative_email?: string | undefined;
    contact_person?: string | undefined;
    contact_person_phone?: string | undefined;
    contact_person_email?: string | undefined;
    id?: string;
}

export class CustomerSitesCreateDTO implements ICustomerSitesCreateDTO {
    customer_id?: string | undefined;
    address!: string;
    iso_50001_certified_site?: boolean | undefined;
    covered_area?: number | undefined;
    telecom_network_presence!: boolean;
    cogeneration_availability!: boolean;
    last_update?: string | undefined;
    excluded_areas?: string | undefined;
    norm_unicei_16247_1?: boolean | undefined;
    norm_unicei_16247_2?: boolean | undefined;
    norm_unicei_16247_3?: boolean | undefined;
    norm_unicei_16247_4?: boolean | undefined;
    notes?: string | undefined;
    property?: string | undefined;
    type?: string | undefined;
    availability_until?: string | undefined;
    construction_year?: string | undefined;
    renovation_year?: string | undefined;
    energy_performance_certificate?: boolean | undefined;
    efficiency_class?: string | undefined;
    building_envelope_walls_floors?: string | undefined;
    building_envelope_insulation?: string | undefined;
    building_envelope_transmittance?: string | undefined;
    fixtures_glass?: string | undefined;
    fixtures_frame?: string | undefined;
    fixtures_transmittance?: string | undefined;
    fixtures_shading?: string | undefined;
    img?: string | undefined;
    climatic_zone?: string | undefined;
    start_summer?: string | undefined;
    start_winter?: string | undefined;
    has_podp?: number | undefined;
    has_podi?: number | undefined;
    has_prod?: number | undefined;
    has_pdr?: number | undefined;

    constructor(data?: ICustomerSitesCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer_id = _data["customer_id"];
            this.address = _data["address"];
            this.iso_50001_certified_site = _data["iso_50001_certified_site"];
            this.covered_area = _data["covered_area"];
            this.telecom_network_presence = _data["telecom_network_presence"];
            this.cogeneration_availability = _data["cogeneration_availability"];
            this.last_update = _data["last_update"];
            this.excluded_areas = _data["excluded_areas"];
            this.norm_unicei_16247_1 = _data["norm_unicei_16247_1"];
            this.norm_unicei_16247_2 = _data["norm_unicei_16247_2"];
            this.norm_unicei_16247_3 = _data["norm_unicei_16247_3"];
            this.norm_unicei_16247_4 = _data["norm_unicei_16247_4"];
            this.notes = _data["notes"];
            this.property = _data["property"];
            this.type = _data["type"];
            this.availability_until = _data["availability_until"];
            this.construction_year = _data["construction_year"];
            this.renovation_year = _data["renovation_year"];
            this.energy_performance_certificate = _data["energy_performance_certificate"];
            this.efficiency_class = _data["efficiency_class"];
            this.building_envelope_walls_floors = _data["building_envelope_walls_floors"];
            this.building_envelope_insulation = _data["building_envelope_insulation"];
            this.building_envelope_transmittance = _data["building_envelope_transmittance"];
            this.fixtures_glass = _data["fixtures_glass"];
            this.fixtures_frame = _data["fixtures_frame"];
            this.fixtures_transmittance = _data["fixtures_transmittance"];
            this.fixtures_shading = _data["fixtures_shading"];
            this.img = _data["img"];
            this.climatic_zone = _data["climatic_zone"];
            this.start_summer = _data["start_summer"];
            this.start_winter = _data["start_winter"];
            this.has_podp = _data["has_podp"];
            this.has_podi = _data["has_podi"];
            this.has_prod = _data["has_prod"];
            this.has_pdr = _data["has_pdr"];
        }
    }

    static fromJS(data: any): CustomerSitesCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSitesCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer_id"] = this.customer_id;
        data["address"] = this.address;
        data["iso_50001_certified_site"] = this.iso_50001_certified_site;
        data["covered_area"] = this.covered_area;
        data["telecom_network_presence"] = this.telecom_network_presence;
        data["cogeneration_availability"] = this.cogeneration_availability;
        data["last_update"] = this.last_update;
        data["excluded_areas"] = this.excluded_areas;
        data["norm_unicei_16247_1"] = this.norm_unicei_16247_1;
        data["norm_unicei_16247_2"] = this.norm_unicei_16247_2;
        data["norm_unicei_16247_3"] = this.norm_unicei_16247_3;
        data["norm_unicei_16247_4"] = this.norm_unicei_16247_4;
        data["notes"] = this.notes;
        data["property"] = this.property;
        data["type"] = this.type;
        data["availability_until"] = this.availability_until;
        data["construction_year"] = this.construction_year;
        data["renovation_year"] = this.renovation_year;
        data["energy_performance_certificate"] = this.energy_performance_certificate;
        data["efficiency_class"] = this.efficiency_class;
        data["building_envelope_walls_floors"] = this.building_envelope_walls_floors;
        data["building_envelope_insulation"] = this.building_envelope_insulation;
        data["building_envelope_transmittance"] = this.building_envelope_transmittance;
        data["fixtures_glass"] = this.fixtures_glass;
        data["fixtures_frame"] = this.fixtures_frame;
        data["fixtures_transmittance"] = this.fixtures_transmittance;
        data["fixtures_shading"] = this.fixtures_shading;
        data["img"] = this.img;
        data["climatic_zone"] = this.climatic_zone;
        data["start_summer"] = this.start_summer;
        data["start_winter"] = this.start_winter;
        data["has_podp"] = this.has_podp;
        data["has_podi"] = this.has_podi;
        data["has_prod"] = this.has_prod;
        data["has_pdr"] = this.has_pdr;
        return data;
    }
}

export interface ICustomerSitesCreateDTO {
    customer_id?: string | undefined;
    address: string;
    iso_50001_certified_site?: boolean | undefined;
    covered_area?: number | undefined;
    telecom_network_presence: boolean;
    cogeneration_availability: boolean;
    last_update?: string | undefined;
    excluded_areas?: string | undefined;
    norm_unicei_16247_1?: boolean | undefined;
    norm_unicei_16247_2?: boolean | undefined;
    norm_unicei_16247_3?: boolean | undefined;
    norm_unicei_16247_4?: boolean | undefined;
    notes?: string | undefined;
    property?: string | undefined;
    type?: string | undefined;
    availability_until?: string | undefined;
    construction_year?: string | undefined;
    renovation_year?: string | undefined;
    energy_performance_certificate?: boolean | undefined;
    efficiency_class?: string | undefined;
    building_envelope_walls_floors?: string | undefined;
    building_envelope_insulation?: string | undefined;
    building_envelope_transmittance?: string | undefined;
    fixtures_glass?: string | undefined;
    fixtures_frame?: string | undefined;
    fixtures_transmittance?: string | undefined;
    fixtures_shading?: string | undefined;
    img?: string | undefined;
    climatic_zone?: string | undefined;
    start_summer?: string | undefined;
    start_winter?: string | undefined;
    has_podp?: number | undefined;
    has_podi?: number | undefined;
    has_prod?: number | undefined;
    has_pdr?: number | undefined;
}

export class CustomerSitesReadDTO implements ICustomerSitesReadDTO {
    customer_id?: string | undefined;
    address!: string;
    iso_50001_certified_site?: boolean | undefined;
    covered_area?: number | undefined;
    telecom_network_presence!: boolean;
    cogeneration_availability!: boolean;
    last_update?: string | undefined;
    excluded_areas?: string | undefined;
    norm_unicei_16247_1?: boolean | undefined;
    norm_unicei_16247_2?: boolean | undefined;
    norm_unicei_16247_3?: boolean | undefined;
    norm_unicei_16247_4?: boolean | undefined;
    notes?: string | undefined;
    property?: string | undefined;
    type?: string | undefined;
    availability_until?: string | undefined;
    construction_year?: string | undefined;
    renovation_year?: string | undefined;
    energy_performance_certificate?: boolean | undefined;
    efficiency_class?: string | undefined;
    building_envelope_walls_floors?: string | undefined;
    building_envelope_insulation?: string | undefined;
    building_envelope_transmittance?: string | undefined;
    fixtures_glass?: string | undefined;
    fixtures_frame?: string | undefined;
    fixtures_transmittance?: string | undefined;
    fixtures_shading?: string | undefined;
    img?: string | undefined;
    climatic_zone?: string | undefined;
    start_summer?: string | undefined;
    start_winter?: string | undefined;
    has_podp?: number | undefined;
    has_podi?: number | undefined;
    has_prod?: number | undefined;
    has_pdr?: number | undefined;
    id?: string;

    constructor(data?: ICustomerSitesReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer_id = _data["customer_id"];
            this.address = _data["address"];
            this.iso_50001_certified_site = _data["iso_50001_certified_site"];
            this.covered_area = _data["covered_area"];
            this.telecom_network_presence = _data["telecom_network_presence"];
            this.cogeneration_availability = _data["cogeneration_availability"];
            this.last_update = _data["last_update"];
            this.excluded_areas = _data["excluded_areas"];
            this.norm_unicei_16247_1 = _data["norm_unicei_16247_1"];
            this.norm_unicei_16247_2 = _data["norm_unicei_16247_2"];
            this.norm_unicei_16247_3 = _data["norm_unicei_16247_3"];
            this.norm_unicei_16247_4 = _data["norm_unicei_16247_4"];
            this.notes = _data["notes"];
            this.property = _data["property"];
            this.type = _data["type"];
            this.availability_until = _data["availability_until"];
            this.construction_year = _data["construction_year"];
            this.renovation_year = _data["renovation_year"];
            this.energy_performance_certificate = _data["energy_performance_certificate"];
            this.efficiency_class = _data["efficiency_class"];
            this.building_envelope_walls_floors = _data["building_envelope_walls_floors"];
            this.building_envelope_insulation = _data["building_envelope_insulation"];
            this.building_envelope_transmittance = _data["building_envelope_transmittance"];
            this.fixtures_glass = _data["fixtures_glass"];
            this.fixtures_frame = _data["fixtures_frame"];
            this.fixtures_transmittance = _data["fixtures_transmittance"];
            this.fixtures_shading = _data["fixtures_shading"];
            this.img = _data["img"];
            this.climatic_zone = _data["climatic_zone"];
            this.start_summer = _data["start_summer"];
            this.start_winter = _data["start_winter"];
            this.has_podp = _data["has_podp"];
            this.has_podi = _data["has_podi"];
            this.has_prod = _data["has_prod"];
            this.has_pdr = _data["has_pdr"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerSitesReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSitesReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer_id"] = this.customer_id;
        data["address"] = this.address;
        data["iso_50001_certified_site"] = this.iso_50001_certified_site;
        data["covered_area"] = this.covered_area;
        data["telecom_network_presence"] = this.telecom_network_presence;
        data["cogeneration_availability"] = this.cogeneration_availability;
        data["last_update"] = this.last_update;
        data["excluded_areas"] = this.excluded_areas;
        data["norm_unicei_16247_1"] = this.norm_unicei_16247_1;
        data["norm_unicei_16247_2"] = this.norm_unicei_16247_2;
        data["norm_unicei_16247_3"] = this.norm_unicei_16247_3;
        data["norm_unicei_16247_4"] = this.norm_unicei_16247_4;
        data["notes"] = this.notes;
        data["property"] = this.property;
        data["type"] = this.type;
        data["availability_until"] = this.availability_until;
        data["construction_year"] = this.construction_year;
        data["renovation_year"] = this.renovation_year;
        data["energy_performance_certificate"] = this.energy_performance_certificate;
        data["efficiency_class"] = this.efficiency_class;
        data["building_envelope_walls_floors"] = this.building_envelope_walls_floors;
        data["building_envelope_insulation"] = this.building_envelope_insulation;
        data["building_envelope_transmittance"] = this.building_envelope_transmittance;
        data["fixtures_glass"] = this.fixtures_glass;
        data["fixtures_frame"] = this.fixtures_frame;
        data["fixtures_transmittance"] = this.fixtures_transmittance;
        data["fixtures_shading"] = this.fixtures_shading;
        data["img"] = this.img;
        data["climatic_zone"] = this.climatic_zone;
        data["start_summer"] = this.start_summer;
        data["start_winter"] = this.start_winter;
        data["has_podp"] = this.has_podp;
        data["has_podi"] = this.has_podi;
        data["has_prod"] = this.has_prod;
        data["has_pdr"] = this.has_pdr;
        data["id"] = this.id;
        return data;
    }
}

export interface ICustomerSitesReadDTO {
    customer_id?: string | undefined;
    address: string;
    iso_50001_certified_site?: boolean | undefined;
    covered_area?: number | undefined;
    telecom_network_presence: boolean;
    cogeneration_availability: boolean;
    last_update?: string | undefined;
    excluded_areas?: string | undefined;
    norm_unicei_16247_1?: boolean | undefined;
    norm_unicei_16247_2?: boolean | undefined;
    norm_unicei_16247_3?: boolean | undefined;
    norm_unicei_16247_4?: boolean | undefined;
    notes?: string | undefined;
    property?: string | undefined;
    type?: string | undefined;
    availability_until?: string | undefined;
    construction_year?: string | undefined;
    renovation_year?: string | undefined;
    energy_performance_certificate?: boolean | undefined;
    efficiency_class?: string | undefined;
    building_envelope_walls_floors?: string | undefined;
    building_envelope_insulation?: string | undefined;
    building_envelope_transmittance?: string | undefined;
    fixtures_glass?: string | undefined;
    fixtures_frame?: string | undefined;
    fixtures_transmittance?: string | undefined;
    fixtures_shading?: string | undefined;
    img?: string | undefined;
    climatic_zone?: string | undefined;
    start_summer?: string | undefined;
    start_winter?: string | undefined;
    has_podp?: number | undefined;
    has_podi?: number | undefined;
    has_prod?: number | undefined;
    has_pdr?: number | undefined;
    id?: string;
}

export class DeleteStatusResponse implements IDeleteStatusResponse {
    status!: string;

    constructor(data?: IDeleteStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DeleteStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface IDeleteStatusResponse {
    status: string;
}

export class DiagnosisCheckItem implements IDiagnosisCheckItem {
    code!: string;
    label!: string;
    section!: string;
    passed!: boolean;
    details?: string | undefined;

    [key: string]: any;

    constructor(data?: IDiagnosisCheckItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.code = _data["code"];
            this.label = _data["label"];
            this.section = _data["section"];
            this.passed = _data["passed"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): DiagnosisCheckItem {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisCheckItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["code"] = this.code;
        data["label"] = this.label;
        data["section"] = this.section;
        data["passed"] = this.passed;
        data["details"] = this.details;
        return data;
    }
}

export interface IDiagnosisCheckItem {
    code: string;
    label: string;
    section: string;
    passed: boolean;
    details?: string | undefined;

    [key: string]: any;
}

export class DiagnosisChecklistResponse implements IDiagnosisChecklistResponse {
    diagnosis_id!: string;
    checks!: DiagnosisCheckItem[];

    [key: string]: any;

    constructor(data?: IDiagnosisChecklistResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.checks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.diagnosis_id = _data["diagnosis_id"];
            if (Array.isArray(_data["checks"])) {
                this.checks = [] as any;
                for (let item of _data["checks"])
                    this.checks!.push(DiagnosisCheckItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DiagnosisChecklistResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisChecklistResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["diagnosis_id"] = this.diagnosis_id;
        if (Array.isArray(this.checks)) {
            data["checks"] = [];
            for (let item of this.checks)
                data["checks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDiagnosisChecklistResponse {
    diagnosis_id: string;
    checks: DiagnosisCheckItem[];

    [key: string]: any;
}

export class DiagnosisConsumptionCreateDTO implements IDiagnosisConsumptionCreateDTO {
    code!: string;
    index?: number | undefined;
    diagnosis_id?: string | undefined;
    diagnosis_energy_vector_id!: string;
    type!: ConsumptionType;
    unit_of_measurement?: string | undefined;
    reference_period_quantity?: number | undefined;
    reference_period_price?: number | undefined;
    reference_period_unitcost?: number | undefined;

    constructor(data?: IDiagnosisConsumptionCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.index = _data["index"];
            this.diagnosis_id = _data["diagnosis_id"];
            this.diagnosis_energy_vector_id = _data["diagnosis_energy_vector_id"];
            this.type = _data["type"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.reference_period_quantity = _data["reference_period_quantity"];
            this.reference_period_price = _data["reference_period_price"];
            this.reference_period_unitcost = _data["reference_period_unitcost"];
        }
    }

    static fromJS(data: any): DiagnosisConsumptionCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisConsumptionCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["index"] = this.index;
        data["diagnosis_id"] = this.diagnosis_id;
        data["diagnosis_energy_vector_id"] = this.diagnosis_energy_vector_id;
        data["type"] = this.type;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["reference_period_quantity"] = this.reference_period_quantity;
        data["reference_period_price"] = this.reference_period_price;
        data["reference_period_unitcost"] = this.reference_period_unitcost;
        return data;
    }
}

export interface IDiagnosisConsumptionCreateDTO {
    code: string;
    index?: number | undefined;
    diagnosis_id?: string | undefined;
    diagnosis_energy_vector_id: string;
    type: ConsumptionType;
    unit_of_measurement?: string | undefined;
    reference_period_quantity?: number | undefined;
    reference_period_price?: number | undefined;
    reference_period_unitcost?: number | undefined;
}

export class DiagnosisConsumptionDataCreateDTO implements IDiagnosisConsumptionDataCreateDTO {
    diagnosis_consumption_id!: string;
    month!: string;
    value?: number | undefined;

    constructor(data?: IDiagnosisConsumptionDataCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_consumption_id = _data["diagnosis_consumption_id"];
            this.month = _data["month"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DiagnosisConsumptionDataCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisConsumptionDataCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_consumption_id"] = this.diagnosis_consumption_id;
        data["month"] = this.month;
        data["value"] = this.value;
        return data;
    }
}

export interface IDiagnosisConsumptionDataCreateDTO {
    diagnosis_consumption_id: string;
    month: string;
    value?: number | undefined;
}

export class DiagnosisConsumptionDataReadDTO implements IDiagnosisConsumptionDataReadDTO {
    diagnosis_consumption_id!: string;
    month!: string;
    value?: number | undefined;
    id?: string;

    constructor(data?: IDiagnosisConsumptionDataReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_consumption_id = _data["diagnosis_consumption_id"];
            this.month = _data["month"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisConsumptionDataReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisConsumptionDataReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_consumption_id"] = this.diagnosis_consumption_id;
        data["month"] = this.month;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisConsumptionDataReadDTO {
    diagnosis_consumption_id: string;
    month: string;
    value?: number | undefined;
    id?: string;
}

export class DiagnosisConsumptionReadDTO implements IDiagnosisConsumptionReadDTO {
    code!: string;
    index?: number | undefined;
    diagnosis_id?: string | undefined;
    diagnosis_energy_vector_id!: string;
    type!: ConsumptionType;
    unit_of_measurement?: string | undefined;
    reference_period_quantity?: number | undefined;
    reference_period_price?: number | undefined;
    reference_period_unitcost?: number | undefined;
    id?: string;

    constructor(data?: IDiagnosisConsumptionReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.index = _data["index"];
            this.diagnosis_id = _data["diagnosis_id"];
            this.diagnosis_energy_vector_id = _data["diagnosis_energy_vector_id"];
            this.type = _data["type"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.reference_period_quantity = _data["reference_period_quantity"];
            this.reference_period_price = _data["reference_period_price"];
            this.reference_period_unitcost = _data["reference_period_unitcost"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisConsumptionReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisConsumptionReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["index"] = this.index;
        data["diagnosis_id"] = this.diagnosis_id;
        data["diagnosis_energy_vector_id"] = this.diagnosis_energy_vector_id;
        data["type"] = this.type;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["reference_period_quantity"] = this.reference_period_quantity;
        data["reference_period_price"] = this.reference_period_price;
        data["reference_period_unitcost"] = this.reference_period_unitcost;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisConsumptionReadDTO {
    code: string;
    index?: number | undefined;
    diagnosis_id?: string | undefined;
    diagnosis_energy_vector_id: string;
    type: ConsumptionType;
    unit_of_measurement?: string | undefined;
    reference_period_quantity?: number | undefined;
    reference_period_price?: number | undefined;
    reference_period_unitcost?: number | undefined;
    id?: string;
}

export class DiagnosisCreateDTO implements IDiagnosisCreateDTO {
    table_code_index!: string;
    site_id?: string | undefined;
    last_update?: string | undefined;
    data_generated_from?: string | undefined;
    data_generated_to?: string | undefined;
    reference_period_from?: string | undefined;
    reference_period_to?: string | undefined;
    responsible_01!: string;
    responsible_02?: string | undefined;
    responsible_03?: string | undefined;
    status?: DiagnosisStatus;
    diagnosis_date?: string | undefined;

    constructor(data?: IDiagnosisCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.status = DiagnosisStatus.Open;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.table_code_index = _data["table_code_index"];
            this.site_id = _data["site_id"];
            this.last_update = _data["last_update"];
            this.data_generated_from = _data["data_generated_from"];
            this.data_generated_to = _data["data_generated_to"];
            this.reference_period_from = _data["reference_period_from"];
            this.reference_period_to = _data["reference_period_to"];
            this.responsible_01 = _data["responsible_01"];
            this.responsible_02 = _data["responsible_02"];
            this.responsible_03 = _data["responsible_03"];
            this.status = _data["status"] !== undefined ? _data["status"] : DiagnosisStatus.Open;
            this.diagnosis_date = _data["diagnosis_date"];
        }
    }

    static fromJS(data: any): DiagnosisCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table_code_index"] = this.table_code_index;
        data["site_id"] = this.site_id;
        data["last_update"] = this.last_update;
        data["data_generated_from"] = this.data_generated_from;
        data["data_generated_to"] = this.data_generated_to;
        data["reference_period_from"] = this.reference_period_from;
        data["reference_period_to"] = this.reference_period_to;
        data["responsible_01"] = this.responsible_01;
        data["responsible_02"] = this.responsible_02;
        data["responsible_03"] = this.responsible_03;
        data["status"] = this.status;
        data["diagnosis_date"] = this.diagnosis_date;
        return data;
    }
}

export interface IDiagnosisCreateDTO {
    table_code_index: string;
    site_id?: string | undefined;
    last_update?: string | undefined;
    data_generated_from?: string | undefined;
    data_generated_to?: string | undefined;
    reference_period_from?: string | undefined;
    reference_period_to?: string | undefined;
    responsible_01: string;
    responsible_02?: string | undefined;
    responsible_03?: string | undefined;
    status?: DiagnosisStatus;
    diagnosis_date?: string | undefined;
}

export class DiagnosisCustomerCreateDTO implements IDiagnosisCustomerCreateDTO {
    original_customer_id?: string | undefined;
    company_name!: string;
    company_name_type?: string | undefined;
    ateco_2007?: string | undefined;
    ateco_2022?: string | undefined;
    ateco_2025?: string | undefined;
    last_update?: string | undefined;
    address?: string | undefined;
    city_id?: number | undefined;
    postal_code?: string | undefined;
    phone?: string | undefined;
    voluntary?: boolean | undefined;
    type?: string | undefined;
    single_multi_site?: boolean | undefined;
    clustering?: string | undefined;
    employee_count?: number | undefined;
    revenue?: number | undefined;
    balance_sheet_assets?: number | undefined;
    size_category?: string | undefined;
    consumption_category?: string | undefined;
    average_annual_consumption?: number | undefined;
    high_electricity_consumption?: boolean | undefined;
    high_gas_consumption?: boolean | undefined;
    certifications?: string | undefined;
    vat_number?: string | undefined;
    tax_code?: string | undefined;
    legal_address?: string | undefined;
    certified_email?: string | undefined;
    legal_representative?: string | undefined;
    legal_representative_phone?: string | undefined;
    legal_representative_email?: string | undefined;
    diagnosis_contact_person?: string | undefined;
    contact_person_phone?: string | undefined;
    contact_person_email?: string | undefined;

    constructor(data?: IDiagnosisCustomerCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.original_customer_id = _data["original_customer_id"];
            this.company_name = _data["company_name"];
            this.company_name_type = _data["company_name_type"];
            this.ateco_2007 = _data["ateco_2007"];
            this.ateco_2022 = _data["ateco_2022"];
            this.ateco_2025 = _data["ateco_2025"];
            this.last_update = _data["last_update"];
            this.address = _data["address"];
            this.city_id = _data["city_id"];
            this.postal_code = _data["postal_code"];
            this.phone = _data["phone"];
            this.voluntary = _data["voluntary"];
            this.type = _data["type"];
            this.single_multi_site = _data["single_multi_site"];
            this.clustering = _data["clustering"];
            this.employee_count = _data["employee_count"];
            this.revenue = _data["revenue"];
            this.balance_sheet_assets = _data["balance_sheet_assets"];
            this.size_category = _data["size_category"];
            this.consumption_category = _data["consumption_category"];
            this.average_annual_consumption = _data["average_annual_consumption"];
            this.high_electricity_consumption = _data["high_electricity_consumption"];
            this.high_gas_consumption = _data["high_gas_consumption"];
            this.certifications = _data["certifications"];
            this.vat_number = _data["vat_number"];
            this.tax_code = _data["tax_code"];
            this.legal_address = _data["legal_address"];
            this.certified_email = _data["certified_email"];
            this.legal_representative = _data["legal_representative"];
            this.legal_representative_phone = _data["legal_representative_phone"];
            this.legal_representative_email = _data["legal_representative_email"];
            this.diagnosis_contact_person = _data["diagnosis_contact_person"];
            this.contact_person_phone = _data["contact_person_phone"];
            this.contact_person_email = _data["contact_person_email"];
        }
    }

    static fromJS(data: any): DiagnosisCustomerCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisCustomerCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["original_customer_id"] = this.original_customer_id;
        data["company_name"] = this.company_name;
        data["company_name_type"] = this.company_name_type;
        data["ateco_2007"] = this.ateco_2007;
        data["ateco_2022"] = this.ateco_2022;
        data["ateco_2025"] = this.ateco_2025;
        data["last_update"] = this.last_update;
        data["address"] = this.address;
        data["city_id"] = this.city_id;
        data["postal_code"] = this.postal_code;
        data["phone"] = this.phone;
        data["voluntary"] = this.voluntary;
        data["type"] = this.type;
        data["single_multi_site"] = this.single_multi_site;
        data["clustering"] = this.clustering;
        data["employee_count"] = this.employee_count;
        data["revenue"] = this.revenue;
        data["balance_sheet_assets"] = this.balance_sheet_assets;
        data["size_category"] = this.size_category;
        data["consumption_category"] = this.consumption_category;
        data["average_annual_consumption"] = this.average_annual_consumption;
        data["high_electricity_consumption"] = this.high_electricity_consumption;
        data["high_gas_consumption"] = this.high_gas_consumption;
        data["certifications"] = this.certifications;
        data["vat_number"] = this.vat_number;
        data["tax_code"] = this.tax_code;
        data["legal_address"] = this.legal_address;
        data["certified_email"] = this.certified_email;
        data["legal_representative"] = this.legal_representative;
        data["legal_representative_phone"] = this.legal_representative_phone;
        data["legal_representative_email"] = this.legal_representative_email;
        data["diagnosis_contact_person"] = this.diagnosis_contact_person;
        data["contact_person_phone"] = this.contact_person_phone;
        data["contact_person_email"] = this.contact_person_email;
        return data;
    }
}

export interface IDiagnosisCustomerCreateDTO {
    original_customer_id?: string | undefined;
    company_name: string;
    company_name_type?: string | undefined;
    ateco_2007?: string | undefined;
    ateco_2022?: string | undefined;
    ateco_2025?: string | undefined;
    last_update?: string | undefined;
    address?: string | undefined;
    city_id?: number | undefined;
    postal_code?: string | undefined;
    phone?: string | undefined;
    voluntary?: boolean | undefined;
    type?: string | undefined;
    single_multi_site?: boolean | undefined;
    clustering?: string | undefined;
    employee_count?: number | undefined;
    revenue?: number | undefined;
    balance_sheet_assets?: number | undefined;
    size_category?: string | undefined;
    consumption_category?: string | undefined;
    average_annual_consumption?: number | undefined;
    high_electricity_consumption?: boolean | undefined;
    high_gas_consumption?: boolean | undefined;
    certifications?: string | undefined;
    vat_number?: string | undefined;
    tax_code?: string | undefined;
    legal_address?: string | undefined;
    certified_email?: string | undefined;
    legal_representative?: string | undefined;
    legal_representative_phone?: string | undefined;
    legal_representative_email?: string | undefined;
    diagnosis_contact_person?: string | undefined;
    contact_person_phone?: string | undefined;
    contact_person_email?: string | undefined;
}

export class DiagnosisCustomerReadDTO implements IDiagnosisCustomerReadDTO {
    original_customer_id?: string | undefined;
    company_name!: string;
    company_name_type?: string | undefined;
    ateco_2007?: string | undefined;
    ateco_2022?: string | undefined;
    ateco_2025?: string | undefined;
    last_update?: string | undefined;
    address?: string | undefined;
    city_id?: number | undefined;
    postal_code?: string | undefined;
    phone?: string | undefined;
    voluntary?: boolean | undefined;
    type?: string | undefined;
    single_multi_site?: boolean | undefined;
    clustering?: string | undefined;
    employee_count?: number | undefined;
    revenue?: number | undefined;
    balance_sheet_assets?: number | undefined;
    size_category?: string | undefined;
    consumption_category?: string | undefined;
    average_annual_consumption?: number | undefined;
    high_electricity_consumption?: boolean | undefined;
    high_gas_consumption?: boolean | undefined;
    certifications?: string | undefined;
    vat_number?: string | undefined;
    tax_code?: string | undefined;
    legal_address?: string | undefined;
    certified_email?: string | undefined;
    legal_representative?: string | undefined;
    legal_representative_phone?: string | undefined;
    legal_representative_email?: string | undefined;
    diagnosis_contact_person?: string | undefined;
    contact_person_phone?: string | undefined;
    contact_person_email?: string | undefined;
    id?: string;

    constructor(data?: IDiagnosisCustomerReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.original_customer_id = _data["original_customer_id"];
            this.company_name = _data["company_name"];
            this.company_name_type = _data["company_name_type"];
            this.ateco_2007 = _data["ateco_2007"];
            this.ateco_2022 = _data["ateco_2022"];
            this.ateco_2025 = _data["ateco_2025"];
            this.last_update = _data["last_update"];
            this.address = _data["address"];
            this.city_id = _data["city_id"];
            this.postal_code = _data["postal_code"];
            this.phone = _data["phone"];
            this.voluntary = _data["voluntary"];
            this.type = _data["type"];
            this.single_multi_site = _data["single_multi_site"];
            this.clustering = _data["clustering"];
            this.employee_count = _data["employee_count"];
            this.revenue = _data["revenue"];
            this.balance_sheet_assets = _data["balance_sheet_assets"];
            this.size_category = _data["size_category"];
            this.consumption_category = _data["consumption_category"];
            this.average_annual_consumption = _data["average_annual_consumption"];
            this.high_electricity_consumption = _data["high_electricity_consumption"];
            this.high_gas_consumption = _data["high_gas_consumption"];
            this.certifications = _data["certifications"];
            this.vat_number = _data["vat_number"];
            this.tax_code = _data["tax_code"];
            this.legal_address = _data["legal_address"];
            this.certified_email = _data["certified_email"];
            this.legal_representative = _data["legal_representative"];
            this.legal_representative_phone = _data["legal_representative_phone"];
            this.legal_representative_email = _data["legal_representative_email"];
            this.diagnosis_contact_person = _data["diagnosis_contact_person"];
            this.contact_person_phone = _data["contact_person_phone"];
            this.contact_person_email = _data["contact_person_email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisCustomerReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisCustomerReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["original_customer_id"] = this.original_customer_id;
        data["company_name"] = this.company_name;
        data["company_name_type"] = this.company_name_type;
        data["ateco_2007"] = this.ateco_2007;
        data["ateco_2022"] = this.ateco_2022;
        data["ateco_2025"] = this.ateco_2025;
        data["last_update"] = this.last_update;
        data["address"] = this.address;
        data["city_id"] = this.city_id;
        data["postal_code"] = this.postal_code;
        data["phone"] = this.phone;
        data["voluntary"] = this.voluntary;
        data["type"] = this.type;
        data["single_multi_site"] = this.single_multi_site;
        data["clustering"] = this.clustering;
        data["employee_count"] = this.employee_count;
        data["revenue"] = this.revenue;
        data["balance_sheet_assets"] = this.balance_sheet_assets;
        data["size_category"] = this.size_category;
        data["consumption_category"] = this.consumption_category;
        data["average_annual_consumption"] = this.average_annual_consumption;
        data["high_electricity_consumption"] = this.high_electricity_consumption;
        data["high_gas_consumption"] = this.high_gas_consumption;
        data["certifications"] = this.certifications;
        data["vat_number"] = this.vat_number;
        data["tax_code"] = this.tax_code;
        data["legal_address"] = this.legal_address;
        data["certified_email"] = this.certified_email;
        data["legal_representative"] = this.legal_representative;
        data["legal_representative_phone"] = this.legal_representative_phone;
        data["legal_representative_email"] = this.legal_representative_email;
        data["diagnosis_contact_person"] = this.diagnosis_contact_person;
        data["contact_person_phone"] = this.contact_person_phone;
        data["contact_person_email"] = this.contact_person_email;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisCustomerReadDTO {
    original_customer_id?: string | undefined;
    company_name: string;
    company_name_type?: string | undefined;
    ateco_2007?: string | undefined;
    ateco_2022?: string | undefined;
    ateco_2025?: string | undefined;
    last_update?: string | undefined;
    address?: string | undefined;
    city_id?: number | undefined;
    postal_code?: string | undefined;
    phone?: string | undefined;
    voluntary?: boolean | undefined;
    type?: string | undefined;
    single_multi_site?: boolean | undefined;
    clustering?: string | undefined;
    employee_count?: number | undefined;
    revenue?: number | undefined;
    balance_sheet_assets?: number | undefined;
    size_category?: string | undefined;
    consumption_category?: string | undefined;
    average_annual_consumption?: number | undefined;
    high_electricity_consumption?: boolean | undefined;
    high_gas_consumption?: boolean | undefined;
    certifications?: string | undefined;
    vat_number?: string | undefined;
    tax_code?: string | undefined;
    legal_address?: string | undefined;
    certified_email?: string | undefined;
    legal_representative?: string | undefined;
    legal_representative_phone?: string | undefined;
    legal_representative_email?: string | undefined;
    diagnosis_contact_person?: string | undefined;
    contact_person_phone?: string | undefined;
    contact_person_email?: string | undefined;
    id?: string;
}

export class DiagnosisCustomerSitesCreateDTO implements IDiagnosisCustomerSitesCreateDTO {
    original_site_id?: string | undefined;
    customer_id?: string | undefined;
    address!: string;
    iso_50001_certified_site?: boolean | undefined;
    covered_area?: number | undefined;
    telecom_network_presence!: boolean;
    cogeneration_availability!: boolean;
    last_update?: string | undefined;
    site_framing?: string | undefined;
    excluded_areas?: string | undefined;
    norm_unicei_16247_1?: boolean | undefined;
    norm_unicei_16247_2?: boolean | undefined;
    norm_unicei_16247_3?: boolean | undefined;
    norm_unicei_16247_4?: boolean | undefined;
    notes?: string | undefined;
    property?: string | undefined;
    type?: string | undefined;
    availability_until?: string | undefined;
    construction_year?: string | undefined;
    renovation_year?: string | undefined;
    energy_performance_certificate?: boolean | undefined;
    efficiency_class?: string | undefined;
    building_envelope_walls_floors?: string | undefined;
    building_envelope_insulation?: string | undefined;
    building_envelope_transmittance?: string | undefined;
    fixtures_glass?: string | undefined;
    fixtures_frame?: string | undefined;
    fixtures_transmittance?: string | undefined;
    fixtures_shading?: string | undefined;
    img?: string | undefined;
    climatic_zone?: string | undefined;
    start_summer?: string | undefined;
    start_winter?: string | undefined;
    has_podp?: number | undefined;
    has_podi?: number | undefined;
    has_prod?: number | undefined;
    has_pdr?: number | undefined;

    constructor(data?: IDiagnosisCustomerSitesCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.original_site_id = _data["original_site_id"];
            this.customer_id = _data["customer_id"];
            this.address = _data["address"];
            this.iso_50001_certified_site = _data["iso_50001_certified_site"];
            this.covered_area = _data["covered_area"];
            this.telecom_network_presence = _data["telecom_network_presence"];
            this.cogeneration_availability = _data["cogeneration_availability"];
            this.last_update = _data["last_update"];
            this.site_framing = _data["site_framing"];
            this.excluded_areas = _data["excluded_areas"];
            this.norm_unicei_16247_1 = _data["norm_unicei_16247_1"];
            this.norm_unicei_16247_2 = _data["norm_unicei_16247_2"];
            this.norm_unicei_16247_3 = _data["norm_unicei_16247_3"];
            this.norm_unicei_16247_4 = _data["norm_unicei_16247_4"];
            this.notes = _data["notes"];
            this.property = _data["property"];
            this.type = _data["type"];
            this.availability_until = _data["availability_until"];
            this.construction_year = _data["construction_year"];
            this.renovation_year = _data["renovation_year"];
            this.energy_performance_certificate = _data["energy_performance_certificate"];
            this.efficiency_class = _data["efficiency_class"];
            this.building_envelope_walls_floors = _data["building_envelope_walls_floors"];
            this.building_envelope_insulation = _data["building_envelope_insulation"];
            this.building_envelope_transmittance = _data["building_envelope_transmittance"];
            this.fixtures_glass = _data["fixtures_glass"];
            this.fixtures_frame = _data["fixtures_frame"];
            this.fixtures_transmittance = _data["fixtures_transmittance"];
            this.fixtures_shading = _data["fixtures_shading"];
            this.img = _data["img"];
            this.climatic_zone = _data["climatic_zone"];
            this.start_summer = _data["start_summer"];
            this.start_winter = _data["start_winter"];
            this.has_podp = _data["has_podp"];
            this.has_podi = _data["has_podi"];
            this.has_prod = _data["has_prod"];
            this.has_pdr = _data["has_pdr"];
        }
    }

    static fromJS(data: any): DiagnosisCustomerSitesCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisCustomerSitesCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["original_site_id"] = this.original_site_id;
        data["customer_id"] = this.customer_id;
        data["address"] = this.address;
        data["iso_50001_certified_site"] = this.iso_50001_certified_site;
        data["covered_area"] = this.covered_area;
        data["telecom_network_presence"] = this.telecom_network_presence;
        data["cogeneration_availability"] = this.cogeneration_availability;
        data["last_update"] = this.last_update;
        data["site_framing"] = this.site_framing;
        data["excluded_areas"] = this.excluded_areas;
        data["norm_unicei_16247_1"] = this.norm_unicei_16247_1;
        data["norm_unicei_16247_2"] = this.norm_unicei_16247_2;
        data["norm_unicei_16247_3"] = this.norm_unicei_16247_3;
        data["norm_unicei_16247_4"] = this.norm_unicei_16247_4;
        data["notes"] = this.notes;
        data["property"] = this.property;
        data["type"] = this.type;
        data["availability_until"] = this.availability_until;
        data["construction_year"] = this.construction_year;
        data["renovation_year"] = this.renovation_year;
        data["energy_performance_certificate"] = this.energy_performance_certificate;
        data["efficiency_class"] = this.efficiency_class;
        data["building_envelope_walls_floors"] = this.building_envelope_walls_floors;
        data["building_envelope_insulation"] = this.building_envelope_insulation;
        data["building_envelope_transmittance"] = this.building_envelope_transmittance;
        data["fixtures_glass"] = this.fixtures_glass;
        data["fixtures_frame"] = this.fixtures_frame;
        data["fixtures_transmittance"] = this.fixtures_transmittance;
        data["fixtures_shading"] = this.fixtures_shading;
        data["img"] = this.img;
        data["climatic_zone"] = this.climatic_zone;
        data["start_summer"] = this.start_summer;
        data["start_winter"] = this.start_winter;
        data["has_podp"] = this.has_podp;
        data["has_podi"] = this.has_podi;
        data["has_prod"] = this.has_prod;
        data["has_pdr"] = this.has_pdr;
        return data;
    }
}

export interface IDiagnosisCustomerSitesCreateDTO {
    original_site_id?: string | undefined;
    customer_id?: string | undefined;
    address: string;
    iso_50001_certified_site?: boolean | undefined;
    covered_area?: number | undefined;
    telecom_network_presence: boolean;
    cogeneration_availability: boolean;
    last_update?: string | undefined;
    site_framing?: string | undefined;
    excluded_areas?: string | undefined;
    norm_unicei_16247_1?: boolean | undefined;
    norm_unicei_16247_2?: boolean | undefined;
    norm_unicei_16247_3?: boolean | undefined;
    norm_unicei_16247_4?: boolean | undefined;
    notes?: string | undefined;
    property?: string | undefined;
    type?: string | undefined;
    availability_until?: string | undefined;
    construction_year?: string | undefined;
    renovation_year?: string | undefined;
    energy_performance_certificate?: boolean | undefined;
    efficiency_class?: string | undefined;
    building_envelope_walls_floors?: string | undefined;
    building_envelope_insulation?: string | undefined;
    building_envelope_transmittance?: string | undefined;
    fixtures_glass?: string | undefined;
    fixtures_frame?: string | undefined;
    fixtures_transmittance?: string | undefined;
    fixtures_shading?: string | undefined;
    img?: string | undefined;
    climatic_zone?: string | undefined;
    start_summer?: string | undefined;
    start_winter?: string | undefined;
    has_podp?: number | undefined;
    has_podi?: number | undefined;
    has_prod?: number | undefined;
    has_pdr?: number | undefined;
}

export class DiagnosisCustomerSitesReadDTO implements IDiagnosisCustomerSitesReadDTO {
    original_site_id?: string | undefined;
    customer_id?: string | undefined;
    address!: string;
    iso_50001_certified_site?: boolean | undefined;
    covered_area?: number | undefined;
    telecom_network_presence!: boolean;
    cogeneration_availability!: boolean;
    last_update?: string | undefined;
    site_framing?: string | undefined;
    excluded_areas?: string | undefined;
    norm_unicei_16247_1?: boolean | undefined;
    norm_unicei_16247_2?: boolean | undefined;
    norm_unicei_16247_3?: boolean | undefined;
    norm_unicei_16247_4?: boolean | undefined;
    notes?: string | undefined;
    property?: string | undefined;
    type?: string | undefined;
    availability_until?: string | undefined;
    construction_year?: string | undefined;
    renovation_year?: string | undefined;
    energy_performance_certificate?: boolean | undefined;
    efficiency_class?: string | undefined;
    building_envelope_walls_floors?: string | undefined;
    building_envelope_insulation?: string | undefined;
    building_envelope_transmittance?: string | undefined;
    fixtures_glass?: string | undefined;
    fixtures_frame?: string | undefined;
    fixtures_transmittance?: string | undefined;
    fixtures_shading?: string | undefined;
    img?: string | undefined;
    climatic_zone?: string | undefined;
    start_summer?: string | undefined;
    start_winter?: string | undefined;
    has_podp?: number | undefined;
    has_podi?: number | undefined;
    has_prod?: number | undefined;
    has_pdr?: number | undefined;
    id?: string;

    constructor(data?: IDiagnosisCustomerSitesReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.original_site_id = _data["original_site_id"];
            this.customer_id = _data["customer_id"];
            this.address = _data["address"];
            this.iso_50001_certified_site = _data["iso_50001_certified_site"];
            this.covered_area = _data["covered_area"];
            this.telecom_network_presence = _data["telecom_network_presence"];
            this.cogeneration_availability = _data["cogeneration_availability"];
            this.last_update = _data["last_update"];
            this.site_framing = _data["site_framing"];
            this.excluded_areas = _data["excluded_areas"];
            this.norm_unicei_16247_1 = _data["norm_unicei_16247_1"];
            this.norm_unicei_16247_2 = _data["norm_unicei_16247_2"];
            this.norm_unicei_16247_3 = _data["norm_unicei_16247_3"];
            this.norm_unicei_16247_4 = _data["norm_unicei_16247_4"];
            this.notes = _data["notes"];
            this.property = _data["property"];
            this.type = _data["type"];
            this.availability_until = _data["availability_until"];
            this.construction_year = _data["construction_year"];
            this.renovation_year = _data["renovation_year"];
            this.energy_performance_certificate = _data["energy_performance_certificate"];
            this.efficiency_class = _data["efficiency_class"];
            this.building_envelope_walls_floors = _data["building_envelope_walls_floors"];
            this.building_envelope_insulation = _data["building_envelope_insulation"];
            this.building_envelope_transmittance = _data["building_envelope_transmittance"];
            this.fixtures_glass = _data["fixtures_glass"];
            this.fixtures_frame = _data["fixtures_frame"];
            this.fixtures_transmittance = _data["fixtures_transmittance"];
            this.fixtures_shading = _data["fixtures_shading"];
            this.img = _data["img"];
            this.climatic_zone = _data["climatic_zone"];
            this.start_summer = _data["start_summer"];
            this.start_winter = _data["start_winter"];
            this.has_podp = _data["has_podp"];
            this.has_podi = _data["has_podi"];
            this.has_prod = _data["has_prod"];
            this.has_pdr = _data["has_pdr"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisCustomerSitesReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisCustomerSitesReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["original_site_id"] = this.original_site_id;
        data["customer_id"] = this.customer_id;
        data["address"] = this.address;
        data["iso_50001_certified_site"] = this.iso_50001_certified_site;
        data["covered_area"] = this.covered_area;
        data["telecom_network_presence"] = this.telecom_network_presence;
        data["cogeneration_availability"] = this.cogeneration_availability;
        data["last_update"] = this.last_update;
        data["site_framing"] = this.site_framing;
        data["excluded_areas"] = this.excluded_areas;
        data["norm_unicei_16247_1"] = this.norm_unicei_16247_1;
        data["norm_unicei_16247_2"] = this.norm_unicei_16247_2;
        data["norm_unicei_16247_3"] = this.norm_unicei_16247_3;
        data["norm_unicei_16247_4"] = this.norm_unicei_16247_4;
        data["notes"] = this.notes;
        data["property"] = this.property;
        data["type"] = this.type;
        data["availability_until"] = this.availability_until;
        data["construction_year"] = this.construction_year;
        data["renovation_year"] = this.renovation_year;
        data["energy_performance_certificate"] = this.energy_performance_certificate;
        data["efficiency_class"] = this.efficiency_class;
        data["building_envelope_walls_floors"] = this.building_envelope_walls_floors;
        data["building_envelope_insulation"] = this.building_envelope_insulation;
        data["building_envelope_transmittance"] = this.building_envelope_transmittance;
        data["fixtures_glass"] = this.fixtures_glass;
        data["fixtures_frame"] = this.fixtures_frame;
        data["fixtures_transmittance"] = this.fixtures_transmittance;
        data["fixtures_shading"] = this.fixtures_shading;
        data["img"] = this.img;
        data["climatic_zone"] = this.climatic_zone;
        data["start_summer"] = this.start_summer;
        data["start_winter"] = this.start_winter;
        data["has_podp"] = this.has_podp;
        data["has_podi"] = this.has_podi;
        data["has_prod"] = this.has_prod;
        data["has_pdr"] = this.has_pdr;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisCustomerSitesReadDTO {
    original_site_id?: string | undefined;
    customer_id?: string | undefined;
    address: string;
    iso_50001_certified_site?: boolean | undefined;
    covered_area?: number | undefined;
    telecom_network_presence: boolean;
    cogeneration_availability: boolean;
    last_update?: string | undefined;
    site_framing?: string | undefined;
    excluded_areas?: string | undefined;
    norm_unicei_16247_1?: boolean | undefined;
    norm_unicei_16247_2?: boolean | undefined;
    norm_unicei_16247_3?: boolean | undefined;
    norm_unicei_16247_4?: boolean | undefined;
    notes?: string | undefined;
    property?: string | undefined;
    type?: string | undefined;
    availability_until?: string | undefined;
    construction_year?: string | undefined;
    renovation_year?: string | undefined;
    energy_performance_certificate?: boolean | undefined;
    efficiency_class?: string | undefined;
    building_envelope_walls_floors?: string | undefined;
    building_envelope_insulation?: string | undefined;
    building_envelope_transmittance?: string | undefined;
    fixtures_glass?: string | undefined;
    fixtures_frame?: string | undefined;
    fixtures_transmittance?: string | undefined;
    fixtures_shading?: string | undefined;
    img?: string | undefined;
    climatic_zone?: string | undefined;
    start_summer?: string | undefined;
    start_winter?: string | undefined;
    has_podp?: number | undefined;
    has_podi?: number | undefined;
    has_prod?: number | undefined;
    has_pdr?: number | undefined;
    id?: string;
}

export class DiagnosisEnergyBalanceCreateDTO implements IDiagnosisEnergyBalanceCreateDTO {
    diagnosis_id!: string;
    diagnosis_energy_vector_id!: string;
    tep?: number | undefined;
    tj?: number | undefined;
    co2?: number | undefined;
    percentage?: number | undefined;
    isToMonitored?: boolean | undefined;

    constructor(data?: IDiagnosisEnergyBalanceCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_id = _data["diagnosis_id"];
            this.diagnosis_energy_vector_id = _data["diagnosis_energy_vector_id"];
            this.tep = _data["tep"];
            this.tj = _data["tj"];
            this.co2 = _data["co2"];
            this.percentage = _data["percentage"];
            this.isToMonitored = _data["isToMonitored"];
        }
    }

    static fromJS(data: any): DiagnosisEnergyBalanceCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisEnergyBalanceCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_id"] = this.diagnosis_id;
        data["diagnosis_energy_vector_id"] = this.diagnosis_energy_vector_id;
        data["tep"] = this.tep;
        data["tj"] = this.tj;
        data["co2"] = this.co2;
        data["percentage"] = this.percentage;
        data["isToMonitored"] = this.isToMonitored;
        return data;
    }
}

export interface IDiagnosisEnergyBalanceCreateDTO {
    diagnosis_id: string;
    diagnosis_energy_vector_id: string;
    tep?: number | undefined;
    tj?: number | undefined;
    co2?: number | undefined;
    percentage?: number | undefined;
    isToMonitored?: boolean | undefined;
}

export class DiagnosisEnergyBalanceReadDTO implements IDiagnosisEnergyBalanceReadDTO {
    diagnosis_id!: string;
    diagnosis_energy_vector_id!: string;
    tep?: number | undefined;
    tj?: number | undefined;
    co2?: number | undefined;
    percentage?: number | undefined;
    isToMonitored?: boolean | undefined;
    id?: string;

    constructor(data?: IDiagnosisEnergyBalanceReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_id = _data["diagnosis_id"];
            this.diagnosis_energy_vector_id = _data["diagnosis_energy_vector_id"];
            this.tep = _data["tep"];
            this.tj = _data["tj"];
            this.co2 = _data["co2"];
            this.percentage = _data["percentage"];
            this.isToMonitored = _data["isToMonitored"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisEnergyBalanceReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisEnergyBalanceReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_id"] = this.diagnosis_id;
        data["diagnosis_energy_vector_id"] = this.diagnosis_energy_vector_id;
        data["tep"] = this.tep;
        data["tj"] = this.tj;
        data["co2"] = this.co2;
        data["percentage"] = this.percentage;
        data["isToMonitored"] = this.isToMonitored;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisEnergyBalanceReadDTO {
    diagnosis_id: string;
    diagnosis_energy_vector_id: string;
    tep?: number | undefined;
    tj?: number | undefined;
    co2?: number | undefined;
    percentage?: number | undefined;
    isToMonitored?: boolean | undefined;
    id?: string;
}

export class DiagnosisEnergyUseCreateDTO implements IDiagnosisEnergyUseCreateDTO {
    original_energy_use_id?: string | undefined;
    diagnosis_id?: string | undefined;
    code!: string;
    description?: string | undefined;

    constructor(data?: IDiagnosisEnergyUseCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.original_energy_use_id = _data["original_energy_use_id"];
            this.diagnosis_id = _data["diagnosis_id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DiagnosisEnergyUseCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisEnergyUseCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["original_energy_use_id"] = this.original_energy_use_id;
        data["diagnosis_id"] = this.diagnosis_id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IDiagnosisEnergyUseCreateDTO {
    original_energy_use_id?: string | undefined;
    diagnosis_id?: string | undefined;
    code: string;
    description?: string | undefined;
}

export class DiagnosisEnergyUseReadDTO implements IDiagnosisEnergyUseReadDTO {
    original_energy_use_id?: string | undefined;
    diagnosis_id?: string | undefined;
    code!: string;
    description?: string | undefined;
    id?: string;

    constructor(data?: IDiagnosisEnergyUseReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.original_energy_use_id = _data["original_energy_use_id"];
            this.diagnosis_id = _data["diagnosis_id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisEnergyUseReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisEnergyUseReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["original_energy_use_id"] = this.original_energy_use_id;
        data["diagnosis_id"] = this.diagnosis_id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisEnergyUseReadDTO {
    original_energy_use_id?: string | undefined;
    diagnosis_id?: string | undefined;
    code: string;
    description?: string | undefined;
    id?: string;
}

export class DiagnosisEnergyUseSettingsCreateDTO implements IDiagnosisEnergyUseSettingsCreateDTO {
    diagnosis_id?: string | undefined;
    default_energy_relevance_lower_limit!: number;
    default_energy_relevance_upper_limit!: number;
    weight_energy_relevance!: number;
    weight_technological_gap_vs_bats!: number;
    weight_plant_management!: number;
    knowledge_measurement!: number;
    minimum_threshold!: number;

    constructor(data?: IDiagnosisEnergyUseSettingsCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_id = _data["diagnosis_id"];
            this.default_energy_relevance_lower_limit = _data["default_energy_relevance_lower_limit"];
            this.default_energy_relevance_upper_limit = _data["default_energy_relevance_upper_limit"];
            this.weight_energy_relevance = _data["weight_energy_relevance"];
            this.weight_technological_gap_vs_bats = _data["weight_technological_gap_vs_bats"];
            this.weight_plant_management = _data["weight_plant_management"];
            this.knowledge_measurement = _data["knowledge_measurement"];
            this.minimum_threshold = _data["minimum_threshold"];
        }
    }

    static fromJS(data: any): DiagnosisEnergyUseSettingsCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisEnergyUseSettingsCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_id"] = this.diagnosis_id;
        data["default_energy_relevance_lower_limit"] = this.default_energy_relevance_lower_limit;
        data["default_energy_relevance_upper_limit"] = this.default_energy_relevance_upper_limit;
        data["weight_energy_relevance"] = this.weight_energy_relevance;
        data["weight_technological_gap_vs_bats"] = this.weight_technological_gap_vs_bats;
        data["weight_plant_management"] = this.weight_plant_management;
        data["knowledge_measurement"] = this.knowledge_measurement;
        data["minimum_threshold"] = this.minimum_threshold;
        return data;
    }
}

export interface IDiagnosisEnergyUseSettingsCreateDTO {
    diagnosis_id?: string | undefined;
    default_energy_relevance_lower_limit: number;
    default_energy_relevance_upper_limit: number;
    weight_energy_relevance: number;
    weight_technological_gap_vs_bats: number;
    weight_plant_management: number;
    knowledge_measurement: number;
    minimum_threshold: number;
}

export class DiagnosisEnergyUseSettingsReadDTO implements IDiagnosisEnergyUseSettingsReadDTO {
    diagnosis_id?: string | undefined;
    default_energy_relevance_lower_limit!: number;
    default_energy_relevance_upper_limit!: number;
    weight_energy_relevance!: number;
    weight_technological_gap_vs_bats!: number;
    weight_plant_management!: number;
    knowledge_measurement!: number;
    minimum_threshold!: number;
    id?: string;

    constructor(data?: IDiagnosisEnergyUseSettingsReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_id = _data["diagnosis_id"];
            this.default_energy_relevance_lower_limit = _data["default_energy_relevance_lower_limit"];
            this.default_energy_relevance_upper_limit = _data["default_energy_relevance_upper_limit"];
            this.weight_energy_relevance = _data["weight_energy_relevance"];
            this.weight_technological_gap_vs_bats = _data["weight_technological_gap_vs_bats"];
            this.weight_plant_management = _data["weight_plant_management"];
            this.knowledge_measurement = _data["knowledge_measurement"];
            this.minimum_threshold = _data["minimum_threshold"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisEnergyUseSettingsReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisEnergyUseSettingsReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_id"] = this.diagnosis_id;
        data["default_energy_relevance_lower_limit"] = this.default_energy_relevance_lower_limit;
        data["default_energy_relevance_upper_limit"] = this.default_energy_relevance_upper_limit;
        data["weight_energy_relevance"] = this.weight_energy_relevance;
        data["weight_technological_gap_vs_bats"] = this.weight_technological_gap_vs_bats;
        data["weight_plant_management"] = this.weight_plant_management;
        data["knowledge_measurement"] = this.knowledge_measurement;
        data["minimum_threshold"] = this.minimum_threshold;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisEnergyUseSettingsReadDTO {
    diagnosis_id?: string | undefined;
    default_energy_relevance_lower_limit: number;
    default_energy_relevance_upper_limit: number;
    weight_energy_relevance: number;
    weight_technological_gap_vs_bats: number;
    weight_plant_management: number;
    knowledge_measurement: number;
    minimum_threshold: number;
    id?: string;
}

export class DiagnosisEnergyUseTotalsDataCreateDTO implements IDiagnosisEnergyUseTotalsDataCreateDTO {
    diagnosis_id!: string;
    energy_use_id!: string;
    total_consumption?: number | undefined;
    total_percentage?: number | undefined;
    energy_relevance?: number | undefined;
    technological_gap_vs_bats?: number | undefined;
    plant_management?: number | undefined;
    knowledge_measurement?: number | undefined;
    weighted_average_criticality?: number | undefined;
    significance_of_energy_use?: boolean | undefined;

    constructor(data?: IDiagnosisEnergyUseTotalsDataCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_id = _data["diagnosis_id"];
            this.energy_use_id = _data["energy_use_id"];
            this.total_consumption = _data["total_consumption"];
            this.total_percentage = _data["total_percentage"];
            this.energy_relevance = _data["energy_relevance"];
            this.technological_gap_vs_bats = _data["technological_gap_vs_bats"];
            this.plant_management = _data["plant_management"];
            this.knowledge_measurement = _data["knowledge_measurement"];
            this.weighted_average_criticality = _data["weighted_average_criticality"];
            this.significance_of_energy_use = _data["significance_of_energy_use"];
        }
    }

    static fromJS(data: any): DiagnosisEnergyUseTotalsDataCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisEnergyUseTotalsDataCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_id"] = this.diagnosis_id;
        data["energy_use_id"] = this.energy_use_id;
        data["total_consumption"] = this.total_consumption;
        data["total_percentage"] = this.total_percentage;
        data["energy_relevance"] = this.energy_relevance;
        data["technological_gap_vs_bats"] = this.technological_gap_vs_bats;
        data["plant_management"] = this.plant_management;
        data["knowledge_measurement"] = this.knowledge_measurement;
        data["weighted_average_criticality"] = this.weighted_average_criticality;
        data["significance_of_energy_use"] = this.significance_of_energy_use;
        return data;
    }
}

export interface IDiagnosisEnergyUseTotalsDataCreateDTO {
    diagnosis_id: string;
    energy_use_id: string;
    total_consumption?: number | undefined;
    total_percentage?: number | undefined;
    energy_relevance?: number | undefined;
    technological_gap_vs_bats?: number | undefined;
    plant_management?: number | undefined;
    knowledge_measurement?: number | undefined;
    weighted_average_criticality?: number | undefined;
    significance_of_energy_use?: boolean | undefined;
}

export class DiagnosisEnergyUseTotalsDataReadDTO implements IDiagnosisEnergyUseTotalsDataReadDTO {
    diagnosis_id!: string;
    energy_use_id!: string;
    total_consumption?: number | undefined;
    total_percentage?: number | undefined;
    energy_relevance?: number | undefined;
    technological_gap_vs_bats?: number | undefined;
    plant_management?: number | undefined;
    knowledge_measurement?: number | undefined;
    weighted_average_criticality?: number | undefined;
    significance_of_energy_use?: boolean | undefined;
    id?: string;

    constructor(data?: IDiagnosisEnergyUseTotalsDataReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_id = _data["diagnosis_id"];
            this.energy_use_id = _data["energy_use_id"];
            this.total_consumption = _data["total_consumption"];
            this.total_percentage = _data["total_percentage"];
            this.energy_relevance = _data["energy_relevance"];
            this.technological_gap_vs_bats = _data["technological_gap_vs_bats"];
            this.plant_management = _data["plant_management"];
            this.knowledge_measurement = _data["knowledge_measurement"];
            this.weighted_average_criticality = _data["weighted_average_criticality"];
            this.significance_of_energy_use = _data["significance_of_energy_use"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisEnergyUseTotalsDataReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisEnergyUseTotalsDataReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_id"] = this.diagnosis_id;
        data["energy_use_id"] = this.energy_use_id;
        data["total_consumption"] = this.total_consumption;
        data["total_percentage"] = this.total_percentage;
        data["energy_relevance"] = this.energy_relevance;
        data["technological_gap_vs_bats"] = this.technological_gap_vs_bats;
        data["plant_management"] = this.plant_management;
        data["knowledge_measurement"] = this.knowledge_measurement;
        data["weighted_average_criticality"] = this.weighted_average_criticality;
        data["significance_of_energy_use"] = this.significance_of_energy_use;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisEnergyUseTotalsDataReadDTO {
    diagnosis_id: string;
    energy_use_id: string;
    total_consumption?: number | undefined;
    total_percentage?: number | undefined;
    energy_relevance?: number | undefined;
    technological_gap_vs_bats?: number | undefined;
    plant_management?: number | undefined;
    knowledge_measurement?: number | undefined;
    weighted_average_criticality?: number | undefined;
    significance_of_energy_use?: boolean | undefined;
    id?: string;
}

export class DiagnosisEnergyUseVectorDataCreateDTO implements IDiagnosisEnergyUseVectorDataCreateDTO {
    diagnosis_id!: string;
    energy_use_id!: string;
    energy_vector_id!: string;
    consumption?: number | undefined;
    percentage?: number | undefined;
    cost?: number | undefined;

    constructor(data?: IDiagnosisEnergyUseVectorDataCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_id = _data["diagnosis_id"];
            this.energy_use_id = _data["energy_use_id"];
            this.energy_vector_id = _data["energy_vector_id"];
            this.consumption = _data["consumption"];
            this.percentage = _data["percentage"];
            this.cost = _data["cost"];
        }
    }

    static fromJS(data: any): DiagnosisEnergyUseVectorDataCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisEnergyUseVectorDataCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_id"] = this.diagnosis_id;
        data["energy_use_id"] = this.energy_use_id;
        data["energy_vector_id"] = this.energy_vector_id;
        data["consumption"] = this.consumption;
        data["percentage"] = this.percentage;
        data["cost"] = this.cost;
        return data;
    }
}

export interface IDiagnosisEnergyUseVectorDataCreateDTO {
    diagnosis_id: string;
    energy_use_id: string;
    energy_vector_id: string;
    consumption?: number | undefined;
    percentage?: number | undefined;
    cost?: number | undefined;
}

export class DiagnosisEnergyUseVectorDataReadDTO implements IDiagnosisEnergyUseVectorDataReadDTO {
    diagnosis_id!: string;
    energy_use_id!: string;
    energy_vector_id!: string;
    consumption?: number | undefined;
    percentage?: number | undefined;
    cost?: number | undefined;
    id?: string;

    constructor(data?: IDiagnosisEnergyUseVectorDataReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_id = _data["diagnosis_id"];
            this.energy_use_id = _data["energy_use_id"];
            this.energy_vector_id = _data["energy_vector_id"];
            this.consumption = _data["consumption"];
            this.percentage = _data["percentage"];
            this.cost = _data["cost"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisEnergyUseVectorDataReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisEnergyUseVectorDataReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_id"] = this.diagnosis_id;
        data["energy_use_id"] = this.energy_use_id;
        data["energy_vector_id"] = this.energy_vector_id;
        data["consumption"] = this.consumption;
        data["percentage"] = this.percentage;
        data["cost"] = this.cost;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisEnergyUseVectorDataReadDTO {
    diagnosis_id: string;
    energy_use_id: string;
    energy_vector_id: string;
    consumption?: number | undefined;
    percentage?: number | undefined;
    cost?: number | undefined;
    id?: string;
}

export class DiagnosisEnergyVectorsCreateDTO implements IDiagnosisEnergyVectorsCreateDTO {
    original_energy_vector_id?: string | undefined;
    diagnosis_id?: string | undefined;
    table_code_index!: string;
    co2_factor?: number | undefined;
    tep_factor?: number | undefined;
    tj_factor?: number | undefined;
    kwh_factor?: number | undefined;
    density?: number | undefined;
    code!: string;
    vector_type?: string | undefined;
    unit_of_measurement?: string | undefined;

    constructor(data?: IDiagnosisEnergyVectorsCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.original_energy_vector_id = _data["original_energy_vector_id"];
            this.diagnosis_id = _data["diagnosis_id"];
            this.table_code_index = _data["table_code_index"];
            this.co2_factor = _data["co2_factor"];
            this.tep_factor = _data["tep_factor"];
            this.tj_factor = _data["tj_factor"];
            this.kwh_factor = _data["kwh_factor"];
            this.density = _data["density"];
            this.code = _data["code"];
            this.vector_type = _data["vector_type"];
            this.unit_of_measurement = _data["unit_of_measurement"];
        }
    }

    static fromJS(data: any): DiagnosisEnergyVectorsCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisEnergyVectorsCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["original_energy_vector_id"] = this.original_energy_vector_id;
        data["diagnosis_id"] = this.diagnosis_id;
        data["table_code_index"] = this.table_code_index;
        data["co2_factor"] = this.co2_factor;
        data["tep_factor"] = this.tep_factor;
        data["tj_factor"] = this.tj_factor;
        data["kwh_factor"] = this.kwh_factor;
        data["density"] = this.density;
        data["code"] = this.code;
        data["vector_type"] = this.vector_type;
        data["unit_of_measurement"] = this.unit_of_measurement;
        return data;
    }
}

export interface IDiagnosisEnergyVectorsCreateDTO {
    original_energy_vector_id?: string | undefined;
    diagnosis_id?: string | undefined;
    table_code_index: string;
    co2_factor?: number | undefined;
    tep_factor?: number | undefined;
    tj_factor?: number | undefined;
    kwh_factor?: number | undefined;
    density?: number | undefined;
    code: string;
    vector_type?: string | undefined;
    unit_of_measurement?: string | undefined;
}

export class DiagnosisEnergyVectorsReadDTO implements IDiagnosisEnergyVectorsReadDTO {
    original_energy_vector_id?: string | undefined;
    diagnosis_id?: string | undefined;
    table_code_index!: string;
    co2_factor?: number | undefined;
    tep_factor?: number | undefined;
    tj_factor?: number | undefined;
    kwh_factor?: number | undefined;
    density?: number | undefined;
    code!: string;
    vector_type?: string | undefined;
    unit_of_measurement?: string | undefined;
    id?: string;

    constructor(data?: IDiagnosisEnergyVectorsReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.original_energy_vector_id = _data["original_energy_vector_id"];
            this.diagnosis_id = _data["diagnosis_id"];
            this.table_code_index = _data["table_code_index"];
            this.co2_factor = _data["co2_factor"];
            this.tep_factor = _data["tep_factor"];
            this.tj_factor = _data["tj_factor"];
            this.kwh_factor = _data["kwh_factor"];
            this.density = _data["density"];
            this.code = _data["code"];
            this.vector_type = _data["vector_type"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisEnergyVectorsReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisEnergyVectorsReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["original_energy_vector_id"] = this.original_energy_vector_id;
        data["diagnosis_id"] = this.diagnosis_id;
        data["table_code_index"] = this.table_code_index;
        data["co2_factor"] = this.co2_factor;
        data["tep_factor"] = this.tep_factor;
        data["tj_factor"] = this.tj_factor;
        data["kwh_factor"] = this.kwh_factor;
        data["density"] = this.density;
        data["code"] = this.code;
        data["vector_type"] = this.vector_type;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisEnergyVectorsReadDTO {
    original_energy_vector_id?: string | undefined;
    diagnosis_id?: string | undefined;
    table_code_index: string;
    co2_factor?: number | undefined;
    tep_factor?: number | undefined;
    tj_factor?: number | undefined;
    kwh_factor?: number | undefined;
    density?: number | undefined;
    code: string;
    vector_type?: string | undefined;
    unit_of_measurement?: string | undefined;
    id?: string;
}

export class DiagnosisIncidenceEneaCreateDTO implements IDiagnosisIncidenceEneaCreateDTO {
    original_incidence_enea_id?: string | undefined;
    diagnosis_id?: string | undefined;
    code!: string;
    unit_of_measurement?: string | undefined;
    codice_ateco?: string[];
    minimum_percentage_consideration?: number | undefined;
    customTotal?: number | undefined;
    total_tep_override?: number | undefined;

    constructor(data?: IDiagnosisIncidenceEneaCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.original_incidence_enea_id = _data["original_incidence_enea_id"];
            this.diagnosis_id = _data["diagnosis_id"];
            this.code = _data["code"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            if (Array.isArray(_data["codice_ateco"])) {
                this.codice_ateco = [] as any;
                for (let item of _data["codice_ateco"])
                    this.codice_ateco!.push(item);
            }
            this.minimum_percentage_consideration = _data["minimum_percentage_consideration"];
            this.customTotal = _data["customTotal"];
            this.total_tep_override = _data["total_tep_override"];
        }
    }

    static fromJS(data: any): DiagnosisIncidenceEneaCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisIncidenceEneaCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["original_incidence_enea_id"] = this.original_incidence_enea_id;
        data["diagnosis_id"] = this.diagnosis_id;
        data["code"] = this.code;
        data["unit_of_measurement"] = this.unit_of_measurement;
        if (Array.isArray(this.codice_ateco)) {
            data["codice_ateco"] = [];
            for (let item of this.codice_ateco)
                data["codice_ateco"].push(item);
        }
        data["minimum_percentage_consideration"] = this.minimum_percentage_consideration;
        data["customTotal"] = this.customTotal;
        data["total_tep_override"] = this.total_tep_override;
        return data;
    }
}

export interface IDiagnosisIncidenceEneaCreateDTO {
    original_incidence_enea_id?: string | undefined;
    diagnosis_id?: string | undefined;
    code: string;
    unit_of_measurement?: string | undefined;
    codice_ateco?: string[];
    minimum_percentage_consideration?: number | undefined;
    customTotal?: number | undefined;
    total_tep_override?: number | undefined;
}

export class DiagnosisIncidenceEneaPercentageCreateDTO implements IDiagnosisIncidenceEneaPercentageCreateDTO {
    incidence_enea_id!: string;
    from_value!: number;
    to_value?: number | undefined;
    functional_area!: FunctionalArea;
    percentage!: number;

    constructor(data?: IDiagnosisIncidenceEneaPercentageCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incidence_enea_id = _data["incidence_enea_id"];
            this.from_value = _data["from_value"];
            this.to_value = _data["to_value"];
            this.functional_area = _data["functional_area"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): DiagnosisIncidenceEneaPercentageCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisIncidenceEneaPercentageCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidence_enea_id"] = this.incidence_enea_id;
        data["from_value"] = this.from_value;
        data["to_value"] = this.to_value;
        data["functional_area"] = this.functional_area;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IDiagnosisIncidenceEneaPercentageCreateDTO {
    incidence_enea_id: string;
    from_value: number;
    to_value?: number | undefined;
    functional_area: FunctionalArea;
    percentage: number;
}

export class DiagnosisIncidenceEneaPercentageReadDTO implements IDiagnosisIncidenceEneaPercentageReadDTO {
    incidence_enea_id!: string;
    from_value!: number;
    to_value?: number | undefined;
    functional_area!: FunctionalArea;
    percentage!: number;
    id?: string;

    constructor(data?: IDiagnosisIncidenceEneaPercentageReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incidence_enea_id = _data["incidence_enea_id"];
            this.from_value = _data["from_value"];
            this.to_value = _data["to_value"];
            this.functional_area = _data["functional_area"];
            this.percentage = _data["percentage"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisIncidenceEneaPercentageReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisIncidenceEneaPercentageReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidence_enea_id"] = this.incidence_enea_id;
        data["from_value"] = this.from_value;
        data["to_value"] = this.to_value;
        data["functional_area"] = this.functional_area;
        data["percentage"] = this.percentage;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisIncidenceEneaPercentageReadDTO {
    incidence_enea_id: string;
    from_value: number;
    to_value?: number | undefined;
    functional_area: FunctionalArea;
    percentage: number;
    id?: string;
}

export class DiagnosisIncidenceEneaReadDTO implements IDiagnosisIncidenceEneaReadDTO {
    id!: string;
    original_incidence_enea_id?: string | undefined;
    diagnosis_id?: string | undefined;
    code!: string;
    unit_of_measurement?: string | undefined;
    codice_ateco?: string[];
    minimum_percentage_consideration?: number | undefined;
    customTotal?: number | undefined;
    total_tep_override?: number | undefined;

    constructor(data?: IDiagnosisIncidenceEneaReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.original_incidence_enea_id = _data["original_incidence_enea_id"];
            this.diagnosis_id = _data["diagnosis_id"];
            this.code = _data["code"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            if (Array.isArray(_data["codice_ateco"])) {
                this.codice_ateco = [] as any;
                for (let item of _data["codice_ateco"])
                    this.codice_ateco!.push(item);
            }
            this.minimum_percentage_consideration = _data["minimum_percentage_consideration"];
            this.customTotal = _data["customTotal"];
            this.total_tep_override = _data["total_tep_override"];
        }
    }

    static fromJS(data: any): DiagnosisIncidenceEneaReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisIncidenceEneaReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["original_incidence_enea_id"] = this.original_incidence_enea_id;
        data["diagnosis_id"] = this.diagnosis_id;
        data["code"] = this.code;
        data["unit_of_measurement"] = this.unit_of_measurement;
        if (Array.isArray(this.codice_ateco)) {
            data["codice_ateco"] = [];
            for (let item of this.codice_ateco)
                data["codice_ateco"].push(item);
        }
        data["minimum_percentage_consideration"] = this.minimum_percentage_consideration;
        data["customTotal"] = this.customTotal;
        data["total_tep_override"] = this.total_tep_override;
        return data;
    }
}

export interface IDiagnosisIncidenceEneaReadDTO {
    id: string;
    original_incidence_enea_id?: string | undefined;
    diagnosis_id?: string | undefined;
    code: string;
    unit_of_measurement?: string | undefined;
    codice_ateco?: string[];
    minimum_percentage_consideration?: number | undefined;
    customTotal?: number | undefined;
    total_tep_override?: number | undefined;
}

export class DiagnosisIndicatorConsumptionsCreateDTO implements IDiagnosisIndicatorConsumptionsCreateDTO {
    indicator_id!: string;
    consumption_id!: string;
    code?: string | undefined;

    constructor(data?: IDiagnosisIndicatorConsumptionsCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indicator_id = _data["indicator_id"];
            this.consumption_id = _data["consumption_id"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): DiagnosisIndicatorConsumptionsCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisIndicatorConsumptionsCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicator_id"] = this.indicator_id;
        data["consumption_id"] = this.consumption_id;
        data["code"] = this.code;
        return data;
    }
}

export interface IDiagnosisIndicatorConsumptionsCreateDTO {
    indicator_id: string;
    consumption_id: string;
    code?: string | undefined;
}

export class DiagnosisIndicatorConsumptionsReadDTO implements IDiagnosisIndicatorConsumptionsReadDTO {
    indicator_id!: string;
    consumption_id!: string;
    code?: string | undefined;
    id?: string;

    constructor(data?: IDiagnosisIndicatorConsumptionsReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indicator_id = _data["indicator_id"];
            this.consumption_id = _data["consumption_id"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisIndicatorConsumptionsReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisIndicatorConsumptionsReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicator_id"] = this.indicator_id;
        data["consumption_id"] = this.consumption_id;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisIndicatorConsumptionsReadDTO {
    indicator_id: string;
    consumption_id: string;
    code?: string | undefined;
    id?: string;
}

export class DiagnosisIndicatorMetersCreateDTO implements IDiagnosisIndicatorMetersCreateDTO {
    indicator_id!: string;
    meter_id!: string;
    code?: string | undefined;

    constructor(data?: IDiagnosisIndicatorMetersCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indicator_id = _data["indicator_id"];
            this.meter_id = _data["meter_id"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): DiagnosisIndicatorMetersCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisIndicatorMetersCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicator_id"] = this.indicator_id;
        data["meter_id"] = this.meter_id;
        data["code"] = this.code;
        return data;
    }
}

export interface IDiagnosisIndicatorMetersCreateDTO {
    indicator_id: string;
    meter_id: string;
    code?: string | undefined;
}

export class DiagnosisIndicatorMetersReadDTO implements IDiagnosisIndicatorMetersReadDTO {
    indicator_id!: string;
    meter_id!: string;
    code?: string | undefined;
    id?: string;

    constructor(data?: IDiagnosisIndicatorMetersReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indicator_id = _data["indicator_id"];
            this.meter_id = _data["meter_id"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisIndicatorMetersReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisIndicatorMetersReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicator_id"] = this.indicator_id;
        data["meter_id"] = this.meter_id;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisIndicatorMetersReadDTO {
    indicator_id: string;
    meter_id: string;
    code?: string | undefined;
    id?: string;
}

export class DiagnosisIndicatorRelevantVariablesCreateDTO implements IDiagnosisIndicatorRelevantVariablesCreateDTO {
    indicator_id!: string;
    relevant_variable_id!: string;
    code?: string | undefined;

    constructor(data?: IDiagnosisIndicatorRelevantVariablesCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indicator_id = _data["indicator_id"];
            this.relevant_variable_id = _data["relevant_variable_id"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): DiagnosisIndicatorRelevantVariablesCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisIndicatorRelevantVariablesCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicator_id"] = this.indicator_id;
        data["relevant_variable_id"] = this.relevant_variable_id;
        data["code"] = this.code;
        return data;
    }
}

export interface IDiagnosisIndicatorRelevantVariablesCreateDTO {
    indicator_id: string;
    relevant_variable_id: string;
    code?: string | undefined;
}

export class DiagnosisIndicatorRelevantVariablesReadDTO implements IDiagnosisIndicatorRelevantVariablesReadDTO {
    indicator_id!: string;
    relevant_variable_id!: string;
    code?: string | undefined;
    id?: string;

    constructor(data?: IDiagnosisIndicatorRelevantVariablesReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indicator_id = _data["indicator_id"];
            this.relevant_variable_id = _data["relevant_variable_id"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisIndicatorRelevantVariablesReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisIndicatorRelevantVariablesReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicator_id"] = this.indicator_id;
        data["relevant_variable_id"] = this.relevant_variable_id;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisIndicatorRelevantVariablesReadDTO {
    indicator_id: string;
    relevant_variable_id: string;
    code?: string | undefined;
    id?: string;
}

export class DiagnosisIndicatorsCreateDTO implements IDiagnosisIndicatorsCreateDTO {
    diagnosis_id?: string | undefined;
    code?: string | undefined;
    index?: number | undefined;
    formula?: string | undefined;
    udm_desiderata?: string | undefined;
    energy_use_id?: string | undefined;
    correlation_r2?: string | undefined;
    reference_ipe?: string | undefined;
    reference_ipe_unit?: string | undefined;
    min_relevant_variable_field?: number | undefined;
    max_relevant_variable_field?: number | undefined;
    reliability_level?: string | undefined;
    ipe_source?: string | undefined;
    report_table_graph?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IDiagnosisIndicatorsCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_id = _data["diagnosis_id"];
            this.code = _data["code"];
            this.index = _data["index"];
            this.formula = _data["formula"];
            this.udm_desiderata = _data["udm_desiderata"];
            this.energy_use_id = _data["energy_use_id"];
            this.correlation_r2 = _data["correlation_r2"];
            this.reference_ipe = _data["reference_ipe"];
            this.reference_ipe_unit = _data["reference_ipe_unit"];
            this.min_relevant_variable_field = _data["min_relevant_variable_field"];
            this.max_relevant_variable_field = _data["max_relevant_variable_field"];
            this.reliability_level = _data["reliability_level"];
            this.ipe_source = _data["ipe_source"];
            this.report_table_graph = _data["report_table_graph"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): DiagnosisIndicatorsCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisIndicatorsCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_id"] = this.diagnosis_id;
        data["code"] = this.code;
        data["index"] = this.index;
        data["formula"] = this.formula;
        data["udm_desiderata"] = this.udm_desiderata;
        data["energy_use_id"] = this.energy_use_id;
        data["correlation_r2"] = this.correlation_r2;
        data["reference_ipe"] = this.reference_ipe;
        data["reference_ipe_unit"] = this.reference_ipe_unit;
        data["min_relevant_variable_field"] = this.min_relevant_variable_field;
        data["max_relevant_variable_field"] = this.max_relevant_variable_field;
        data["reliability_level"] = this.reliability_level;
        data["ipe_source"] = this.ipe_source;
        data["report_table_graph"] = this.report_table_graph;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IDiagnosisIndicatorsCreateDTO {
    diagnosis_id?: string | undefined;
    code?: string | undefined;
    index?: number | undefined;
    formula?: string | undefined;
    udm_desiderata?: string | undefined;
    energy_use_id?: string | undefined;
    correlation_r2?: string | undefined;
    reference_ipe?: string | undefined;
    reference_ipe_unit?: string | undefined;
    min_relevant_variable_field?: number | undefined;
    max_relevant_variable_field?: number | undefined;
    reliability_level?: string | undefined;
    ipe_source?: string | undefined;
    report_table_graph?: string | undefined;
    notes?: string | undefined;
}

export class DiagnosisIndicatorsCreateWithRelationsDTO implements IDiagnosisIndicatorsCreateWithRelationsDTO {
    diagnosis_id!: string;
    code?: string | undefined;
    index?: number | undefined;
    formula?: string | undefined;
    udm_desiderata?: string | undefined;
    energy_use?: string | undefined;
    correlation_r2?: string | undefined;
    reference_ipe?: string | undefined;
    reference_ipe_unit?: string | undefined;
    min_relevant_variable_field?: number | undefined;
    max_relevant_variable_field?: number | undefined;
    reliability_level?: string | undefined;
    ipe_source?: string | undefined;
    report_table_graph?: string | undefined;
    notes?: string | undefined;
    meters?: MeterRelation[] | undefined;
    variables?: VariableRelation[] | undefined;
    consumptions?: ConsumptionRelation[] | undefined;

    [key: string]: any;

    constructor(data?: IDiagnosisIndicatorsCreateWithRelationsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.diagnosis_id = _data["diagnosis_id"];
            this.code = _data["code"];
            this.index = _data["index"];
            this.formula = _data["formula"];
            this.udm_desiderata = _data["udm_desiderata"];
            this.energy_use = _data["energy_use"];
            this.correlation_r2 = _data["correlation_r2"];
            this.reference_ipe = _data["reference_ipe"];
            this.reference_ipe_unit = _data["reference_ipe_unit"];
            this.min_relevant_variable_field = _data["min_relevant_variable_field"];
            this.max_relevant_variable_field = _data["max_relevant_variable_field"];
            this.reliability_level = _data["reliability_level"];
            this.ipe_source = _data["ipe_source"];
            this.report_table_graph = _data["report_table_graph"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["meters"])) {
                this.meters = [] as any;
                for (let item of _data["meters"])
                    this.meters!.push(MeterRelation.fromJS(item));
            }
            if (Array.isArray(_data["variables"])) {
                this.variables = [] as any;
                for (let item of _data["variables"])
                    this.variables!.push(VariableRelation.fromJS(item));
            }
            if (Array.isArray(_data["consumptions"])) {
                this.consumptions = [] as any;
                for (let item of _data["consumptions"])
                    this.consumptions!.push(ConsumptionRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DiagnosisIndicatorsCreateWithRelationsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisIndicatorsCreateWithRelationsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["diagnosis_id"] = this.diagnosis_id;
        data["code"] = this.code;
        data["index"] = this.index;
        data["formula"] = this.formula;
        data["udm_desiderata"] = this.udm_desiderata;
        data["energy_use"] = this.energy_use;
        data["correlation_r2"] = this.correlation_r2;
        data["reference_ipe"] = this.reference_ipe;
        data["reference_ipe_unit"] = this.reference_ipe_unit;
        data["min_relevant_variable_field"] = this.min_relevant_variable_field;
        data["max_relevant_variable_field"] = this.max_relevant_variable_field;
        data["reliability_level"] = this.reliability_level;
        data["ipe_source"] = this.ipe_source;
        data["report_table_graph"] = this.report_table_graph;
        data["notes"] = this.notes;
        if (Array.isArray(this.meters)) {
            data["meters"] = [];
            for (let item of this.meters)
                data["meters"].push(item.toJSON());
        }
        if (Array.isArray(this.variables)) {
            data["variables"] = [];
            for (let item of this.variables)
                data["variables"].push(item.toJSON());
        }
        if (Array.isArray(this.consumptions)) {
            data["consumptions"] = [];
            for (let item of this.consumptions)
                data["consumptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDiagnosisIndicatorsCreateWithRelationsDTO {
    diagnosis_id: string;
    code?: string | undefined;
    index?: number | undefined;
    formula?: string | undefined;
    udm_desiderata?: string | undefined;
    energy_use?: string | undefined;
    correlation_r2?: string | undefined;
    reference_ipe?: string | undefined;
    reference_ipe_unit?: string | undefined;
    min_relevant_variable_field?: number | undefined;
    max_relevant_variable_field?: number | undefined;
    reliability_level?: string | undefined;
    ipe_source?: string | undefined;
    report_table_graph?: string | undefined;
    notes?: string | undefined;
    meters?: MeterRelation[] | undefined;
    variables?: VariableRelation[] | undefined;
    consumptions?: ConsumptionRelation[] | undefined;

    [key: string]: any;
}

export class DiagnosisIndicatorsReadDTO implements IDiagnosisIndicatorsReadDTO {
    diagnosis_id?: string | undefined;
    code?: string | undefined;
    index?: number | undefined;
    formula?: string | undefined;
    udm_desiderata?: string | undefined;
    energy_use_id?: string | undefined;
    correlation_r2?: string | undefined;
    reference_ipe?: string | undefined;
    reference_ipe_unit?: string | undefined;
    min_relevant_variable_field?: number | undefined;
    max_relevant_variable_field?: number | undefined;
    reliability_level?: string | undefined;
    ipe_source?: string | undefined;
    report_table_graph?: string | undefined;
    notes?: string | undefined;
    id?: string;

    constructor(data?: IDiagnosisIndicatorsReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_id = _data["diagnosis_id"];
            this.code = _data["code"];
            this.index = _data["index"];
            this.formula = _data["formula"];
            this.udm_desiderata = _data["udm_desiderata"];
            this.energy_use_id = _data["energy_use_id"];
            this.correlation_r2 = _data["correlation_r2"];
            this.reference_ipe = _data["reference_ipe"];
            this.reference_ipe_unit = _data["reference_ipe_unit"];
            this.min_relevant_variable_field = _data["min_relevant_variable_field"];
            this.max_relevant_variable_field = _data["max_relevant_variable_field"];
            this.reliability_level = _data["reliability_level"];
            this.ipe_source = _data["ipe_source"];
            this.report_table_graph = _data["report_table_graph"];
            this.notes = _data["notes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisIndicatorsReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisIndicatorsReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_id"] = this.diagnosis_id;
        data["code"] = this.code;
        data["index"] = this.index;
        data["formula"] = this.formula;
        data["udm_desiderata"] = this.udm_desiderata;
        data["energy_use_id"] = this.energy_use_id;
        data["correlation_r2"] = this.correlation_r2;
        data["reference_ipe"] = this.reference_ipe;
        data["reference_ipe_unit"] = this.reference_ipe_unit;
        data["min_relevant_variable_field"] = this.min_relevant_variable_field;
        data["max_relevant_variable_field"] = this.max_relevant_variable_field;
        data["reliability_level"] = this.reliability_level;
        data["ipe_source"] = this.ipe_source;
        data["report_table_graph"] = this.report_table_graph;
        data["notes"] = this.notes;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisIndicatorsReadDTO {
    diagnosis_id?: string | undefined;
    code?: string | undefined;
    index?: number | undefined;
    formula?: string | undefined;
    udm_desiderata?: string | undefined;
    energy_use_id?: string | undefined;
    correlation_r2?: string | undefined;
    reference_ipe?: string | undefined;
    reference_ipe_unit?: string | undefined;
    min_relevant_variable_field?: number | undefined;
    max_relevant_variable_field?: number | undefined;
    reliability_level?: string | undefined;
    ipe_source?: string | undefined;
    report_table_graph?: string | undefined;
    notes?: string | undefined;
    id?: string;
}

export class DiagnosisIndicatorsUpdateWithRelationsDTO implements IDiagnosisIndicatorsUpdateWithRelationsDTO {
    diagnosis_id?: string | undefined;
    code?: string | undefined;
    index?: number | undefined;
    formula?: string | undefined;
    udm_desiderata?: string | undefined;
    energy_use?: string | undefined;
    correlation_r2?: string | undefined;
    reference_ipe?: string | undefined;
    reference_ipe_unit?: string | undefined;
    min_relevant_variable_field?: number | undefined;
    max_relevant_variable_field?: number | undefined;
    reliability_level?: string | undefined;
    ipe_source?: string | undefined;
    report_table_graph?: string | undefined;
    notes?: string | undefined;
    meters?: MeterRelation[] | undefined;
    variables?: VariableRelation[] | undefined;
    consumptions?: ConsumptionRelation[] | undefined;

    [key: string]: any;

    constructor(data?: IDiagnosisIndicatorsUpdateWithRelationsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.diagnosis_id = _data["diagnosis_id"];
            this.code = _data["code"];
            this.index = _data["index"];
            this.formula = _data["formula"];
            this.udm_desiderata = _data["udm_desiderata"];
            this.energy_use = _data["energy_use"];
            this.correlation_r2 = _data["correlation_r2"];
            this.reference_ipe = _data["reference_ipe"];
            this.reference_ipe_unit = _data["reference_ipe_unit"];
            this.min_relevant_variable_field = _data["min_relevant_variable_field"];
            this.max_relevant_variable_field = _data["max_relevant_variable_field"];
            this.reliability_level = _data["reliability_level"];
            this.ipe_source = _data["ipe_source"];
            this.report_table_graph = _data["report_table_graph"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["meters"])) {
                this.meters = [] as any;
                for (let item of _data["meters"])
                    this.meters!.push(MeterRelation.fromJS(item));
            }
            if (Array.isArray(_data["variables"])) {
                this.variables = [] as any;
                for (let item of _data["variables"])
                    this.variables!.push(VariableRelation.fromJS(item));
            }
            if (Array.isArray(_data["consumptions"])) {
                this.consumptions = [] as any;
                for (let item of _data["consumptions"])
                    this.consumptions!.push(ConsumptionRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DiagnosisIndicatorsUpdateWithRelationsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisIndicatorsUpdateWithRelationsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["diagnosis_id"] = this.diagnosis_id;
        data["code"] = this.code;
        data["index"] = this.index;
        data["formula"] = this.formula;
        data["udm_desiderata"] = this.udm_desiderata;
        data["energy_use"] = this.energy_use;
        data["correlation_r2"] = this.correlation_r2;
        data["reference_ipe"] = this.reference_ipe;
        data["reference_ipe_unit"] = this.reference_ipe_unit;
        data["min_relevant_variable_field"] = this.min_relevant_variable_field;
        data["max_relevant_variable_field"] = this.max_relevant_variable_field;
        data["reliability_level"] = this.reliability_level;
        data["ipe_source"] = this.ipe_source;
        data["report_table_graph"] = this.report_table_graph;
        data["notes"] = this.notes;
        if (Array.isArray(this.meters)) {
            data["meters"] = [];
            for (let item of this.meters)
                data["meters"].push(item.toJSON());
        }
        if (Array.isArray(this.variables)) {
            data["variables"] = [];
            for (let item of this.variables)
                data["variables"].push(item.toJSON());
        }
        if (Array.isArray(this.consumptions)) {
            data["consumptions"] = [];
            for (let item of this.consumptions)
                data["consumptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDiagnosisIndicatorsUpdateWithRelationsDTO {
    diagnosis_id?: string | undefined;
    code?: string | undefined;
    index?: number | undefined;
    formula?: string | undefined;
    udm_desiderata?: string | undefined;
    energy_use?: string | undefined;
    correlation_r2?: string | undefined;
    reference_ipe?: string | undefined;
    reference_ipe_unit?: string | undefined;
    min_relevant_variable_field?: number | undefined;
    max_relevant_variable_field?: number | undefined;
    reliability_level?: string | undefined;
    ipe_source?: string | undefined;
    report_table_graph?: string | undefined;
    notes?: string | undefined;
    meters?: MeterRelation[] | undefined;
    variables?: VariableRelation[] | undefined;
    consumptions?: ConsumptionRelation[] | undefined;

    [key: string]: any;
}

/** Create DTO with energy_vectors and energy_uses as lists, all_energy_use flag. */
export class DiagnosisInterventionsCreateDTO implements IDiagnosisInterventionsCreateDTO {
    diagnosis_id?: string | undefined;
    order?: number | undefined;
    code?: string | undefined;
    title?: string | undefined;
    consumption_before?: number | undefined;
    cost_before_ea?: number | undefined;
    energy_uses?: string[];
    all_energy_use?: boolean;
    description?: string | undefined;
    type?: string | undefined;
    incentives?: string | undefined;
    priority?: string | undefined;
    comments?: string | undefined;
    investment?: number | undefined;
    investment_to_evaluated?: boolean;
    unit_of_measurement?: string | undefined;
    annual_co2_saving?: number | undefined;
    expected_economic_saving?: number | undefined;
    expected_economic_saving_manual?: boolean | undefined;
    useful_life?: number | undefined;
    payback_time?: number | undefined;
    payback_time_manual?: boolean | undefined;
    van_5_10_years?: number | undefined;
    van_5_10_years_manual?: boolean | undefined;
    tir_10_years?: number | undefined;
    tir_10_years_manual?: boolean | undefined;
    energy_vectors?: string[];
    annual_energy_saving_by_vector?: { [key: string]: number; };
    to_evaluated_by_vector?: { [key: string]: boolean; };
    is_to_export?: boolean;

    constructor(data?: IDiagnosisInterventionsCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.all_energy_use = false;
            this.investment_to_evaluated = false;
            this.is_to_export = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_id = _data["diagnosis_id"];
            this.order = _data["order"];
            this.code = _data["code"];
            this.title = _data["title"];
            this.consumption_before = _data["consumption_before"];
            this.cost_before_ea = _data["cost_before_ea"];
            if (Array.isArray(_data["energy_uses"])) {
                this.energy_uses = [] as any;
                for (let item of _data["energy_uses"])
                    this.energy_uses!.push(item);
            }
            this.all_energy_use = _data["all_energy_use"] !== undefined ? _data["all_energy_use"] : false;
            this.description = _data["description"];
            this.type = _data["type"];
            this.incentives = _data["incentives"];
            this.priority = _data["priority"];
            this.comments = _data["comments"];
            this.investment = _data["investment"];
            this.investment_to_evaluated = _data["investment_to_evaluated"] !== undefined ? _data["investment_to_evaluated"] : false;
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.annual_co2_saving = _data["annual_co2_saving"];
            this.expected_economic_saving = _data["expected_economic_saving"];
            this.expected_economic_saving_manual = _data["expected_economic_saving_manual"];
            this.useful_life = _data["useful_life"];
            this.payback_time = _data["payback_time"];
            this.payback_time_manual = _data["payback_time_manual"];
            this.van_5_10_years = _data["van_5_10_years"];
            this.van_5_10_years_manual = _data["van_5_10_years_manual"];
            this.tir_10_years = _data["tir_10_years"];
            this.tir_10_years_manual = _data["tir_10_years_manual"];
            if (Array.isArray(_data["energy_vectors"])) {
                this.energy_vectors = [] as any;
                for (let item of _data["energy_vectors"])
                    this.energy_vectors!.push(item);
            }
            if (_data["annual_energy_saving_by_vector"]) {
                this.annual_energy_saving_by_vector = {} as any;
                for (let key in _data["annual_energy_saving_by_vector"]) {
                    if (_data["annual_energy_saving_by_vector"].hasOwnProperty(key))
                        (<any>this.annual_energy_saving_by_vector)![key] = _data["annual_energy_saving_by_vector"][key];
                }
            }
            if (_data["to_evaluated_by_vector"]) {
                this.to_evaluated_by_vector = {} as any;
                for (let key in _data["to_evaluated_by_vector"]) {
                    if (_data["to_evaluated_by_vector"].hasOwnProperty(key))
                        (<any>this.to_evaluated_by_vector)![key] = _data["to_evaluated_by_vector"][key];
                }
            }
            this.is_to_export = _data["is_to_export"] !== undefined ? _data["is_to_export"] : false;
        }
    }

    static fromJS(data: any): DiagnosisInterventionsCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisInterventionsCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_id"] = this.diagnosis_id;
        data["order"] = this.order;
        data["code"] = this.code;
        data["title"] = this.title;
        data["consumption_before"] = this.consumption_before;
        data["cost_before_ea"] = this.cost_before_ea;
        if (Array.isArray(this.energy_uses)) {
            data["energy_uses"] = [];
            for (let item of this.energy_uses)
                data["energy_uses"].push(item);
        }
        data["all_energy_use"] = this.all_energy_use;
        data["description"] = this.description;
        data["type"] = this.type;
        data["incentives"] = this.incentives;
        data["priority"] = this.priority;
        data["comments"] = this.comments;
        data["investment"] = this.investment;
        data["investment_to_evaluated"] = this.investment_to_evaluated;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["annual_co2_saving"] = this.annual_co2_saving;
        data["expected_economic_saving"] = this.expected_economic_saving;
        data["expected_economic_saving_manual"] = this.expected_economic_saving_manual;
        data["useful_life"] = this.useful_life;
        data["payback_time"] = this.payback_time;
        data["payback_time_manual"] = this.payback_time_manual;
        data["van_5_10_years"] = this.van_5_10_years;
        data["van_5_10_years_manual"] = this.van_5_10_years_manual;
        data["tir_10_years"] = this.tir_10_years;
        data["tir_10_years_manual"] = this.tir_10_years_manual;
        if (Array.isArray(this.energy_vectors)) {
            data["energy_vectors"] = [];
            for (let item of this.energy_vectors)
                data["energy_vectors"].push(item);
        }
        if (this.annual_energy_saving_by_vector) {
            data["annual_energy_saving_by_vector"] = {};
            for (let key in this.annual_energy_saving_by_vector) {
                if (this.annual_energy_saving_by_vector.hasOwnProperty(key))
                    (<any>data["annual_energy_saving_by_vector"])[key] = (<any>this.annual_energy_saving_by_vector)[key];
            }
        }
        if (this.to_evaluated_by_vector) {
            data["to_evaluated_by_vector"] = {};
            for (let key in this.to_evaluated_by_vector) {
                if (this.to_evaluated_by_vector.hasOwnProperty(key))
                    (<any>data["to_evaluated_by_vector"])[key] = (<any>this.to_evaluated_by_vector)[key];
            }
        }
        data["is_to_export"] = this.is_to_export;
        return data;
    }
}

/** Create DTO with energy_vectors and energy_uses as lists, all_energy_use flag. */
export interface IDiagnosisInterventionsCreateDTO {
    diagnosis_id?: string | undefined;
    order?: number | undefined;
    code?: string | undefined;
    title?: string | undefined;
    consumption_before?: number | undefined;
    cost_before_ea?: number | undefined;
    energy_uses?: string[];
    all_energy_use?: boolean;
    description?: string | undefined;
    type?: string | undefined;
    incentives?: string | undefined;
    priority?: string | undefined;
    comments?: string | undefined;
    investment?: number | undefined;
    investment_to_evaluated?: boolean;
    unit_of_measurement?: string | undefined;
    annual_co2_saving?: number | undefined;
    expected_economic_saving?: number | undefined;
    expected_economic_saving_manual?: boolean | undefined;
    useful_life?: number | undefined;
    payback_time?: number | undefined;
    payback_time_manual?: boolean | undefined;
    van_5_10_years?: number | undefined;
    van_5_10_years_manual?: boolean | undefined;
    tir_10_years?: number | undefined;
    tir_10_years_manual?: boolean | undefined;
    energy_vectors?: string[];
    annual_energy_saving_by_vector?: { [key: string]: number; };
    to_evaluated_by_vector?: { [key: string]: boolean; };
    is_to_export?: boolean;
}

/** Read DTO with energy_vectors and energy_uses as lists, all_energy_use flag. */
export class DiagnosisInterventionsReadDTO implements IDiagnosisInterventionsReadDTO {
    id?: string | undefined;
    diagnosis_id?: string | undefined;
    order?: number | undefined;
    code?: string | undefined;
    title?: string | undefined;
    consumption_before?: number | undefined;
    cost_before_ea?: number | undefined;
    energy_uses?: string[];
    all_energy_use?: boolean;
    description?: string | undefined;
    type?: string | undefined;
    incentives?: string | undefined;
    priority?: string | undefined;
    comments?: string | undefined;
    investment?: number | undefined;
    investment_to_evaluated?: boolean;
    unit_of_measurement?: string | undefined;
    annual_co2_saving?: number | undefined;
    expected_economic_saving?: number | undefined;
    expected_economic_saving_manual?: boolean | undefined;
    useful_life?: number | undefined;
    payback_time?: number | undefined;
    payback_time_manual?: boolean | undefined;
    van_5_10_years?: number | undefined;
    van_5_10_years_manual?: boolean | undefined;
    tir_10_years?: number | undefined;
    tir_10_years_manual?: boolean | undefined;
    energy_vectors?: string[];
    consumption_before_by_vector?: { [key: string]: number; };
    cost_before?: number | undefined;
    annual_energy_saving_by_vector?: { [key: string]: number; };
    to_evaluated_by_vector?: { [key: string]: boolean; };
    is_to_export?: boolean;

    constructor(data?: IDiagnosisInterventionsReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.all_energy_use = false;
            this.investment_to_evaluated = false;
            this.is_to_export = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.diagnosis_id = _data["diagnosis_id"];
            this.order = _data["order"];
            this.code = _data["code"];
            this.title = _data["title"];
            this.consumption_before = _data["consumption_before"];
            this.cost_before_ea = _data["cost_before_ea"];
            if (Array.isArray(_data["energy_uses"])) {
                this.energy_uses = [] as any;
                for (let item of _data["energy_uses"])
                    this.energy_uses!.push(item);
            }
            this.all_energy_use = _data["all_energy_use"] !== undefined ? _data["all_energy_use"] : false;
            this.description = _data["description"];
            this.type = _data["type"];
            this.incentives = _data["incentives"];
            this.priority = _data["priority"];
            this.comments = _data["comments"];
            this.investment = _data["investment"];
            this.investment_to_evaluated = _data["investment_to_evaluated"] !== undefined ? _data["investment_to_evaluated"] : false;
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.annual_co2_saving = _data["annual_co2_saving"];
            this.expected_economic_saving = _data["expected_economic_saving"];
            this.expected_economic_saving_manual = _data["expected_economic_saving_manual"];
            this.useful_life = _data["useful_life"];
            this.payback_time = _data["payback_time"];
            this.payback_time_manual = _data["payback_time_manual"];
            this.van_5_10_years = _data["van_5_10_years"];
            this.van_5_10_years_manual = _data["van_5_10_years_manual"];
            this.tir_10_years = _data["tir_10_years"];
            this.tir_10_years_manual = _data["tir_10_years_manual"];
            if (Array.isArray(_data["energy_vectors"])) {
                this.energy_vectors = [] as any;
                for (let item of _data["energy_vectors"])
                    this.energy_vectors!.push(item);
            }
            if (_data["consumption_before_by_vector"]) {
                this.consumption_before_by_vector = {} as any;
                for (let key in _data["consumption_before_by_vector"]) {
                    if (_data["consumption_before_by_vector"].hasOwnProperty(key))
                        (<any>this.consumption_before_by_vector)![key] = _data["consumption_before_by_vector"][key];
                }
            }
            this.cost_before = _data["cost_before"];
            if (_data["annual_energy_saving_by_vector"]) {
                this.annual_energy_saving_by_vector = {} as any;
                for (let key in _data["annual_energy_saving_by_vector"]) {
                    if (_data["annual_energy_saving_by_vector"].hasOwnProperty(key))
                        (<any>this.annual_energy_saving_by_vector)![key] = _data["annual_energy_saving_by_vector"][key];
                }
            }
            if (_data["to_evaluated_by_vector"]) {
                this.to_evaluated_by_vector = {} as any;
                for (let key in _data["to_evaluated_by_vector"]) {
                    if (_data["to_evaluated_by_vector"].hasOwnProperty(key))
                        (<any>this.to_evaluated_by_vector)![key] = _data["to_evaluated_by_vector"][key];
                }
            }
            this.is_to_export = _data["is_to_export"] !== undefined ? _data["is_to_export"] : false;
        }
    }

    static fromJS(data: any): DiagnosisInterventionsReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisInterventionsReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["diagnosis_id"] = this.diagnosis_id;
        data["order"] = this.order;
        data["code"] = this.code;
        data["title"] = this.title;
        data["consumption_before"] = this.consumption_before;
        data["cost_before_ea"] = this.cost_before_ea;
        if (Array.isArray(this.energy_uses)) {
            data["energy_uses"] = [];
            for (let item of this.energy_uses)
                data["energy_uses"].push(item);
        }
        data["all_energy_use"] = this.all_energy_use;
        data["description"] = this.description;
        data["type"] = this.type;
        data["incentives"] = this.incentives;
        data["priority"] = this.priority;
        data["comments"] = this.comments;
        data["investment"] = this.investment;
        data["investment_to_evaluated"] = this.investment_to_evaluated;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["annual_co2_saving"] = this.annual_co2_saving;
        data["expected_economic_saving"] = this.expected_economic_saving;
        data["expected_economic_saving_manual"] = this.expected_economic_saving_manual;
        data["useful_life"] = this.useful_life;
        data["payback_time"] = this.payback_time;
        data["payback_time_manual"] = this.payback_time_manual;
        data["van_5_10_years"] = this.van_5_10_years;
        data["van_5_10_years_manual"] = this.van_5_10_years_manual;
        data["tir_10_years"] = this.tir_10_years;
        data["tir_10_years_manual"] = this.tir_10_years_manual;
        if (Array.isArray(this.energy_vectors)) {
            data["energy_vectors"] = [];
            for (let item of this.energy_vectors)
                data["energy_vectors"].push(item);
        }
        if (this.consumption_before_by_vector) {
            data["consumption_before_by_vector"] = {};
            for (let key in this.consumption_before_by_vector) {
                if (this.consumption_before_by_vector.hasOwnProperty(key))
                    (<any>data["consumption_before_by_vector"])[key] = (<any>this.consumption_before_by_vector)[key];
            }
        }
        data["cost_before"] = this.cost_before;
        if (this.annual_energy_saving_by_vector) {
            data["annual_energy_saving_by_vector"] = {};
            for (let key in this.annual_energy_saving_by_vector) {
                if (this.annual_energy_saving_by_vector.hasOwnProperty(key))
                    (<any>data["annual_energy_saving_by_vector"])[key] = (<any>this.annual_energy_saving_by_vector)[key];
            }
        }
        if (this.to_evaluated_by_vector) {
            data["to_evaluated_by_vector"] = {};
            for (let key in this.to_evaluated_by_vector) {
                if (this.to_evaluated_by_vector.hasOwnProperty(key))
                    (<any>data["to_evaluated_by_vector"])[key] = (<any>this.to_evaluated_by_vector)[key];
            }
        }
        data["is_to_export"] = this.is_to_export;
        return data;
    }
}

/** Read DTO with energy_vectors and energy_uses as lists, all_energy_use flag. */
export interface IDiagnosisInterventionsReadDTO {
    id?: string | undefined;
    diagnosis_id?: string | undefined;
    order?: number | undefined;
    code?: string | undefined;
    title?: string | undefined;
    consumption_before?: number | undefined;
    cost_before_ea?: number | undefined;
    energy_uses?: string[];
    all_energy_use?: boolean;
    description?: string | undefined;
    type?: string | undefined;
    incentives?: string | undefined;
    priority?: string | undefined;
    comments?: string | undefined;
    investment?: number | undefined;
    investment_to_evaluated?: boolean;
    unit_of_measurement?: string | undefined;
    annual_co2_saving?: number | undefined;
    expected_economic_saving?: number | undefined;
    expected_economic_saving_manual?: boolean | undefined;
    useful_life?: number | undefined;
    payback_time?: number | undefined;
    payback_time_manual?: boolean | undefined;
    van_5_10_years?: number | undefined;
    van_5_10_years_manual?: boolean | undefined;
    tir_10_years?: number | undefined;
    tir_10_years_manual?: boolean | undefined;
    energy_vectors?: string[];
    consumption_before_by_vector?: { [key: string]: number; };
    cost_before?: number | undefined;
    annual_energy_saving_by_vector?: { [key: string]: number; };
    to_evaluated_by_vector?: { [key: string]: boolean; };
    is_to_export?: boolean;
}

export class DiagnosisMetersCreateDTO implements IDiagnosisMetersCreateDTO {
    meter_code?: string | undefined;
    meter_customer_code?: string | undefined;
    diagnosis_id?: string | undefined;
    energy_vector_id?: string | undefined;
    unit_of_measurement?: string | undefined;
    table_code_index!: string;
    index?: number | undefined;
    type?: string | undefined;
    meter_type?: MeterType | undefined;
    id_autoproduzione?: string | undefined;
    hierarchy?: string | undefined;
    functional_area?: FunctionalArea | undefined;
    energy_use_id?: string | undefined;
    grouping?: string | undefined;
    is_fake?: boolean | undefined;
    notes?: string | undefined;

    constructor(data?: IDiagnosisMetersCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meter_code = _data["meter_code"];
            this.meter_customer_code = _data["meter_customer_code"];
            this.diagnosis_id = _data["diagnosis_id"];
            this.energy_vector_id = _data["energy_vector_id"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.table_code_index = _data["table_code_index"];
            this.index = _data["index"];
            this.type = _data["type"];
            this.meter_type = _data["meter_type"];
            this.id_autoproduzione = _data["id_autoproduzione"];
            this.hierarchy = _data["hierarchy"];
            this.functional_area = _data["functional_area"];
            this.energy_use_id = _data["energy_use_id"];
            this.grouping = _data["grouping"];
            this.is_fake = _data["is_fake"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): DiagnosisMetersCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisMetersCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meter_code"] = this.meter_code;
        data["meter_customer_code"] = this.meter_customer_code;
        data["diagnosis_id"] = this.diagnosis_id;
        data["energy_vector_id"] = this.energy_vector_id;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["table_code_index"] = this.table_code_index;
        data["index"] = this.index;
        data["type"] = this.type;
        data["meter_type"] = this.meter_type;
        data["id_autoproduzione"] = this.id_autoproduzione;
        data["hierarchy"] = this.hierarchy;
        data["functional_area"] = this.functional_area;
        data["energy_use_id"] = this.energy_use_id;
        data["grouping"] = this.grouping;
        data["is_fake"] = this.is_fake;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IDiagnosisMetersCreateDTO {
    meter_code?: string | undefined;
    meter_customer_code?: string | undefined;
    diagnosis_id?: string | undefined;
    energy_vector_id?: string | undefined;
    unit_of_measurement?: string | undefined;
    table_code_index: string;
    index?: number | undefined;
    type?: string | undefined;
    meter_type?: MeterType | undefined;
    id_autoproduzione?: string | undefined;
    hierarchy?: string | undefined;
    functional_area?: FunctionalArea | undefined;
    energy_use_id?: string | undefined;
    grouping?: string | undefined;
    is_fake?: boolean | undefined;
    notes?: string | undefined;
}

export class DiagnosisMetersReadDTO implements IDiagnosisMetersReadDTO {
    meter_code?: string | undefined;
    meter_customer_code?: string | undefined;
    diagnosis_id?: string | undefined;
    energy_vector_id?: string | undefined;
    unit_of_measurement?: string | undefined;
    table_code_index!: string;
    index?: number | undefined;
    type?: string | undefined;
    meter_type?: MeterType | undefined;
    id_autoproduzione?: string | undefined;
    hierarchy?: string | undefined;
    functional_area?: FunctionalArea | undefined;
    energy_use_id?: string | undefined;
    grouping?: string | undefined;
    is_fake?: boolean | undefined;
    notes?: string | undefined;
    id?: string;

    constructor(data?: IDiagnosisMetersReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meter_code = _data["meter_code"];
            this.meter_customer_code = _data["meter_customer_code"];
            this.diagnosis_id = _data["diagnosis_id"];
            this.energy_vector_id = _data["energy_vector_id"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.table_code_index = _data["table_code_index"];
            this.index = _data["index"];
            this.type = _data["type"];
            this.meter_type = _data["meter_type"];
            this.id_autoproduzione = _data["id_autoproduzione"];
            this.hierarchy = _data["hierarchy"];
            this.functional_area = _data["functional_area"];
            this.energy_use_id = _data["energy_use_id"];
            this.grouping = _data["grouping"];
            this.is_fake = _data["is_fake"];
            this.notes = _data["notes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisMetersReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisMetersReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meter_code"] = this.meter_code;
        data["meter_customer_code"] = this.meter_customer_code;
        data["diagnosis_id"] = this.diagnosis_id;
        data["energy_vector_id"] = this.energy_vector_id;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["table_code_index"] = this.table_code_index;
        data["index"] = this.index;
        data["type"] = this.type;
        data["meter_type"] = this.meter_type;
        data["id_autoproduzione"] = this.id_autoproduzione;
        data["hierarchy"] = this.hierarchy;
        data["functional_area"] = this.functional_area;
        data["energy_use_id"] = this.energy_use_id;
        data["grouping"] = this.grouping;
        data["is_fake"] = this.is_fake;
        data["notes"] = this.notes;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisMetersReadDTO {
    meter_code?: string | undefined;
    meter_customer_code?: string | undefined;
    diagnosis_id?: string | undefined;
    energy_vector_id?: string | undefined;
    unit_of_measurement?: string | undefined;
    table_code_index: string;
    index?: number | undefined;
    type?: string | undefined;
    meter_type?: MeterType | undefined;
    id_autoproduzione?: string | undefined;
    hierarchy?: string | undefined;
    functional_area?: FunctionalArea | undefined;
    energy_use_id?: string | undefined;
    grouping?: string | undefined;
    is_fake?: boolean | undefined;
    notes?: string | undefined;
    id?: string;
}

/** Read diagnosi con avanzamento checklist pre-calcolato (liste e GET singolo). */
export class DiagnosisReadDTO implements IDiagnosisReadDTO {
    table_code_index!: string;
    site_id?: string | undefined;
    last_update?: string | undefined;
    data_generated_from?: string | undefined;
    data_generated_to?: string | undefined;
    reference_period_from?: string | undefined;
    reference_period_to?: string | undefined;
    responsible_01!: string;
    responsible_02?: string | undefined;
    responsible_03?: string | undefined;
    status?: DiagnosisStatus;
    diagnosis_date?: string | undefined;
    id?: string;
    /** 0–100 checklist; 101 se diagnosi chiusa (convenzione UI come la griglia). */
    checklist_progress_percent?: number;

    constructor(data?: IDiagnosisReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.status = DiagnosisStatus.Open;
            this.checklist_progress_percent = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.table_code_index = _data["table_code_index"];
            this.site_id = _data["site_id"];
            this.last_update = _data["last_update"];
            this.data_generated_from = _data["data_generated_from"];
            this.data_generated_to = _data["data_generated_to"];
            this.reference_period_from = _data["reference_period_from"];
            this.reference_period_to = _data["reference_period_to"];
            this.responsible_01 = _data["responsible_01"];
            this.responsible_02 = _data["responsible_02"];
            this.responsible_03 = _data["responsible_03"];
            this.status = _data["status"] !== undefined ? _data["status"] : DiagnosisStatus.Open;
            this.diagnosis_date = _data["diagnosis_date"];
            this.id = _data["id"];
            this.checklist_progress_percent = _data["checklist_progress_percent"] !== undefined ? _data["checklist_progress_percent"] : 0;
        }
    }

    static fromJS(data: any): DiagnosisReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table_code_index"] = this.table_code_index;
        data["site_id"] = this.site_id;
        data["last_update"] = this.last_update;
        data["data_generated_from"] = this.data_generated_from;
        data["data_generated_to"] = this.data_generated_to;
        data["reference_period_from"] = this.reference_period_from;
        data["reference_period_to"] = this.reference_period_to;
        data["responsible_01"] = this.responsible_01;
        data["responsible_02"] = this.responsible_02;
        data["responsible_03"] = this.responsible_03;
        data["status"] = this.status;
        data["diagnosis_date"] = this.diagnosis_date;
        data["id"] = this.id;
        data["checklist_progress_percent"] = this.checklist_progress_percent;
        return data;
    }
}

/** Read diagnosi con avanzamento checklist pre-calcolato (liste e GET singolo). */
export interface IDiagnosisReadDTO {
    table_code_index: string;
    site_id?: string | undefined;
    last_update?: string | undefined;
    data_generated_from?: string | undefined;
    data_generated_to?: string | undefined;
    reference_period_from?: string | undefined;
    reference_period_to?: string | undefined;
    responsible_01: string;
    responsible_02?: string | undefined;
    responsible_03?: string | undefined;
    status?: DiagnosisStatus;
    diagnosis_date?: string | undefined;
    id?: string;
    /** 0–100 checklist; 101 se diagnosi chiusa (convenzione UI come la griglia). */
    checklist_progress_percent?: number;
}

export class DiagnosisRelevantVariablesCreateDTO implements IDiagnosisRelevantVariablesCreateDTO {
    diagnosis_id?: string | undefined;
    table_code_index!: string;
    index?: number | undefined;
    variable?: string | undefined;
    unit_of_measurement?: string | undefined;
    type?: string | undefined;
    hierarchy?: number | undefined;
    notes?: string | undefined;

    constructor(data?: IDiagnosisRelevantVariablesCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_id = _data["diagnosis_id"];
            this.table_code_index = _data["table_code_index"];
            this.index = _data["index"];
            this.variable = _data["variable"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.type = _data["type"];
            this.hierarchy = _data["hierarchy"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): DiagnosisRelevantVariablesCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisRelevantVariablesCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_id"] = this.diagnosis_id;
        data["table_code_index"] = this.table_code_index;
        data["index"] = this.index;
        data["variable"] = this.variable;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["type"] = this.type;
        data["hierarchy"] = this.hierarchy;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IDiagnosisRelevantVariablesCreateDTO {
    diagnosis_id?: string | undefined;
    table_code_index: string;
    index?: number | undefined;
    variable?: string | undefined;
    unit_of_measurement?: string | undefined;
    type?: string | undefined;
    hierarchy?: number | undefined;
    notes?: string | undefined;
}

export class DiagnosisRelevantVariablesReadDTO implements IDiagnosisRelevantVariablesReadDTO {
    diagnosis_id?: string | undefined;
    table_code_index!: string;
    index?: number | undefined;
    variable?: string | undefined;
    unit_of_measurement?: string | undefined;
    type?: string | undefined;
    hierarchy?: number | undefined;
    notes?: string | undefined;
    id?: string;

    constructor(data?: IDiagnosisRelevantVariablesReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_id = _data["diagnosis_id"];
            this.table_code_index = _data["table_code_index"];
            this.index = _data["index"];
            this.variable = _data["variable"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.type = _data["type"];
            this.hierarchy = _data["hierarchy"];
            this.notes = _data["notes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisRelevantVariablesReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisRelevantVariablesReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_id"] = this.diagnosis_id;
        data["table_code_index"] = this.table_code_index;
        data["index"] = this.index;
        data["variable"] = this.variable;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["type"] = this.type;
        data["hierarchy"] = this.hierarchy;
        data["notes"] = this.notes;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisRelevantVariablesReadDTO {
    diagnosis_id?: string | undefined;
    table_code_index: string;
    index?: number | undefined;
    variable?: string | undefined;
    unit_of_measurement?: string | undefined;
    type?: string | undefined;
    hierarchy?: number | undefined;
    notes?: string | undefined;
    id?: string;
}

export class DiagnosisSelfProductionPlantsCreateDTO implements IDiagnosisSelfProductionPlantsCreateDTO {
    original_self_production_plant_id?: string | undefined;
    diagnosis_id?: string | undefined;
    type?: string | undefined;
    power_source?: string | undefined;
    in_service_year?: string | undefined;
    electrical_power_kw?: number | undefined;
    thermal_power_kw?: number | undefined;
    cooling_power_kw?: number | undefined;

    constructor(data?: IDiagnosisSelfProductionPlantsCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.original_self_production_plant_id = _data["original_self_production_plant_id"];
            this.diagnosis_id = _data["diagnosis_id"];
            this.type = _data["type"];
            this.power_source = _data["power_source"];
            this.in_service_year = _data["in_service_year"];
            this.electrical_power_kw = _data["electrical_power_kw"];
            this.thermal_power_kw = _data["thermal_power_kw"];
            this.cooling_power_kw = _data["cooling_power_kw"];
        }
    }

    static fromJS(data: any): DiagnosisSelfProductionPlantsCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisSelfProductionPlantsCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["original_self_production_plant_id"] = this.original_self_production_plant_id;
        data["diagnosis_id"] = this.diagnosis_id;
        data["type"] = this.type;
        data["power_source"] = this.power_source;
        data["in_service_year"] = this.in_service_year;
        data["electrical_power_kw"] = this.electrical_power_kw;
        data["thermal_power_kw"] = this.thermal_power_kw;
        data["cooling_power_kw"] = this.cooling_power_kw;
        return data;
    }
}

export interface IDiagnosisSelfProductionPlantsCreateDTO {
    original_self_production_plant_id?: string | undefined;
    diagnosis_id?: string | undefined;
    type?: string | undefined;
    power_source?: string | undefined;
    in_service_year?: string | undefined;
    electrical_power_kw?: number | undefined;
    thermal_power_kw?: number | undefined;
    cooling_power_kw?: number | undefined;
}

export class DiagnosisSelfProductionPlantsReadDTO implements IDiagnosisSelfProductionPlantsReadDTO {
    original_self_production_plant_id?: string | undefined;
    diagnosis_id?: string | undefined;
    type?: string | undefined;
    power_source?: string | undefined;
    in_service_year?: string | undefined;
    electrical_power_kw?: number | undefined;
    thermal_power_kw?: number | undefined;
    cooling_power_kw?: number | undefined;
    id?: string;

    constructor(data?: IDiagnosisSelfProductionPlantsReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.original_self_production_plant_id = _data["original_self_production_plant_id"];
            this.diagnosis_id = _data["diagnosis_id"];
            this.type = _data["type"];
            this.power_source = _data["power_source"];
            this.in_service_year = _data["in_service_year"];
            this.electrical_power_kw = _data["electrical_power_kw"];
            this.thermal_power_kw = _data["thermal_power_kw"];
            this.cooling_power_kw = _data["cooling_power_kw"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiagnosisSelfProductionPlantsReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosisSelfProductionPlantsReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["original_self_production_plant_id"] = this.original_self_production_plant_id;
        data["diagnosis_id"] = this.diagnosis_id;
        data["type"] = this.type;
        data["power_source"] = this.power_source;
        data["in_service_year"] = this.in_service_year;
        data["electrical_power_kw"] = this.electrical_power_kw;
        data["thermal_power_kw"] = this.thermal_power_kw;
        data["cooling_power_kw"] = this.cooling_power_kw;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiagnosisSelfProductionPlantsReadDTO {
    original_self_production_plant_id?: string | undefined;
    diagnosis_id?: string | undefined;
    type?: string | undefined;
    power_source?: string | undefined;
    in_service_year?: string | undefined;
    electrical_power_kw?: number | undefined;
    thermal_power_kw?: number | undefined;
    cooling_power_kw?: number | undefined;
    id?: string;
}

export enum DiagnosisStatus {
    Open = "open",
    Closed = "closed",
}

export class EnergyUseCreateDTO implements IEnergyUseCreateDTO {
    code!: string;
    description?: string | undefined;
    is_default?: boolean | undefined;

    constructor(data?: IEnergyUseCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            this.is_default = _data["is_default"];
        }
    }

    static fromJS(data: any): EnergyUseCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EnergyUseCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["is_default"] = this.is_default;
        return data;
    }
}

export interface IEnergyUseCreateDTO {
    code: string;
    description?: string | undefined;
    is_default?: boolean | undefined;
}

export class EnergyUseReadDTO implements IEnergyUseReadDTO {
    code!: string;
    description?: string | undefined;
    is_default?: boolean | undefined;
    id?: string;

    constructor(data?: IEnergyUseReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            this.is_default = _data["is_default"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EnergyUseReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EnergyUseReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["is_default"] = this.is_default;
        data["id"] = this.id;
        return data;
    }
}

export interface IEnergyUseReadDTO {
    code: string;
    description?: string | undefined;
    is_default?: boolean | undefined;
    id?: string;
}

export class EnergyUseSettingsCreateDTO implements IEnergyUseSettingsCreateDTO {
    default_energy_relevance_lower_limit!: number;
    default_energy_relevance_upper_limit!: number;
    weight_energy_relevance!: number;
    weight_technological_gap_vs_bats!: number;
    weight_plant_management!: number;
    knowledge_measurement!: number;
    minimum_threshold!: number;

    constructor(data?: IEnergyUseSettingsCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.default_energy_relevance_lower_limit = _data["default_energy_relevance_lower_limit"];
            this.default_energy_relevance_upper_limit = _data["default_energy_relevance_upper_limit"];
            this.weight_energy_relevance = _data["weight_energy_relevance"];
            this.weight_technological_gap_vs_bats = _data["weight_technological_gap_vs_bats"];
            this.weight_plant_management = _data["weight_plant_management"];
            this.knowledge_measurement = _data["knowledge_measurement"];
            this.minimum_threshold = _data["minimum_threshold"];
        }
    }

    static fromJS(data: any): EnergyUseSettingsCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EnergyUseSettingsCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["default_energy_relevance_lower_limit"] = this.default_energy_relevance_lower_limit;
        data["default_energy_relevance_upper_limit"] = this.default_energy_relevance_upper_limit;
        data["weight_energy_relevance"] = this.weight_energy_relevance;
        data["weight_technological_gap_vs_bats"] = this.weight_technological_gap_vs_bats;
        data["weight_plant_management"] = this.weight_plant_management;
        data["knowledge_measurement"] = this.knowledge_measurement;
        data["minimum_threshold"] = this.minimum_threshold;
        return data;
    }
}

export interface IEnergyUseSettingsCreateDTO {
    default_energy_relevance_lower_limit: number;
    default_energy_relevance_upper_limit: number;
    weight_energy_relevance: number;
    weight_technological_gap_vs_bats: number;
    weight_plant_management: number;
    knowledge_measurement: number;
    minimum_threshold: number;
}

export class EnergyUseSettingsReadDTO implements IEnergyUseSettingsReadDTO {
    default_energy_relevance_lower_limit!: number;
    default_energy_relevance_upper_limit!: number;
    weight_energy_relevance!: number;
    weight_technological_gap_vs_bats!: number;
    weight_plant_management!: number;
    knowledge_measurement!: number;
    minimum_threshold!: number;
    id?: string;

    constructor(data?: IEnergyUseSettingsReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.default_energy_relevance_lower_limit = _data["default_energy_relevance_lower_limit"];
            this.default_energy_relevance_upper_limit = _data["default_energy_relevance_upper_limit"];
            this.weight_energy_relevance = _data["weight_energy_relevance"];
            this.weight_technological_gap_vs_bats = _data["weight_technological_gap_vs_bats"];
            this.weight_plant_management = _data["weight_plant_management"];
            this.knowledge_measurement = _data["knowledge_measurement"];
            this.minimum_threshold = _data["minimum_threshold"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EnergyUseSettingsReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EnergyUseSettingsReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["default_energy_relevance_lower_limit"] = this.default_energy_relevance_lower_limit;
        data["default_energy_relevance_upper_limit"] = this.default_energy_relevance_upper_limit;
        data["weight_energy_relevance"] = this.weight_energy_relevance;
        data["weight_technological_gap_vs_bats"] = this.weight_technological_gap_vs_bats;
        data["weight_plant_management"] = this.weight_plant_management;
        data["knowledge_measurement"] = this.knowledge_measurement;
        data["minimum_threshold"] = this.minimum_threshold;
        data["id"] = this.id;
        return data;
    }
}

export interface IEnergyUseSettingsReadDTO {
    default_energy_relevance_lower_limit: number;
    default_energy_relevance_upper_limit: number;
    weight_energy_relevance: number;
    weight_technological_gap_vs_bats: number;
    weight_plant_management: number;
    knowledge_measurement: number;
    minimum_threshold: number;
    id?: string;
}

export class EnergyVectorsCreateDTO implements IEnergyVectorsCreateDTO {
    table_code_index!: string;
    unit_of_measurement?: string | undefined;
    vector_type!: string;
    co2_factor?: number | undefined;
    tep_factor?: number | undefined;
    tj_factor?: number | undefined;
    kwh_factor?: number | undefined;
    density?: number | undefined;
    code?: string | undefined;
    is_default?: boolean | undefined;
    diagnosis_field_option_option_id!: number;

    constructor(data?: IEnergyVectorsCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.table_code_index = _data["table_code_index"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.vector_type = _data["vector_type"];
            this.co2_factor = _data["co2_factor"];
            this.tep_factor = _data["tep_factor"];
            this.tj_factor = _data["tj_factor"];
            this.kwh_factor = _data["kwh_factor"];
            this.density = _data["density"];
            this.code = _data["code"];
            this.is_default = _data["is_default"];
            this.diagnosis_field_option_option_id = _data["diagnosis_field_option_option_id"];
        }
    }

    static fromJS(data: any): EnergyVectorsCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EnergyVectorsCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table_code_index"] = this.table_code_index;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["vector_type"] = this.vector_type;
        data["co2_factor"] = this.co2_factor;
        data["tep_factor"] = this.tep_factor;
        data["tj_factor"] = this.tj_factor;
        data["kwh_factor"] = this.kwh_factor;
        data["density"] = this.density;
        data["code"] = this.code;
        data["is_default"] = this.is_default;
        data["diagnosis_field_option_option_id"] = this.diagnosis_field_option_option_id;
        return data;
    }
}

export interface IEnergyVectorsCreateDTO {
    table_code_index: string;
    unit_of_measurement?: string | undefined;
    vector_type: string;
    co2_factor?: number | undefined;
    tep_factor?: number | undefined;
    tj_factor?: number | undefined;
    kwh_factor?: number | undefined;
    density?: number | undefined;
    code?: string | undefined;
    is_default?: boolean | undefined;
    diagnosis_field_option_option_id: number;
}

export class EnergyVectorsReadDTO implements IEnergyVectorsReadDTO {
    table_code_index!: string;
    unit_of_measurement?: string | undefined;
    vector_type!: string;
    co2_factor?: number | undefined;
    tep_factor?: number | undefined;
    tj_factor?: number | undefined;
    kwh_factor?: number | undefined;
    density?: number | undefined;
    code?: string | undefined;
    is_default?: boolean | undefined;
    diagnosis_field_option_option_id!: number;
    id?: string;

    constructor(data?: IEnergyVectorsReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.table_code_index = _data["table_code_index"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.vector_type = _data["vector_type"];
            this.co2_factor = _data["co2_factor"];
            this.tep_factor = _data["tep_factor"];
            this.tj_factor = _data["tj_factor"];
            this.kwh_factor = _data["kwh_factor"];
            this.density = _data["density"];
            this.code = _data["code"];
            this.is_default = _data["is_default"];
            this.diagnosis_field_option_option_id = _data["diagnosis_field_option_option_id"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EnergyVectorsReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EnergyVectorsReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table_code_index"] = this.table_code_index;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["vector_type"] = this.vector_type;
        data["co2_factor"] = this.co2_factor;
        data["tep_factor"] = this.tep_factor;
        data["tj_factor"] = this.tj_factor;
        data["kwh_factor"] = this.kwh_factor;
        data["density"] = this.density;
        data["code"] = this.code;
        data["is_default"] = this.is_default;
        data["diagnosis_field_option_option_id"] = this.diagnosis_field_option_option_id;
        data["id"] = this.id;
        return data;
    }
}

export interface IEnergyVectorsReadDTO {
    table_code_index: string;
    unit_of_measurement?: string | undefined;
    vector_type: string;
    co2_factor?: number | undefined;
    tep_factor?: number | undefined;
    tj_factor?: number | undefined;
    kwh_factor?: number | undefined;
    density?: number | undefined;
    code?: string | undefined;
    is_default?: boolean | undefined;
    diagnosis_field_option_option_id: number;
    id?: string;
}

export class FeedbackRequest implements IFeedbackRequest {
    /** Searcher item UID (format: {source}:{type}:{id}) */
    uid!: string;
    /** Positive (+1) or negative (-1) signal */
    signal!: FeedbackRequestSignal;

    constructor(data?: IFeedbackRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.signal = _data["signal"];
        }
    }

    static fromJS(data: any): FeedbackRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["signal"] = this.signal;
        return data;
    }
}

export interface IFeedbackRequest {
    /** Searcher item UID (format: {source}:{type}:{id}) */
    uid: string;
    /** Positive (+1) or negative (-1) signal */
    signal: FeedbackRequestSignal;
}

export class FeedbackResponse implements IFeedbackResponse {
    status?: string;

    constructor(data?: IFeedbackResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.status = "ok";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : "ok";
        }
    }

    static fromJS(data: any): FeedbackResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface IFeedbackResponse {
    status?: string;
}

export class FieldOptionCreateDTO implements IFieldOptionCreateDTO {
    table_code_index!: string;
    option_value?: string | undefined;

    constructor(data?: IFieldOptionCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.table_code_index = _data["table_code_index"];
            this.option_value = _data["option_value"];
        }
    }

    static fromJS(data: any): FieldOptionCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FieldOptionCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table_code_index"] = this.table_code_index;
        data["option_value"] = this.option_value;
        return data;
    }
}

export interface IFieldOptionCreateDTO {
    table_code_index: string;
    option_value?: string | undefined;
}

export class FieldOptionReadDTO implements IFieldOptionReadDTO {
    table_code_index!: string;
    option_value?: string | undefined;
    id?: string;

    constructor(data?: IFieldOptionReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.table_code_index = _data["table_code_index"];
            this.option_value = _data["option_value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FieldOptionReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FieldOptionReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table_code_index"] = this.table_code_index;
        data["option_value"] = this.option_value;
        data["id"] = this.id;
        return data;
    }
}

export interface IFieldOptionReadDTO {
    table_code_index: string;
    option_value?: string | undefined;
    id?: string;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
    email!: string;

    constructor(data?: IForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IForgotPasswordRequest {
    email: string;
}

export enum FunctionalArea {
    P = "P",
    A = "A",
    G = "G",
}

export class HTTPValidationError implements IHTTPValidationError {
    detail?: ValidationError[];

    [key: string]: any;

    constructor(data?: IHTTPValidationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["detail"])) {
                this.detail = [] as any;
                for (let item of _data["detail"])
                    this.detail!.push(ValidationError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HTTPValidationError {
        data = typeof data === 'object' ? data : {};
        let result = new HTTPValidationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.detail)) {
            data["detail"] = [];
            for (let item of this.detail)
                data["detail"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHTTPValidationError {
    detail?: ValidationError[];

    [key: string]: any;
}

export class IncidenceEneaCreateDTO implements IIncidenceEneaCreateDTO {
    code!: string;
    unit_of_measurement?: string | undefined;
    codice_ateco?: string[];
    minimum_percentage_consideration?: number | undefined;

    constructor(data?: IIncidenceEneaCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            if (Array.isArray(_data["codice_ateco"])) {
                this.codice_ateco = [] as any;
                for (let item of _data["codice_ateco"])
                    this.codice_ateco!.push(item);
            }
            this.minimum_percentage_consideration = _data["minimum_percentage_consideration"];
        }
    }

    static fromJS(data: any): IncidenceEneaCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IncidenceEneaCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["unit_of_measurement"] = this.unit_of_measurement;
        if (Array.isArray(this.codice_ateco)) {
            data["codice_ateco"] = [];
            for (let item of this.codice_ateco)
                data["codice_ateco"].push(item);
        }
        data["minimum_percentage_consideration"] = this.minimum_percentage_consideration;
        return data;
    }
}

export interface IIncidenceEneaCreateDTO {
    code: string;
    unit_of_measurement?: string | undefined;
    codice_ateco?: string[];
    minimum_percentage_consideration?: number | undefined;
}

export class IncidenceEneaPercentageCreateDTO implements IIncidenceEneaPercentageCreateDTO {
    incidence_enea_id!: string;
    from_value!: number;
    to_value?: number | undefined;
    functional_area!: FunctionalArea;
    percentage!: number;

    constructor(data?: IIncidenceEneaPercentageCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incidence_enea_id = _data["incidence_enea_id"];
            this.from_value = _data["from_value"];
            this.to_value = _data["to_value"];
            this.functional_area = _data["functional_area"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): IncidenceEneaPercentageCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IncidenceEneaPercentageCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidence_enea_id"] = this.incidence_enea_id;
        data["from_value"] = this.from_value;
        data["to_value"] = this.to_value;
        data["functional_area"] = this.functional_area;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IIncidenceEneaPercentageCreateDTO {
    incidence_enea_id: string;
    from_value: number;
    to_value?: number | undefined;
    functional_area: FunctionalArea;
    percentage: number;
}

export class IncidenceEneaPercentageReadDTO implements IIncidenceEneaPercentageReadDTO {
    incidence_enea_id!: string;
    from_value!: number;
    to_value?: number | undefined;
    functional_area!: FunctionalArea;
    percentage!: number;
    id?: string;

    constructor(data?: IIncidenceEneaPercentageReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incidence_enea_id = _data["incidence_enea_id"];
            this.from_value = _data["from_value"];
            this.to_value = _data["to_value"];
            this.functional_area = _data["functional_area"];
            this.percentage = _data["percentage"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IncidenceEneaPercentageReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IncidenceEneaPercentageReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidence_enea_id"] = this.incidence_enea_id;
        data["from_value"] = this.from_value;
        data["to_value"] = this.to_value;
        data["functional_area"] = this.functional_area;
        data["percentage"] = this.percentage;
        data["id"] = this.id;
        return data;
    }
}

export interface IIncidenceEneaPercentageReadDTO {
    incidence_enea_id: string;
    from_value: number;
    to_value?: number | undefined;
    functional_area: FunctionalArea;
    percentage: number;
    id?: string;
}

export class IncidenceEneaReadDTO implements IIncidenceEneaReadDTO {
    id!: string;
    code!: string;
    unit_of_measurement?: string | undefined;
    codice_ateco?: string[];
    minimum_percentage_consideration?: number | undefined;

    constructor(data?: IIncidenceEneaReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            if (Array.isArray(_data["codice_ateco"])) {
                this.codice_ateco = [] as any;
                for (let item of _data["codice_ateco"])
                    this.codice_ateco!.push(item);
            }
            this.minimum_percentage_consideration = _data["minimum_percentage_consideration"];
        }
    }

    static fromJS(data: any): IncidenceEneaReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IncidenceEneaReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["unit_of_measurement"] = this.unit_of_measurement;
        if (Array.isArray(this.codice_ateco)) {
            data["codice_ateco"] = [];
            for (let item of this.codice_ateco)
                data["codice_ateco"].push(item);
        }
        data["minimum_percentage_consideration"] = this.minimum_percentage_consideration;
        return data;
    }
}

export interface IIncidenceEneaReadDTO {
    id: string;
    code: string;
    unit_of_measurement?: string | undefined;
    codice_ateco?: string[];
    minimum_percentage_consideration?: number | undefined;
}

export class IndicatorReferencePeriodsCreateDTO implements IIndicatorReferencePeriodsCreateDTO {
    indicator_id?: string | undefined;
    start_month!: number;
    end_month!: number;
    value?: number | undefined;

    constructor(data?: IIndicatorReferencePeriodsCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indicator_id = _data["indicator_id"];
            this.start_month = _data["start_month"];
            this.end_month = _data["end_month"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): IndicatorReferencePeriodsCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IndicatorReferencePeriodsCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicator_id"] = this.indicator_id;
        data["start_month"] = this.start_month;
        data["end_month"] = this.end_month;
        data["value"] = this.value;
        return data;
    }
}

export interface IIndicatorReferencePeriodsCreateDTO {
    indicator_id?: string | undefined;
    start_month: number;
    end_month: number;
    value?: number | undefined;
}

export class IndicatorReferencePeriodsReadDTO implements IIndicatorReferencePeriodsReadDTO {
    indicator_id?: string | undefined;
    start_month!: number;
    end_month!: number;
    value?: number | undefined;
    id?: string;

    constructor(data?: IIndicatorReferencePeriodsReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indicator_id = _data["indicator_id"];
            this.start_month = _data["start_month"];
            this.end_month = _data["end_month"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IndicatorReferencePeriodsReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IndicatorReferencePeriodsReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicator_id"] = this.indicator_id;
        data["start_month"] = this.start_month;
        data["end_month"] = this.end_month;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface IIndicatorReferencePeriodsReadDTO {
    indicator_id?: string | undefined;
    start_month: number;
    end_month: number;
    value?: number | undefined;
    id?: string;
}

export class InitDiagnosisDto implements IInitDiagnosisDto {
    customer_id!: string;
    site_id!: string;
    referent_id!: string;
    code!: string;

    [key: string]: any;

    constructor(data?: IInitDiagnosisDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.customer_id = _data["customer_id"];
            this.site_id = _data["site_id"];
            this.referent_id = _data["referent_id"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): InitDiagnosisDto {
        data = typeof data === 'object' ? data : {};
        let result = new InitDiagnosisDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["customer_id"] = this.customer_id;
        data["site_id"] = this.site_id;
        data["referent_id"] = this.referent_id;
        data["code"] = this.code;
        return data;
    }
}

export interface IInitDiagnosisDto {
    customer_id: string;
    site_id: string;
    referent_id: string;
    code: string;

    [key: string]: any;
}

export class InviteInfoOut implements IInviteInfoOut {
    email!: string;
    role!: string;
    valid?: boolean;

    constructor(data?: IInviteInfoOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.valid = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.role = _data["role"];
            this.valid = _data["valid"] !== undefined ? _data["valid"] : true;
        }
    }

    static fromJS(data: any): InviteInfoOut {
        data = typeof data === 'object' ? data : {};
        let result = new InviteInfoOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["role"] = this.role;
        data["valid"] = this.valid;
        return data;
    }
}

export interface IInviteInfoOut {
    email: string;
    role: string;
    valid?: boolean;
}

export class InviteRequest implements IInviteRequest {
    email!: string;
    role!: UserRole;

    constructor(data?: IInviteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): InviteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["role"] = this.role;
        return data;
    }
}

export interface IInviteRequest {
    email: string;
    role: UserRole;
}

export class MessageResponse implements IMessageResponse {
    message!: string;

    constructor(data?: IMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): MessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IMessageResponse {
    message: string;
}

export class MeterRelation implements IMeterRelation {
    meter_id!: string;
    code!: string;

    [key: string]: any;

    constructor(data?: IMeterRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.meter_id = _data["meter_id"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): MeterRelation {
        data = typeof data === 'object' ? data : {};
        let result = new MeterRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["meter_id"] = this.meter_id;
        data["code"] = this.code;
        return data;
    }
}

export interface IMeterRelation {
    meter_id: string;
    code: string;

    [key: string]: any;
}

export enum MeterType {
    PODp = "PODp",
    PODi = "PODi",
    PROD = "PROD",
    PDR = "PDR",
    TOT = "TOT",
}

export class MetersDataBatchItem implements IMetersDataBatchItem {
    id?: string | undefined;
    meter_id?: string | undefined;
    month!: string;
    value?: number | undefined;

    constructor(data?: IMetersDataBatchItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.meter_id = _data["meter_id"];
            this.month = _data["month"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MetersDataBatchItem {
        data = typeof data === 'object' ? data : {};
        let result = new MetersDataBatchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meter_id"] = this.meter_id;
        data["month"] = this.month;
        data["value"] = this.value;
        return data;
    }
}

export interface IMetersDataBatchItem {
    id?: string | undefined;
    meter_id?: string | undefined;
    month: string;
    value?: number | undefined;
}

export class MetersDataCreateDTO implements IMetersDataCreateDTO {
    meter_id?: string | undefined;
    month!: string;
    value?: number | undefined;

    constructor(data?: IMetersDataCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meter_id = _data["meter_id"];
            this.month = _data["month"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MetersDataCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MetersDataCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meter_id"] = this.meter_id;
        data["month"] = this.month;
        data["value"] = this.value;
        return data;
    }
}

export interface IMetersDataCreateDTO {
    meter_id?: string | undefined;
    month: string;
    value?: number | undefined;
}

export class MetersDataReadDTO implements IMetersDataReadDTO {
    meter_id?: string | undefined;
    month!: string;
    value?: number | undefined;
    id?: string;

    constructor(data?: IMetersDataReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meter_id = _data["meter_id"];
            this.month = _data["month"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MetersDataReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MetersDataReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meter_id"] = this.meter_id;
        data["month"] = this.month;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface IMetersDataReadDTO {
    meter_id?: string | undefined;
    month: string;
    value?: number | undefined;
    id?: string;
}

export class MonthlyIndicatorValuesCreateDTO implements IMonthlyIndicatorValuesCreateDTO {
    indicator_id?: string | undefined;
    year!: number;
    month!: number;
    value?: number | undefined;

    constructor(data?: IMonthlyIndicatorValuesCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indicator_id = _data["indicator_id"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MonthlyIndicatorValuesCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyIndicatorValuesCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicator_id"] = this.indicator_id;
        data["year"] = this.year;
        data["month"] = this.month;
        data["value"] = this.value;
        return data;
    }
}

export interface IMonthlyIndicatorValuesCreateDTO {
    indicator_id?: string | undefined;
    year: number;
    month: number;
    value?: number | undefined;
}

export class MonthlyIndicatorValuesReadDTO implements IMonthlyIndicatorValuesReadDTO {
    indicator_id?: string | undefined;
    year!: number;
    month!: number;
    value?: number | undefined;
    id?: string;

    constructor(data?: IMonthlyIndicatorValuesReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indicator_id = _data["indicator_id"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MonthlyIndicatorValuesReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyIndicatorValuesReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicator_id"] = this.indicator_id;
        data["year"] = this.year;
        data["month"] = this.month;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface IMonthlyIndicatorValuesReadDTO {
    indicator_id?: string | undefined;
    year: number;
    month: number;
    value?: number | undefined;
    id?: string;
}

export class MonthlyVectorValuesCreateDTO implements IMonthlyVectorValuesCreateDTO {
    vector_id?: string | undefined;
    year!: number;
    month!: number;
    unit_of_measurement?: string | undefined;
    value?: number | undefined;

    constructor(data?: IMonthlyVectorValuesCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vector_id = _data["vector_id"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MonthlyVectorValuesCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyVectorValuesCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vector_id"] = this.vector_id;
        data["year"] = this.year;
        data["month"] = this.month;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["value"] = this.value;
        return data;
    }
}

export interface IMonthlyVectorValuesCreateDTO {
    vector_id?: string | undefined;
    year: number;
    month: number;
    unit_of_measurement?: string | undefined;
    value?: number | undefined;
}

export class MonthlyVectorValuesReadDTO implements IMonthlyVectorValuesReadDTO {
    vector_id?: string | undefined;
    year!: number;
    month!: number;
    unit_of_measurement?: string | undefined;
    value?: number | undefined;
    id?: string;

    constructor(data?: IMonthlyVectorValuesReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vector_id = _data["vector_id"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MonthlyVectorValuesReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyVectorValuesReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vector_id"] = this.vector_id;
        data["year"] = this.year;
        data["month"] = this.month;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface IMonthlyVectorValuesReadDTO {
    vector_id?: string | undefined;
    year: number;
    month: number;
    unit_of_measurement?: string | undefined;
    value?: number | undefined;
    id?: string;
}

export class PodTimetablesCreateDTO implements IPodTimetablesCreateDTO {
    diagnosis_id?: string | undefined;
    unit_of_measurement?: string | undefined;
    code?: string | undefined;
    hierarchy?: string | undefined;
    functional_area?: FunctionalArea | undefined;
    energy_use_id?: string | undefined;
    data_grouping?: string | undefined;
    chart?: string | undefined;
    notes?: string | undefined;
    total_consumption_verification?: boolean | undefined;
    index?: number | undefined;

    constructor(data?: IPodTimetablesCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_id = _data["diagnosis_id"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.code = _data["code"];
            this.hierarchy = _data["hierarchy"];
            this.functional_area = _data["functional_area"];
            this.energy_use_id = _data["energy_use_id"];
            this.data_grouping = _data["data_grouping"];
            this.chart = _data["chart"];
            this.notes = _data["notes"];
            this.total_consumption_verification = _data["total_consumption_verification"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): PodTimetablesCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PodTimetablesCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_id"] = this.diagnosis_id;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["code"] = this.code;
        data["hierarchy"] = this.hierarchy;
        data["functional_area"] = this.functional_area;
        data["energy_use_id"] = this.energy_use_id;
        data["data_grouping"] = this.data_grouping;
        data["chart"] = this.chart;
        data["notes"] = this.notes;
        data["total_consumption_verification"] = this.total_consumption_verification;
        data["index"] = this.index;
        return data;
    }
}

export interface IPodTimetablesCreateDTO {
    diagnosis_id?: string | undefined;
    unit_of_measurement?: string | undefined;
    code?: string | undefined;
    hierarchy?: string | undefined;
    functional_area?: FunctionalArea | undefined;
    energy_use_id?: string | undefined;
    data_grouping?: string | undefined;
    chart?: string | undefined;
    notes?: string | undefined;
    total_consumption_verification?: boolean | undefined;
    index?: number | undefined;
}

export class PodTimetablesDataBatchItem implements IPodTimetablesDataBatchItem {
    id?: string | undefined;
    pod_timetable_id?: string | undefined;
    datetime!: string;
    value?: number | undefined;

    constructor(data?: IPodTimetablesDataBatchItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pod_timetable_id = _data["pod_timetable_id"];
            this.datetime = _data["datetime"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PodTimetablesDataBatchItem {
        data = typeof data === 'object' ? data : {};
        let result = new PodTimetablesDataBatchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pod_timetable_id"] = this.pod_timetable_id;
        data["datetime"] = this.datetime;
        data["value"] = this.value;
        return data;
    }
}

export interface IPodTimetablesDataBatchItem {
    id?: string | undefined;
    pod_timetable_id?: string | undefined;
    datetime: string;
    value?: number | undefined;
}

export class PodTimetablesDataCreateDTO implements IPodTimetablesDataCreateDTO {
    pod_timetable_id!: string;
    datetime!: string;
    value?: number | undefined;

    constructor(data?: IPodTimetablesDataCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pod_timetable_id = _data["pod_timetable_id"];
            this.datetime = _data["datetime"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PodTimetablesDataCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PodTimetablesDataCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pod_timetable_id"] = this.pod_timetable_id;
        data["datetime"] = this.datetime;
        data["value"] = this.value;
        return data;
    }
}

export interface IPodTimetablesDataCreateDTO {
    pod_timetable_id: string;
    datetime: string;
    value?: number | undefined;
}

export class PodTimetablesDataReadDTO implements IPodTimetablesDataReadDTO {
    pod_timetable_id!: string;
    datetime!: string;
    value?: number | undefined;
    id?: string;

    constructor(data?: IPodTimetablesDataReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pod_timetable_id = _data["pod_timetable_id"];
            this.datetime = _data["datetime"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PodTimetablesDataReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PodTimetablesDataReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pod_timetable_id"] = this.pod_timetable_id;
        data["datetime"] = this.datetime;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface IPodTimetablesDataReadDTO {
    pod_timetable_id: string;
    datetime: string;
    value?: number | undefined;
    id?: string;
}

export class PodTimetablesDataTotalReadDTO implements IPodTimetablesDataTotalReadDTO {
    id?: string | undefined;
    pod_timetable_id!: string;
    datetime!: string;
    value?: number | undefined;

    constructor(data?: IPodTimetablesDataTotalReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pod_timetable_id = _data["pod_timetable_id"];
            this.datetime = _data["datetime"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PodTimetablesDataTotalReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PodTimetablesDataTotalReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pod_timetable_id"] = this.pod_timetable_id;
        data["datetime"] = this.datetime;
        data["value"] = this.value;
        return data;
    }
}

export interface IPodTimetablesDataTotalReadDTO {
    id?: string | undefined;
    pod_timetable_id: string;
    datetime: string;
    value?: number | undefined;
}

export class PodTimetablesReadDTO implements IPodTimetablesReadDTO {
    diagnosis_id?: string | undefined;
    unit_of_measurement?: string | undefined;
    code?: string | undefined;
    hierarchy?: string | undefined;
    functional_area?: FunctionalArea | undefined;
    energy_use_id?: string | undefined;
    data_grouping?: string | undefined;
    chart?: string | undefined;
    notes?: string | undefined;
    total_consumption_verification?: boolean | undefined;
    index?: number | undefined;
    id?: string;

    constructor(data?: IPodTimetablesReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_id = _data["diagnosis_id"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.code = _data["code"];
            this.hierarchy = _data["hierarchy"];
            this.functional_area = _data["functional_area"];
            this.energy_use_id = _data["energy_use_id"];
            this.data_grouping = _data["data_grouping"];
            this.chart = _data["chart"];
            this.notes = _data["notes"];
            this.total_consumption_verification = _data["total_consumption_verification"];
            this.index = _data["index"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PodTimetablesReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PodTimetablesReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_id"] = this.diagnosis_id;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["code"] = this.code;
        data["hierarchy"] = this.hierarchy;
        data["functional_area"] = this.functional_area;
        data["energy_use_id"] = this.energy_use_id;
        data["data_grouping"] = this.data_grouping;
        data["chart"] = this.chart;
        data["notes"] = this.notes;
        data["total_consumption_verification"] = this.total_consumption_verification;
        data["index"] = this.index;
        data["id"] = this.id;
        return data;
    }
}

export interface IPodTimetablesReadDTO {
    diagnosis_id?: string | undefined;
    unit_of_measurement?: string | undefined;
    code?: string | undefined;
    hierarchy?: string | undefined;
    functional_area?: FunctionalArea | undefined;
    energy_use_id?: string | undefined;
    data_grouping?: string | undefined;
    chart?: string | undefined;
    notes?: string | undefined;
    total_consumption_verification?: boolean | undefined;
    index?: number | undefined;
    id?: string;
}

export class RecalculateDto implements IRecalculateDto {
    diagnosis_id!: string;

    [key: string]: any;

    constructor(data?: IRecalculateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.diagnosis_id = _data["diagnosis_id"];
        }
    }

    static fromJS(data: any): RecalculateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecalculateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["diagnosis_id"] = this.diagnosis_id;
        return data;
    }
}

export interface IRecalculateDto {
    diagnosis_id: string;

    [key: string]: any;
}

export class RecommenderRequest implements IRecommenderRequest {
    /** UUID of the diagnosis to recommend items for */
    id_entity!: string;
    /** Item type to search: 'interventi', 'indicatori', or 'uses' */
    filter!: RecommenderRequestFilter;
    /** If False, restrict results to internal (diagnosis-linked) items only */
    include_external?: boolean;

    constructor(data?: IRecommenderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.include_external = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id_entity = _data["id_entity"];
            this.filter = _data["filter"];
            this.include_external = _data["include_external"] !== undefined ? _data["include_external"] : true;
        }
    }

    static fromJS(data: any): RecommenderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecommenderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id_entity"] = this.id_entity;
        data["filter"] = this.filter;
        data["include_external"] = this.include_external;
        return data;
    }
}

export interface IRecommenderRequest {
    /** UUID of the diagnosis to recommend items for */
    id_entity: string;
    /** Item type to search: 'interventi', 'indicatori', or 'uses' */
    filter: RecommenderRequestFilter;
    /** If False, restrict results to internal (diagnosis-linked) items only */
    include_external?: boolean;
}

/** Solo i campi periodo di riferimento: per PATCH parziale senza validare tutto il modello. */
export class ReferencePeriodUpdateDto implements IReferencePeriodUpdateDto {
    reference_period_quantity?: number | undefined;
    reference_period_price?: number | undefined;
    reference_period_unitcost?: number | undefined;

    [key: string]: any;

    constructor(data?: IReferencePeriodUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.reference_period_quantity = _data["reference_period_quantity"];
            this.reference_period_price = _data["reference_period_price"];
            this.reference_period_unitcost = _data["reference_period_unitcost"];
        }
    }

    static fromJS(data: any): ReferencePeriodUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferencePeriodUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["reference_period_quantity"] = this.reference_period_quantity;
        data["reference_period_price"] = this.reference_period_price;
        data["reference_period_unitcost"] = this.reference_period_unitcost;
        return data;
    }
}

/** Solo i campi periodo di riferimento: per PATCH parziale senza validare tutto il modello. */
export interface IReferencePeriodUpdateDto {
    reference_period_quantity?: number | undefined;
    reference_period_price?: number | undefined;
    reference_period_unitcost?: number | undefined;

    [key: string]: any;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
    token!: string;
    new_password!: string;
    new_password_confirm!: string;

    constructor(data?: IResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.new_password = _data["new_password"];
            this.new_password_confirm = _data["new_password_confirm"];
        }
    }

    static fromJS(data: any): ResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["new_password"] = this.new_password;
        data["new_password_confirm"] = this.new_password_confirm;
        return data;
    }
}

export interface IResetPasswordRequest {
    token: string;
    new_password: string;
    new_password_confirm: string;
}

export class SearchRequest implements ISearchRequest {
    /** Optional UUID of a diagnosis — used only for future query enrichment */
    id_entity?: string | undefined;
    /** Free-text search query */
    query!: string;
    /** Item type to search: 'interventi', 'indicatori', or 'uses' */
    filter!: SearchRequestFilter;
    /** If False, restrict results to internal items only */
    include_external?: boolean;

    constructor(data?: ISearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.include_external = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id_entity = _data["id_entity"];
            this.query = _data["query"];
            this.filter = _data["filter"];
            this.include_external = _data["include_external"] !== undefined ? _data["include_external"] : true;
        }
    }

    static fromJS(data: any): SearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id_entity"] = this.id_entity;
        data["query"] = this.query;
        data["filter"] = this.filter;
        data["include_external"] = this.include_external;
        return data;
    }
}

export interface ISearchRequest {
    /** Optional UUID of a diagnosis — used only for future query enrichment */
    id_entity?: string | undefined;
    /** Free-text search query */
    query: string;
    /** Item type to search: 'interventi', 'indicatori', or 'uses' */
    filter: SearchRequestFilter;
    /** If False, restrict results to internal items only */
    include_external?: boolean;
}

export class SearchResultFields implements ISearchResultFields {
    code?: string | undefined;
    description?: string | undefined;
    title?: string | undefined;
    type?: string | undefined;
    comments?: string | undefined;
    investment?: number | undefined;
    expected_economic_saving?: number | undefined;
    expected_economical_saving?: number | undefined;
    payback_time?: number | undefined;
    ateco_rif?: string[];

    constructor(data?: ISearchResultFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.comments = _data["comments"];
            this.investment = _data["investment"];
            this.expected_economic_saving = _data["expected_economic_saving"];
            this.expected_economical_saving = _data["expected_economical_saving"];
            this.payback_time = _data["payback_time"];
            if (Array.isArray(_data["ateco_rif"])) {
                this.ateco_rif = [] as any;
                for (let item of _data["ateco_rif"])
                    this.ateco_rif!.push(item);
            }
        }
    }

    static fromJS(data: any): SearchResultFields {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["title"] = this.title;
        data["type"] = this.type;
        data["comments"] = this.comments;
        data["investment"] = this.investment;
        data["expected_economic_saving"] = this.expected_economic_saving;
        data["expected_economical_saving"] = this.expected_economical_saving;
        data["payback_time"] = this.payback_time;
        if (Array.isArray(this.ateco_rif)) {
            data["ateco_rif"] = [];
            for (let item of this.ateco_rif)
                data["ateco_rif"].push(item);
        }
        return data;
    }
}

export interface ISearchResultFields {
    code?: string | undefined;
    description?: string | undefined;
    title?: string | undefined;
    type?: string | undefined;
    comments?: string | undefined;
    investment?: number | undefined;
    expected_economic_saving?: number | undefined;
    expected_economical_saving?: number | undefined;
    payback_time?: number | undefined;
    ateco_rif?: string[];
}

export class SearchResultItem implements ISearchResultItem {
    /** Searcher item UID */
    uid!: string;
    /** Primary key of the representative domain row */
    id_source!: string;
    /** All domain row IDs that share this dedup key (code+description+ateco). Present for internal indicators and interventions only. */
    element_ids?: string[] | undefined;
    /** Data source type */
    tipo!: SearchResultItemTipo;
    /** Company name (internal) or fonte field (external) */
    fonte!: string;
    /** Display fields for the matched item */
    fields!: SearchResultFields;

    constructor(data?: ISearchResultItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fields = new SearchResultFields();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.id_source = _data["id_source"];
            if (Array.isArray(_data["element_ids"])) {
                this.element_ids = [] as any;
                for (let item of _data["element_ids"])
                    this.element_ids!.push(item);
            }
            this.tipo = _data["tipo"];
            this.fonte = _data["fonte"];
            this.fields = _data["fields"] ? SearchResultFields.fromJS(_data["fields"]) : new SearchResultFields();
        }
    }

    static fromJS(data: any): SearchResultItem {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["id_source"] = this.id_source;
        if (Array.isArray(this.element_ids)) {
            data["element_ids"] = [];
            for (let item of this.element_ids)
                data["element_ids"].push(item);
        }
        data["tipo"] = this.tipo;
        data["fonte"] = this.fonte;
        data["fields"] = this.fields ? this.fields.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISearchResultItem {
    /** Searcher item UID */
    uid: string;
    /** Primary key of the representative domain row */
    id_source: string;
    /** All domain row IDs that share this dedup key (code+description+ateco). Present for internal indicators and interventions only. */
    element_ids?: string[] | undefined;
    /** Data source type */
    tipo: SearchResultItemTipo;
    /** Company name (internal) or fonte field (external) */
    fonte: string;
    /** Display fields for the matched item */
    fields: SearchResultFields;
}

export enum SeasonEnum {
    Winter = "winter",
    Summer = "summer",
    All = "all",
}

export class SelfProductionPlantsCreateDTO implements ISelfProductionPlantsCreateDTO {
    site_id?: string | undefined;
    type?: string | undefined;
    power_source?: string | undefined;
    in_service_year?: string | undefined;
    electrical_power_kw?: number | undefined;
    thermal_power_kw?: number | undefined;
    cooling_power_kw?: number | undefined;

    constructor(data?: ISelfProductionPlantsCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.site_id = _data["site_id"];
            this.type = _data["type"];
            this.power_source = _data["power_source"];
            this.in_service_year = _data["in_service_year"];
            this.electrical_power_kw = _data["electrical_power_kw"];
            this.thermal_power_kw = _data["thermal_power_kw"];
            this.cooling_power_kw = _data["cooling_power_kw"];
        }
    }

    static fromJS(data: any): SelfProductionPlantsCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SelfProductionPlantsCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["site_id"] = this.site_id;
        data["type"] = this.type;
        data["power_source"] = this.power_source;
        data["in_service_year"] = this.in_service_year;
        data["electrical_power_kw"] = this.electrical_power_kw;
        data["thermal_power_kw"] = this.thermal_power_kw;
        data["cooling_power_kw"] = this.cooling_power_kw;
        return data;
    }
}

export interface ISelfProductionPlantsCreateDTO {
    site_id?: string | undefined;
    type?: string | undefined;
    power_source?: string | undefined;
    in_service_year?: string | undefined;
    electrical_power_kw?: number | undefined;
    thermal_power_kw?: number | undefined;
    cooling_power_kw?: number | undefined;
}

export class SelfProductionPlantsReadDTO implements ISelfProductionPlantsReadDTO {
    site_id?: string | undefined;
    type?: string | undefined;
    power_source?: string | undefined;
    in_service_year?: string | undefined;
    electrical_power_kw?: number | undefined;
    thermal_power_kw?: number | undefined;
    cooling_power_kw?: number | undefined;
    id?: string;

    constructor(data?: ISelfProductionPlantsReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.site_id = _data["site_id"];
            this.type = _data["type"];
            this.power_source = _data["power_source"];
            this.in_service_year = _data["in_service_year"];
            this.electrical_power_kw = _data["electrical_power_kw"];
            this.thermal_power_kw = _data["thermal_power_kw"];
            this.cooling_power_kw = _data["cooling_power_kw"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SelfProductionPlantsReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SelfProductionPlantsReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["site_id"] = this.site_id;
        data["type"] = this.type;
        data["power_source"] = this.power_source;
        data["in_service_year"] = this.in_service_year;
        data["electrical_power_kw"] = this.electrical_power_kw;
        data["thermal_power_kw"] = this.thermal_power_kw;
        data["cooling_power_kw"] = this.cooling_power_kw;
        data["id"] = this.id;
        return data;
    }
}

export interface ISelfProductionPlantsReadDTO {
    site_id?: string | undefined;
    type?: string | undefined;
    power_source?: string | undefined;
    in_service_year?: string | undefined;
    electrical_power_kw?: number | undefined;
    thermal_power_kw?: number | undefined;
    cooling_power_kw?: number | undefined;
    id?: string;
}

export class SiteImageUploadDTO implements ISiteImageUploadDTO {
    image_base64!: string;

    [key: string]: any;

    constructor(data?: ISiteImageUploadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.image_base64 = _data["image_base64"];
        }
    }

    static fromJS(data: any): SiteImageUploadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SiteImageUploadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["image_base64"] = this.image_base64;
        return data;
    }
}

export interface ISiteImageUploadDTO {
    image_base64: string;

    [key: string]: any;
}

export class AccessTokenOut implements IAccessTokenOut {
    access_token!: string;
    token_type!: string;

    constructor(data?: IAccessTokenOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access_token = _data["access_token"];
            this.token_type = _data["token_type"];
        }
    }

    static fromJS(data: any): AccessTokenOut {
        data = typeof data === 'object' ? data : {};
        let result = new AccessTokenOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access_token"] = this.access_token;
        data["token_type"] = this.token_type;
        return data;
    }
}

/** Risposta di login/refresh: contiene solo l'access token. Il refresh token viaggia in un cookie HttpOnly e non è mai esposto nel body. */
export interface IAccessTokenOut {
    access_token: string;
    token_type: string;
}

export class UnitCostOverrideCreateDTO implements IUnitCostOverrideCreateDTO {
    diagnosis_id!: string;
    energy_vector_id!: string;
    unit_cost!: number;

    constructor(data?: IUnitCostOverrideCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diagnosis_id = _data["diagnosis_id"];
            this.energy_vector_id = _data["energy_vector_id"];
            this.unit_cost = _data["unit_cost"];
        }
    }

    static fromJS(data: any): UnitCostOverrideCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UnitCostOverrideCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosis_id"] = this.diagnosis_id;
        data["energy_vector_id"] = this.energy_vector_id;
        data["unit_cost"] = this.unit_cost;
        return data;
    }
}

export interface IUnitCostOverrideCreateDTO {
    diagnosis_id: string;
    energy_vector_id: string;
    unit_cost: number;
}

export class UnitCostOverrideReadDTO implements IUnitCostOverrideReadDTO {
    id?: string | undefined;
    diagnosis_id?: string | undefined;
    energy_vector_id?: string | undefined;
    unit_cost?: number | undefined;

    constructor(data?: IUnitCostOverrideReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.diagnosis_id = _data["diagnosis_id"];
            this.energy_vector_id = _data["energy_vector_id"];
            this.unit_cost = _data["unit_cost"];
        }
    }

    static fromJS(data: any): UnitCostOverrideReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UnitCostOverrideReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["diagnosis_id"] = this.diagnosis_id;
        data["energy_vector_id"] = this.energy_vector_id;
        data["unit_cost"] = this.unit_cost;
        return data;
    }
}

export interface IUnitCostOverrideReadDTO {
    id?: string | undefined;
    diagnosis_id?: string | undefined;
    energy_vector_id?: string | undefined;
    unit_cost?: number | undefined;
}

export class UpdateConsumptionsOrderDto implements IUpdateConsumptionsOrderDto {
    consumption_ids!: string[];

    [key: string]: any;

    constructor(data?: IUpdateConsumptionsOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.consumption_ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["consumption_ids"])) {
                this.consumption_ids = [] as any;
                for (let item of _data["consumption_ids"])
                    this.consumption_ids!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateConsumptionsOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConsumptionsOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.consumption_ids)) {
            data["consumption_ids"] = [];
            for (let item of this.consumption_ids)
                data["consumption_ids"].push(item);
        }
        return data;
    }
}

export interface IUpdateConsumptionsOrderDto {
    consumption_ids: string[];

    [key: string]: any;
}

export class UpdateMetersOrderDto implements IUpdateMetersOrderDto {
    meter_ids!: string[];

    [key: string]: any;

    constructor(data?: IUpdateMetersOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.meter_ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["meter_ids"])) {
                this.meter_ids = [] as any;
                for (let item of _data["meter_ids"])
                    this.meter_ids!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateMetersOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMetersOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.meter_ids)) {
            data["meter_ids"] = [];
            for (let item of this.meter_ids)
                data["meter_ids"].push(item);
        }
        return data;
    }
}

export interface IUpdateMetersOrderDto {
    meter_ids: string[];

    [key: string]: any;
}

export class UpdatePodTimetablesOrderDto implements IUpdatePodTimetablesOrderDto {
    pod_timetable_ids!: string[];

    [key: string]: any;

    constructor(data?: IUpdatePodTimetablesOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pod_timetable_ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["pod_timetable_ids"])) {
                this.pod_timetable_ids = [] as any;
                for (let item of _data["pod_timetable_ids"])
                    this.pod_timetable_ids!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdatePodTimetablesOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePodTimetablesOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.pod_timetable_ids)) {
            data["pod_timetable_ids"] = [];
            for (let item of this.pod_timetable_ids)
                data["pod_timetable_ids"].push(item);
        }
        return data;
    }
}

export interface IUpdatePodTimetablesOrderDto {
    pod_timetable_ids: string[];

    [key: string]: any;
}

export class UpdateUserValuesDto implements IUpdateUserValuesDto {
    technological_gap_vs_bats?: number | undefined;
    plant_management?: number | undefined;
    knowledge_measurement?: number | undefined;

    [key: string]: any;

    constructor(data?: IUpdateUserValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.technological_gap_vs_bats = _data["technological_gap_vs_bats"];
            this.plant_management = _data["plant_management"];
            this.knowledge_measurement = _data["knowledge_measurement"];
        }
    }

    static fromJS(data: any): UpdateUserValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["technological_gap_vs_bats"] = this.technological_gap_vs_bats;
        data["plant_management"] = this.plant_management;
        data["knowledge_measurement"] = this.knowledge_measurement;
        return data;
    }
}

export interface IUpdateUserValuesDto {
    technological_gap_vs_bats?: number | undefined;
    plant_management?: number | undefined;
    knowledge_measurement?: number | undefined;

    [key: string]: any;
}

export class UpdateVariablesOrderDto implements IUpdateVariablesOrderDto {
    variable_ids!: string[];

    [key: string]: any;

    constructor(data?: IUpdateVariablesOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.variable_ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["variable_ids"])) {
                this.variable_ids = [] as any;
                for (let item of _data["variable_ids"])
                    this.variable_ids!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateVariablesOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVariablesOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.variable_ids)) {
            data["variable_ids"] = [];
            for (let item of this.variable_ids)
                data["variable_ids"].push(item);
        }
        return data;
    }
}

export interface IUpdateVariablesOrderDto {
    variable_ids: string[];

    [key: string]: any;
}

export class UserCreateDTO implements IUserCreateDTO {
    email!: string;
    firstname?: string | undefined;
    lastname?: string | undefined;
    role?: UserRole;
    is_active?: boolean | undefined;

    constructor(data?: IUserCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = UserRole.BaseUser;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.role = _data["role"] !== undefined ? _data["role"] : UserRole.BaseUser;
            this.is_active = _data["is_active"];
        }
    }

    static fromJS(data: any): UserCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["role"] = this.role;
        data["is_active"] = this.is_active;
        return data;
    }
}

export interface IUserCreateDTO {
    email: string;
    firstname?: string | undefined;
    lastname?: string | undefined;
    role?: UserRole;
    is_active?: boolean | undefined;
}

export class UserLogin implements IUserLogin {
    email!: string;
    password!: string;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IUserLogin {
    email: string;
    password: string;
}

export class UserOut implements IUserOut {
    id!: string;
    email!: string;
    firstname?: string | undefined;
    lastname?: string | undefined;
    role?: UserRole;
    is_active!: boolean;
    is_verified!: boolean;

    constructor(data?: IUserOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = UserRole.BaseUser;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.role = _data["role"] !== undefined ? _data["role"] : UserRole.BaseUser;
            this.is_active = _data["is_active"];
            this.is_verified = _data["is_verified"];
        }
    }

    static fromJS(data: any): UserOut {
        data = typeof data === 'object' ? data : {};
        let result = new UserOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["role"] = this.role;
        data["is_active"] = this.is_active;
        data["is_verified"] = this.is_verified;
        return data;
    }
}

export interface IUserOut {
    id: string;
    email: string;
    firstname?: string | undefined;
    lastname?: string | undefined;
    role?: UserRole;
    is_active: boolean;
    is_verified: boolean;
}

export class UserReadDTO implements IUserReadDTO {
    email!: string;
    firstname?: string | undefined;
    lastname?: string | undefined;
    role?: UserRole;
    is_active?: boolean | undefined;
    is_verified?: boolean | undefined;
    created_at?: string | undefined;
    updated_at?: string | undefined;
    id?: string;

    constructor(data?: IUserReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = UserRole.BaseUser;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.role = _data["role"] !== undefined ? _data["role"] : UserRole.BaseUser;
            this.is_active = _data["is_active"];
            this.is_verified = _data["is_verified"];
            this.created_at = _data["created_at"];
            this.updated_at = _data["updated_at"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["role"] = this.role;
        data["is_active"] = this.is_active;
        data["is_verified"] = this.is_verified;
        data["created_at"] = this.created_at;
        data["updated_at"] = this.updated_at;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserReadDTO {
    email: string;
    firstname?: string | undefined;
    lastname?: string | undefined;
    role?: UserRole;
    is_active?: boolean | undefined;
    is_verified?: boolean | undefined;
    created_at?: string | undefined;
    updated_at?: string | undefined;
    id?: string;
}

/** Ruoli utente disponibili nel sistema */
export enum UserRole {
    BaseUser = "baseUser",
    Mantainer = "mantainer",
    Admin = "admin",
}

export class ValidationError implements IValidationError {
    loc!: string[];
    msg!: string;
    type!: string;

    [key: string]: any;

    constructor(data?: IValidationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.loc = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["loc"])) {
                this.loc = [] as any;
                for (let item of _data["loc"])
                    this.loc!.push(item);
            }
            this.msg = _data["msg"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ValidationError {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.loc)) {
            data["loc"] = [];
            for (let item of this.loc)
                data["loc"].push(item);
        }
        data["msg"] = this.msg;
        data["type"] = this.type;
        return data;
    }
}

export interface IValidationError {
    loc: string[];
    msg: string;
    type: string;

    [key: string]: any;
}

export class VariableRelation implements IVariableRelation {
    variable_id!: string;
    code!: string;

    [key: string]: any;

    constructor(data?: IVariableRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.variable_id = _data["variable_id"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): VariableRelation {
        data = typeof data === 'object' ? data : {};
        let result = new VariableRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["variable_id"] = this.variable_id;
        data["code"] = this.code;
        return data;
    }
}

export interface IVariableRelation {
    variable_id: string;
    code: string;

    [key: string]: any;
}

export class VariablesDataBatchItem implements IVariablesDataBatchItem {
    id?: string | undefined;
    variable_id?: string | undefined;
    month!: string;
    value?: number | undefined;

    constructor(data?: IVariablesDataBatchItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.variable_id = _data["variable_id"];
            this.month = _data["month"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): VariablesDataBatchItem {
        data = typeof data === 'object' ? data : {};
        let result = new VariablesDataBatchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["variable_id"] = this.variable_id;
        data["month"] = this.month;
        data["value"] = this.value;
        return data;
    }
}

export interface IVariablesDataBatchItem {
    id?: string | undefined;
    variable_id?: string | undefined;
    month: string;
    value?: number | undefined;
}

export class VariablesDataCreateDTO implements IVariablesDataCreateDTO {
    variable_id?: string | undefined;
    month!: string;
    value?: number | undefined;

    constructor(data?: IVariablesDataCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.variable_id = _data["variable_id"];
            this.month = _data["month"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): VariablesDataCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VariablesDataCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variable_id"] = this.variable_id;
        data["month"] = this.month;
        data["value"] = this.value;
        return data;
    }
}

export interface IVariablesDataCreateDTO {
    variable_id?: string | undefined;
    month: string;
    value?: number | undefined;
}

export class VariablesDataReadDTO implements IVariablesDataReadDTO {
    variable_id?: string | undefined;
    month!: string;
    value?: number | undefined;
    id?: string;

    constructor(data?: IVariablesDataReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.variable_id = _data["variable_id"];
            this.month = _data["month"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VariablesDataReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VariablesDataReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variable_id"] = this.variable_id;
        data["month"] = this.month;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface IVariablesDataReadDTO {
    variable_id?: string | undefined;
    month: string;
    value?: number | undefined;
    id?: string;
}

export class VectorReferencePeriodsCreateDTO implements IVectorReferencePeriodsCreateDTO {
    vector_id?: string | undefined;
    start_month!: number;
    end_month!: number;
    unit_of_measurement?: string | undefined;
    quantity?: number | undefined;
    taxable_amount?: number | undefined;
    unit_cost?: number | undefined;

    constructor(data?: IVectorReferencePeriodsCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vector_id = _data["vector_id"];
            this.start_month = _data["start_month"];
            this.end_month = _data["end_month"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.quantity = _data["quantity"];
            this.taxable_amount = _data["taxable_amount"];
            this.unit_cost = _data["unit_cost"];
        }
    }

    static fromJS(data: any): VectorReferencePeriodsCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VectorReferencePeriodsCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vector_id"] = this.vector_id;
        data["start_month"] = this.start_month;
        data["end_month"] = this.end_month;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["quantity"] = this.quantity;
        data["taxable_amount"] = this.taxable_amount;
        data["unit_cost"] = this.unit_cost;
        return data;
    }
}

export interface IVectorReferencePeriodsCreateDTO {
    vector_id?: string | undefined;
    start_month: number;
    end_month: number;
    unit_of_measurement?: string | undefined;
    quantity?: number | undefined;
    taxable_amount?: number | undefined;
    unit_cost?: number | undefined;
}

export class VectorReferencePeriodsReadDTO implements IVectorReferencePeriodsReadDTO {
    vector_id?: string | undefined;
    start_month!: number;
    end_month!: number;
    unit_of_measurement?: string | undefined;
    quantity?: number | undefined;
    taxable_amount?: number | undefined;
    unit_cost?: number | undefined;
    id?: string;

    constructor(data?: IVectorReferencePeriodsReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vector_id = _data["vector_id"];
            this.start_month = _data["start_month"];
            this.end_month = _data["end_month"];
            this.unit_of_measurement = _data["unit_of_measurement"];
            this.quantity = _data["quantity"];
            this.taxable_amount = _data["taxable_amount"];
            this.unit_cost = _data["unit_cost"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VectorReferencePeriodsReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VectorReferencePeriodsReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vector_id"] = this.vector_id;
        data["start_month"] = this.start_month;
        data["end_month"] = this.end_month;
        data["unit_of_measurement"] = this.unit_of_measurement;
        data["quantity"] = this.quantity;
        data["taxable_amount"] = this.taxable_amount;
        data["unit_cost"] = this.unit_cost;
        data["id"] = this.id;
        return data;
    }
}

export interface IVectorReferencePeriodsReadDTO {
    vector_id?: string | undefined;
    start_month: number;
    end_month: number;
    unit_of_measurement?: string | undefined;
    quantity?: number | undefined;
    taxable_amount?: number | undefined;
    unit_cost?: number | undefined;
    id?: string;
}

export class WeeklyProfileResponse implements IWeeklyProfileResponse {
    series!: WeeklySeriesDTO[];

    constructor(data?: IWeeklyProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.series = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(WeeklySeriesDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WeeklyProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWeeklyProfileResponse {
    series: WeeklySeriesDTO[];
}

export class WeeklySeriesDTO implements IWeeklySeriesDTO {
    weekday!: string;
    points!: number[];

    constructor(data?: IWeeklySeriesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.points = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekday = _data["weekday"];
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(item);
            }
        }
    }

    static fromJS(data: any): WeeklySeriesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklySeriesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekday"] = this.weekday;
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item);
        }
        return data;
    }
}

export interface IWeeklySeriesDTO {
    weekday: string;
    points: number[];
}

export enum FeedbackRequestSignal {
    _1 = 1,
    __1 = -1,
}

export enum RecommenderRequestFilter {
    Interventi = "interventi",
    Indicatori = "indicatori",
    Uses = "uses",
}

export enum SearchRequestFilter {
    Interventi = "interventi",
    Indicatori = "indicatori",
    Uses = "uses",
}

export enum SearchResultItemTipo {
    Internal = "internal",
    External = "external",
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

export type FileParameter = { data: Blob; fileName: string };
export type FileResponse = Blob;